// EN
const locale = {
    MENU: {
        DASHBOARD: "Dashboard",
        CREATE_REQUEST_BUTTON: "Create application",
        SEARCH_BUTTON: "Advanced search",
        RESPONSE_TEMPLATES: "Response templates",
        TRANSLATIONS: "Translations",
        TRANSLATIONS_GLOSSARY: "Translation glossary",
        TRANSLATIONS_DASHBOARD: "Translations dashboard",
        TAX_CATEGORY: "Fee categories",
        COMPLAIN_TYPE: "Complaint types",
        ORGANIZATION: "Manage organisations",
        MY_ORGANIZATION: "Manage organisation",
        ACCOUNTS: "Secondary accounts",
        BENEFICIARIES: "Beneficiaries",
        MY_APPLICATIONS: "My applications",
        DRAFT: "Draft",
        SUBMITTED: "Submitted",
        SIGN_PENDING: "To sign",
        TO_CLARIFY: "To clarify",
        FINALIZED: "Completed",
        STAFF_APPLICATIONS: "Applications register",
        NOTIFICATIONS: "Messages and notifications",
        RESPONSIBILITIES: "Responsibilities catalogue",
        MY_COMPLAINS: "My complaints",
        STAFF_COMPLAINS: "Complaints register",
        PAYMENTS: "Payments register",
        DOCUMENTS: "Issued documents",
        EXTERNAL_APPS: "Apps",
        ATLAS: "Territorial Atlas",
        EFACTURA: "e-Factura",
        ARCHIVE: "Archive",
        HELP: "Help",
        MANUAL: "User manual",
        FAQ: "FAQ",
        ADMINISTRATOR: {
            HEADER: "Administrator",
            MANAGE: "Management",
            FUNCTIONARY: "Staff",
        },
        DOCUMENT_TEMPLATE: "Document templates",
        FORMS: "Form interfaces",
        APPLICATION_TYPE: "Application types",
        PROCESS_MANAGEMENT: "Process management",
        PERMISSIONS: "Permissions",
        METADATA_MAPPING: "Metadata mapping",
        GU: "Ghișeul Unic",
        STAFF_OWN_APPLICATIONS: "To sign (documents)",
        STAFF_OWN_CLARIFICATIONS: "To sign (clarifications)",
        STAFF_REVIEW_APPLICATIONS: "To review",
        DECISION_TARGET: "Decision locations",
        DECISION_PURPOSE: "Decision purposes",
        DOCUMENT_SERIES_TYPE: "Series types",
        REGISTERS_TYPE: "Registers typologies",
        REGISTERS: "Registers",
        SPECIAL_REGISTERS: "Special registers",
        PAYMENT_REGISTRY: "Payments register",
        REAL_ESTATE_REGISTER: "Land register data",
        ISSUED_DOCUMENT: "Issued documents",
        ISSUED_DOCUMENT_STAFF: "Issued documents register",
        CONTROLS: "Inspection register",
        ORGANISATION_CONFIG: "Organisation configuration",
        SYSTEM_CONFIG: "System configuration",
        TRANSLATIONS_SECTION: "Translations",
        INTERNAL_DOCUMENTS: "Documents register",
        DOCUMENT_SERIES_ALLOCATION: "Reservations register",
        USEFUL_LINKS: "Useful links",
        APPLICATIONS_DETAILS: "App details",
        CONTROL_TYPE: "Inspection types",
        STAFF_SIGN_INTERNAL_DOCUMENTS: "To sign",
        STAFF_TO_REVIEW_DOCUMENTS: "To review",
        DASHBOARD_REPORTS: "Reports",
        PURPOSE_LIST: "Decision purposes",
        TARGET_LIST: "Decision locations",
        SYSTEM_SETTINGS: "System settings",
        INBOX: "Inbox",
        IN_WORK: "In progress",
        NEW: "New",
        COMPLETED: "Completed",
        WITH_ERRORS: "Errors",
        REGISTRY: "Registry",
        GENERAL_REGISTRY: "General registry",
        REGISTRY_ADD: "Add",
    },
    GENERAL: {
        YES: "Yes",
        NO: "No",
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Back",
        STATUS: "Status",
        ACTIVE: "Active",
        INACTIVE: "Inactive",
        CHECK: "Check",
        LOADING: "Loading...",
        EXTEND: "Expand",
        NOT_AVAILABLE: "Not available",
        PREVIEW: "Preview",
        GIS_INTERSECTIONS: "GIS intersections",
        GIS_INTERSECTIONS_METADATAS: "GIS intersection metadata",
        GIS_INTERSECTIONS_RESULTS: "GIS intersection results",
        CONTINUE_NAVIGATION_BUTTON: "Continue without saving",
        LINE_SPACING: {
            SINGLE: "Single",
            DOUBLE: "Double",
        },
        BUTTON: {
            ADD: "Add",
            CANCEL: "Cancel",
            SAVE: "Save",
            UPDATE: "Edit",
            CONFIRM: "Confirm",
            ERASE: "Delete",
            MORE_FILTERS: "More filters",
            OK: "OK",
            SEND_CODE: "Send code",
            SEND: "Send",
            SENDING: "Sending...",
            CONTINUE: "Continue",
            PUBLISH: "Publish",
            UPLOAD_FILE: "Choose file",
            COMPLETE: "Fill in",
            UPLOAD_MAX_FILE_SIZE: "Upload documents (max {0} MB/doc)",
            DOWNLOAD: "Download",
            EXTRACT: "Extract selection",
            SEARCH: "Search",
            DIGITALIZE: "Digitise application",
            VIEW: "View",
            VIEW_DOC: "View document",
            DELETE_FILES: "Delete documents ",
            GO_TO_APPLICATION: "Go to application",
            REFRESH: "Refresh",
        },
        ACTIONS: {
            EDIT: "Edit",
            DELETE: "Delete",
            DELETE_MESSAGE: "Are you sure you want to delete this?",
            VIEW: "View",
            DOWNLOAD: "Download",
            DOWNLOAD_ALL: "Download all",
            SIGN: "Sign",
            VIEW_ORIGINAL: "View document",
            VIEW_STATUS: "View signing status",
            DO_UPDATE: "Update",
            GO_TO_LINK: "Go to the institution's page",
            COPY: "Copy",
            SELECT_ALL: "Select all",
            UN_SELECT_ALL: "Deselect all",
            REMOVE_SELECTION: "Remove selection",
            SEND_EMAIL: "Send email",
            VIEW_QR: "Print registration receipt",
            CLONE: "Clone",
            FILTER_PROJECT_IDS: "Filter by Project ID",
            LOGS: "History",
        },
        DATEPICKER: {
            FROM_DATE: "From",
            TO_DATE: "To",
            SELECT_DATE: "Select",
            INVALID_DATE: "The entered date is invalid",
            HELP: "Use the cursor keys to navigate the calendar dates",
        },
        PAGINATION: "Showing results {start} to {end}",
        CREATED_SUCCESS: "Saved successfully.",
        UPDATED_SUCCESS: "Saved successfully.",
        PUBLISHED_SUCCESS: "Published successfully.",
        PUBLISHED_FAILED: "An error occurred while publishing the layer, please try again",
        REMOVE_SUCCESS: "Deleted successfully.",
        SELECT_PLACEHOLDER: "Choose",
        EXPIRED_SESSION: "Session expired",
        TABLE: {
            ACTIONS: "Actions",
            COLUMN_SELECTOR_TITLE: "Select visible columns",
            SELECT_ALL_COLUMNS: "Select all",
            FILTER_SELECTOR_TITLE: "Select visible filters",
            SELECT_ALL_FILTERS: "Select all",
            APPLY: "Apply",
            RESET_WIDTHS: "Reset widths",
            CANCEL: "Cancel",
            RECOMMENDED_SELECTION_TITLE: "Large selection",
            RECOMMENDED_SELECTION_TEXT: "You have selected {selected} items. Selecting more than {recommended} items may reduce performance. You can select up to {max} items.",
            MAX_SELECTION_TITLE: "Maximum selection reached",
            MAX_SELECTION_TEXT: "You can select at most {max} items. The first {max} configured items were selected.",
        },
        TABLE_ACTIONS_COLUMN: "Actions",
        TABLE_EMPTY_TEXT: "There are no records to show",
        DAYS: "days | day | days",
        AUTOCOMPLETE_NO_OPTIONS: "No matching options",
        AUTOCOMPLETE_LOAD_MORE: "Load more options...",
        DUAL_LIST_BOX: {
            SEARCH_PLACEHOLDER: "Search",
            SEARCH_RESULTS: "No results found.",
            CLEAR_SEARCH: "Clear search",
        },
        CLICK_HERE: "click here",
        CITIZEN: "Citizen",
        STAFF: "Staff",
        SIGN: "Sign",
        SYSTEM: "System",
        ORGANISATION: "Organisation",
        CITIZEN_CLARIFICATION: "Citizen clarifications",
        STAFF_CLARIFICATION: "Staff clarifications",
        ERROR_PAGE: {
            TITLE: "Oops...",
            TEXT: "Something went wrong...",
            SUB_TEXT: "unexpected error",
            NOT_FOUND_TITLE: "Page not found",
            NOT_FOUND_TEXT: "The resource you are looking for does not exist or is no longer available.",
            BACK_HOME: "Back to home",
        },
        SELECT_LOADING: "Loading...",
        CURRENCY_LABEL: "RON",
        RECOMANDED_SCREEN: "This application is not optimised for mobile phones or tablets. For the best browsing and functional experience, we recommend using the web version of the application.",
        OR: "or",
        MAINTENANCE: "The system is currently under maintenance and some features may not work correctly.",
        SEARCH_OPTIONS: "Search {0}",
        NO_RESULTS: "No results for ",
        COPY_PREFIX: "Annex",
        MISSING_ADDRESS: "Address not available",
        ADD_ASSIGNMENT: "Add assignment",
        REMOVE_ASSIGNMENT: "Delete assignment",
        NO_OPTIONS_AVAILABLE: "No options available",
        CITIZEN_MAINTENANCE_TITLE: "The system is under maintenance",
        MAINTENANCE_MESSAGE: "The platform is temporarily unavailable due to maintenance work. Please come back later.",
        LOGO_ALT: "Logo",
        MAP: {
            EXPORT_MAP: "Export map",
            DOWNLOAD_PDF: "Download as PDF",
            DOWNLOAD_PNG: "Download as PNG",
            MEASURE_DISTANCE: "Measure the distance between two or more points",
            MEASURE_AREA: "Measure area",
            CLEAR_MEASUREMENTS: "Clear measurements",
            EXPORT_PDF_ERROR: "The map could not be exported as PDF",
            EXPORT_PNG_ERROR: "The map could not be exported as PNG",
        },
        DOCUMENT_EDITOR: {
            TOTAL_PAGES: "Total pages",
            TOTAL_PAGES_TOOLTIP: "Inserts the total number of pages.",
            DEFAULT_AUTHOR: "User",
            PASTE: "Paste",
            TABLE_HEADER_GROUP: "Table header",
            REPEAT_HEADER_ROWS: "Repeat header rows",
            REPEAT_HEADER_ROWS_TOOLTIP: "Repeats the table header row at the top of each page.",
        },
        UNKNOWN_USER: "Unknown user",
    },
    ALERT_MODAL: {
        ERROR: "Error",
        WARNING: "Warning",
        SUCCESS: "Success",
        INFO: "Info",
    },
    AUTH: {
        GENERAL: {
            OR: "or",
            CANCEL_BUTTON: "Cancel",
            BACK_BUTTON: "Back",
            PRIVACY: "Privacy policy",
            LEGAL: "Terms and conditions",
        },
        LOGIN: {
            TITLE: "Welcome!",
            DESC: "Enter your email and password to access the platform",
            NO_ACCOUNT: "Don't have an account? Create one now!",
            BUTTON: "Log in",
            FORGOT_PASSWORD_LABEL: "Forgot your password?",
            GOOGLE_BUTTON: "Log in with Google",
            FACEBOOK_BUTTON: "Log in with Facebook",
            ROEID_BUTTON: "Log in with ROeID",
            HELP_TEXT: "* The application allows creating two types of accounts: a personal account for natural persons and legal entities, and a professional account for design/planning offices.",
            ROEID_INFO_TEXT_FIRST: "We recommend using the ",
            ROEID_INFO_TEXT_SECOND: " application to log in to the Ghișeul Unic system.",
            ROEID_INFO_DESCRIPTION: "{roeid} is a mobile application provided by the {adr}, an application notified to the {ec} as the official electronic identification method in Romania.",
            ROEID_INFO_ADR_LINK_TEXT: "Authority for the Digitalisation of Romania",
            ROEID_INFO_EC_LINK_TEXT: "European Commission",
        },
        FORGOT: {
            TITLE: "Reset password?",
            DESC: "Enter the email address associated with your account.",
            BUTTON: "Send email",
            SUCCESS: "Your account has been successfully reset.",
        },
        RESET: {
            TITLE: "Reset password?",
            DESC: "Enter your new password",
            BUTTON: "Change password",
        },
        CHANGE_PASSWORD: {
            TITLE: "Change password",
            DESC: "Enter your new password",
            BUTTON: "Change password",
        },
        SET: {
            TITLE: "Set password",
            DESC: "Enter a password",
            BUTTON: "Set password",
        },
        REGISTER: {
            TITLE: "Welcome!",
            DESC: "The application allows creating two types of accounts: a personal account for natural persons/legal entities and administrative-territorial units (UAT), and a professional account for design/planning offices.",
            HAS_ACCOUNT: "Already have an account? Log in",
            GOOGLE_BUTTON: "Create account with Google",
            FACEBOOK_BUTTON: "Create account with Facebook",
            BUTTON: "Create account",
            ACCEPT_TERMS: "I accept the {0} and the {1}.",
            PRIVACY: "privacy policy",
            TOS: "terms and conditions",
            PASSWORD_HELP: "Minimum 8 characters, one uppercase letter, one lowercase letter, one digit and one special character",
            PROFESSIONAL_TITLE: "Create new professional account",
            PROFESSIONAL_DESC: "The professional account is intended for legal entities – offices / companies / sole traders (PFA) / individual architecture offices (BIA) – operating in the field of design (architecture, urbanism, engineering, etc.) and is meant for managing/submitting applications for one or more beneficiaries – it allows sub-accounts",
            PERSONAL_TITLE: "Create new personal account",
            PERSONAL_DESC: "The personal account is intended for natural persons / legal entities and public administrations and is meant for submitting applications for/on behalf of natural persons / legal entities / town halls",
            BUTTON_PERSONAL: "Create personal account",
            BUTTON_PROFESSIONAL: "Create professional account",
            ROEID_BUTTON: "Log in with ROeID",
        },
        INPUT: {
            EMAIL: "Email",
            PASSWORD: "Password",
            CONFIRM_PASSWORD: "Confirm password",
            NEW_PASSWORD: "New password",
            OLD_PASSWORD: "Old password",
            PHONE: "Phone number",
            VALIDATION_CODE_PLACEHOLDER: "Verification code",
        },
        VERIFY_EMAIL: {
            TITLE: "Email confirmation",
            MESSAGE_SENT: "An activation link has been sent to the email address {0}. Check your email and, after confirming, continue the account validation process. Sometimes the activation link may end up in spam, so please check your spam folder as well.",
            RESEND_CONFIRMATION_MESSAGE: "Didn't receive the confirmation email? {0}.",
            RESEND_LINK: "Resend link",
            TOAST_MESSAGE: "Confirmation email sent successfully",
        },
        VERIFY_SMS: {
            TITLE: "Account validation",
            MESSAGE: "For security reasons, Ghișeul Unic needs to verify your account via SMS. Enter your phone number and follow the validation steps.",
            MESSAGE_SENT: "An SMS has been sent to the phone number {0}. Enter the code you received and validate your account.",
            BUTTON_SUBMIT: "Send code",
            BUTTON_VALIDATE: "Validate account",
            INPUT_PLACEHOLDER: "Verification code",
            MESSAGE_NOT_RECEIVED: "Didn't receive the code? {0}",
            RESEND_LINK: "Resend message",
            CHANGED_VALIDATION_METHOD_LINK: "change validation method",
        },
        INVALID_LINK: {
            TITLE: "Invalid activation link",
            MESSAGE: "The activation link is invalid, has expired or has already been used. Please check your account or restart the registration process.",
            REGISTER_MESSAGE: "Go to the {0} page.",
            REGISTER_LINK: "registration",
        },
        VALIDATION: {
            INVALID: "{{name}} is not valid",
            REQUIRED: "This field is required",
            EMAIL: "The email address is not valid",
            INVALID_EMAIL: "The email address is not valid.",
            MIN_LENGTH: "The minimum length of {{name}} is {{min}}",
            AGREEMENT_REQUIRED: "Accepting the terms and conditions is required",
            NOT_FOUND: "The requested {{name}} is not found",
            INVALID_LOGIN: "Incorrect login details. Please try again.",
            REQUIRED_FIELD: "This field is required",
            CONFIRM_PASSWORD: "Passwords do not match",
            MIN_LENGTH_FIELD: "The field must have at least {min} characters",
            MAX_LENGTH_FIELD: "The field must have at most {max} characters",
            INVALID_FIELD: "The field is not valid",
            STRONG_PASSWORD: "Invalid password",
            INVALID_PHONE: "The phone number is not valid",
            NUMERIC_FIELD: "This field can only contain numeric values",
            PHONE_FIELD: "This field can only contain numeric values",
            INVALID_URC: "Invalid CUI",
            INVALID_PNC: "Invalid CNP",
            POSTAL_CODE_MAX_LENGTH_FIELD: "The postal code must contain 6 digits",
            SMS_CODE_LENGTH: "The verification code must contain 6 digits",
            IBAN: "Invalid IBAN code.",
            INTEGER: "The field value is not a valid integer",
            INVALID_DATE: "Invalid date",
            ALPHABETICAL: "The field value must contain only letters and spaces",
            LETTERS_ONLY: "This field must contain only letters",
            NO_UPPER: "This field can only contain lowercase letters",
            ALPHABETICAL_SPECIAL_CHARS: "The field value must contain only letters, spaces, apostrophes and -",
            URL: "The entered link is not valid",
            FULL_URL: "The entered link is not valid. The \"https\" prefix is required.",
            ARCGIS_FEATURE_SERVICE_URL: "The entered link is not a valid ArcGIS Feature Service",
            INVALID_EMAIL_DOMAIN: "Please use a different email address from another domain",
            NO_SPACE: "This field cannot contain spaces",
            "АT_LEAST_ONE_COLUMN": "Select at least one column",
        },
    },
    LAYOUT: {
        HEADER: {
            SEARCH_PLACEHOLDER: "Search application, approval or other document",
        },
    },
    LOGOUT: {
        CONFIRMATION_MESSAGE: "Are you sure you want to end your session?",
    },
    RESET_PASSWORD: {
        CONFIRMATION_MESSAGE: "Are you sure you want to reset your password?",
        SUCCESSFULLY_SENT_MESSAGE: "A password reset link has been sent to the email address you provided.",
        SUCCESSFULLY_MESSAGE: "Your password has been changed successfully",
    },
    UNLINK_ROEID: {
        CONFIRMATION_MESSAGE: "Are you sure you want to disable the ROeID connection? This action will remove the data retrieved from your ROeID account and disable the features associated with the ROeID account.",
        SUCCESSFULLY_MESSAGE: "The ROeID connection has been disabled successfully. You will receive an email notification to reset your password.",
    },
    LINK_ROEID: {
        INFORMATION_MESSAGE: "To link your account with ROeID, you need to log out and then log in using the \"Log in with ROeID\" option. After linking, the data from your ROeID account can be retrieved and updated in your profile. If you do not have a ROeID account, we recommend downloading the ROeID app on your mobile phone and following the steps to create a ROeID account, then come back to link the accounts.",
    },
    HOME: {
        WELCOME_TEXT: "Welcome to the Ghișeul Unic application.",
    },
    PROFILE: {
        HEADER: "My account",
        HEADER_CITIZEN: "My personal account",
        HEADER_LEGAL: "My professional account",
        LOGOUT_BUTTON_TEXT: "Log out",
        UPDATE_BUTTON: "Update data",
        ROEID_BUTTON: "Retrieve data from ROeID account",
        DEACTIVATE_ROEID_BUTTON: "Disable ROeID connection",
        VIDEO_ENROLL_BUTTON: "Video enrolment",
        SECTIONS: {
            ACCOUNT_DETAILS: {
                HEADER: "Account details",
            },
            PERSONAL_DETAILS: {
                HEADER: "Personal details",
            },
            PERSONAL_DATAS: {
                HEADER: "Personal data",
            },
            COMPANY_DATAS: {
                HEADER: "Company data",
            },
            RESPONSIBILITIES: {
                HEADER: "Responsibilities",
            },
            IDENTITY_CARD: {
                HEADER: "Identity card data",
            },
            LANGUAGE: {
                SAVE_FAILED: "The language could not be saved to your profile. Please try again.",
                CHOICE: {
                    LOGIN_TITLE: "Which language would you like to use?",
                    LOGIN_TEXT: "The language saved in your account is different from the one you logged in with. Your choice will be used for:",
                    SWITCH_TITLE: "Change the language?",
                    SWITCH_TEXT: "The new language will be used for:",
                    APPLIES_TO: {
                        PLATFORM: "Platform",
                        EMAIL: "Email",
                        SMS: "SMS",
                    },
                    TAGS: {
                        ACCOUNT: "Your account",
                        LOGIN_SCREEN: "Log-in screen",
                        CURRENT: "Current language",
                        NEW: "New language",
                    },
                    CAPTION_ACCOUNT: "Keep the language saved in your account",
                    CAPTION_LOGIN_SCREEN: "Switch to the language you logged in with",
                    CAPTION_KEEP: "Keep English",
                    CAPTION_SWITCH: "Switch to English",
                    DESCRIPTION_USE: "The platform and notifications in English",
                    DESCRIPTION_KEEP: "The platform and your notifications stay in English.",
                    DESCRIPTION_SWITCH: "The whole platform and all your notifications will be in English.",
                    FOOTNOTE: "You can change it at any time from the flag in the top bar.",
                    NOTICE: "The platform and your notifications are now in English.",
                },
            },
        },
        OPTIONS: {
            MY_PROFILE: {
                NAME: "My profile",
                DESCRIPTION: "View profile details",
            },
            RESET_PASSWORD: {
                NAME: "Reset password",
                DESCRIPTION: "Access the reset form",
            },
            NOTIFICATIONS_MANAGEMENT: {
                NAME: "Notification management",
                DESCRIPTION: "Manage the type and frequency of notifications",
            },
            UNLINK_ROEID: {
                NAME: "Disable ROeID",
                DESCRIPTION: "Disable ROeID connection",
            },
            LINK_ROEID: {
                NAME: "Connect with ROeID",
                DESCRIPTION: "Link your account with ROeID to retrieve the data from your ROeID account.",
            },
            PCUEL: {
                NAME: "PCUEL",
                DESCRIPTION: "Last synchronisation {0}",
                BUTTON: "Synchronise",
            },
        },
        FIELDS: {
            PERSONAL_NUMERIC_CODE: "CNP",
            LAST_NAME: "Last name",
            FIRST_NAME: "First name",
            COUNTY: "County",
            LOCALITY: "Municipality/Town/Commune",
            VILLAGE: "Locality",
            SECTOR: "Sector",
            STREET: "Street",
            POSTAL_CODE: "Postal code",
            STREET_NUMBER: "Number",
            STAIRCASE: "Staircase",
            BLOCK: "Block",
            FLOOR: "Floor",
            APARTMENT: "Apartment",
            EMAIL: "Email",
            PHONE: "Phone",
            PASSPORT_NUMBER: "Passport/Identity card",
            COUNTRY: "Country",
            CITY: "City",
            ADDRESS: "Address",
            UNIQUE_REGISTRATION_CODE: "CIF or CUI",
            REGISTRATION_NUMBER: "Trade Register registration number",
            COMPANY_NAME: "Entity name",
            IBAN: "IBAN account",
            BANK: "Bank",
            LICENSE: "Architect – TNA number",
            STATUS: "Status",
            IDENTIFICATION_NUMBER: "Staff ID number",
            ORGANISATION: "Institution",
            FUNCTIONS: "Position",
            DEPARTMENTS: "Department",
            USER_TYPE_NAME: "User type",
            ID_CARD_SERIAL: "ID card series",
            ID_CARD_NUMBER: "ID card number",
            ID_CARD_ISSUED_DATE: "Issue date",
            ID_CARD_EXPIRATION_DATE: "Expiry date",
            ID_CARD_ISSUER: "Issued by",
        },
        PLACEHOLDERS: {
            COUNTY: "County",
            LOCALITY: "Locality",
            VILLAGE: "Village",
            COUNTRY: "Country",
            STATUS: "Status",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
        },
        MESSAGES: {
            ID_CARD_EXPIRED: "The identity card has expired!",
            STAFF_ENROLLMENT_PROCESSING_TITLE: "Video enrolment in progress...",
            STAFF_ENROLLMENT_SUCCESS_TITLE: "The staff member has been enrolled successfully",
            STAFF_ENROLLMENT_REDIRECT_TEXT: "You will be redirected to your profile in a few seconds. If you are not redirected automatically, please {0}",
            STAFF_ENROLLMENT_FAILED_TITLE: "An error occurred during the enrolment process, please try again.",
            ROEID_UPDATED_SUCCESSFULLY: "The ROeID data has been retrieved successfully. To turn your account into a qualified account, please press the Update data button. If you have a professional account, fill in the remaining required fields before updating",
        },
        ENROLLED_BADGE_LABEL: "Enrolled",
        ROEID_BADGE_LABEL: "Qualified",
        DEACTIVATE_PCUEL_BUTTON: "Disable PCUEL",
    },
    SET_PROFILE_DATA: {
        UPDATE_PROFILE_MODAL: {
            HEADER: "Important data update!",
            TEXT: "Following the development of new features in the application, we kindly ask you to update your profile data. Thank you!",
            GO_TO_PROFILE: "Go to My profile",
        },
        UPDATE_PROFILE_MODAL_ROEID: {
            TEXT: "The data in your ROeID account has been updated. To update it in your profile, please retrieve and save the data.",
        },
        WELCOME_MODAL: {
            BRAND: {
                NAME: "Ghișeul Unic",
                ORGANISATION: "Cluj County Council",
            },
            HEADER: {
                TOP_P: "Welcome to the Ghișeul Unic platform!",
                BOTTOM_P: "Fill in your profile data so that we can tailor the experience to your needs.",
                BOTTOM_P_PERSON: "Set up personal account",
                BOTTOM_P_LEGAL: "Set up professional account",
            },
            OPTIONS: {
                PERSON: "Set up personal profile",
                LEGAL: "Set up professional profile",
            },
        },
        CITIZEN: {
            ROMANIAN: "Romanian citizen",
            FOREIGNER: "Foreign citizen",
        },
        FORM_BUTTONS: {
            CHANGE_TYPE: "Change profile type",
            SAVE: "Save data",
        },
        LEGAL_FORM: {
            COMPANY: "Company details",
            LEGAL_REPRESENTATIVE: "Legal representative details",
        },
        PERSON: {
            PNC: "CNP",
            LAST_NAME: "Last name",
            FIRST_NAME: "First name",
            COUNTY: "County",
            LOCALITY: "Municipality/Town/Commune",
            VILLAGE: "Locality",
            SECTOR: "Sector",
            STREET: "Street",
            POSTAL_CODE: "Postal code",
            NUMBER: "Number",
            STAIRCASE: "Staircase",
            BLOCK: "Block",
            FLOOR: "Floor",
            APARTMENT: "Apartment",
            EMAIL: "Email",
            PHONE: "Phone",
        },
        FOREIGNER: {
            PNC: "Passport/Identity card",
            LAST_NAME: "Last name",
            FIRST_NAME: "First name",
            COUNTRY: "Country",
            CITY: "City",
            ADDRESS: "Address",
            EMAIL: "Email",
            PHONE: "Phone",
        },
        LEGAL: {
            URC: "CUI",
            COMPANY_NAME: "Name",
            COUNTY: "County",
            LOCALITY: "Locality",
            STREET: "Street",
            POSTAL_CODE: "Postal code",
            NUMBER: "Number",
            STAIRCASE: "Staircase",
            BLOCK: "Block",
            FLOOR: "Floor",
            APARTMENT: "Apartment",
            LAST_NAME: "Last name",
            FIRST_NAME: "First name",
            PNC: "CNP",
            LICENSE: "Architect – TNA number",
            EMAIL: "Email",
            PHONE: "Phone",
        },
        ERRORS: {
            LOCALITIES: "Error generating the list of localities!",
            VILLAGES: "Error generating the list of villages!",
            UPDATE: "Error updating the profile information!",
            CREATE: "Error creating the user profile!",
        },
        SUCCESS_MODAL: {
            TITLE: "Welcome, {0}!",
            TEXT: "You can now upload and send the documents required for the authorisation process and manage your documents.",
            CONFIRM_BUTTON: "Let's get started!",
        },
        UPDATED_MESSAGE: "Profile updated successfully!",
        GDPR: {
            AGREE_CONDITION: "I agree to the processing of my personal data",
            CONDITIONS: "Pursuant to Regulation (EU) No 2016/679 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation), and Law No 190/2018, Cluj County Council processes personal data while ensuring their security and confidentiality.”",
        },
    },
    NOTIFICATIONS: {
        BUTTON_TEXT: "Apply changes",
        HEADER: {
            TOP: "Notification management",
            COL_1: "Notification type",
            COL_2: "Email",
            COL_3: "SMS",
            COL_4: "In-app",
        },
        SECTION_TITLE: {
            ACCOUNT: "Account",
            APPLICATIONS: "Applications",
            DOCUMENTS: "Documents",
            ALERTS: "Alerts",
            OTHERS: "Other",
            COMPLAINS: "Complaints",
            COMMENTS: "Messages",
            INTERNAL_DOCUMENTS: "Internal documents",
            CONTROLS: "Inspections",
        },
        FREQUENCY: {
            DAILY: "Daily",
            WEEKLY: "Weekly",
            MONTHLY: "Monthly",
        },
        ITEMS: {
            ACCOUNT_DATA_CHANGED: "Account details are changed",
            ACCOUNT_TYPE_CHANGED: "Account type is changed",
            NEW_APPLICATION: "A new application is received",
            APPLICATION_CHANGED: "An application is modified",
            APPLICATION_STATUS_CHANGED: "The status of an application changes",
            APPLICATION_SENT: "An application is sent",
            DOCUMENT_CREATED: "A new document is issued",
            DOCUMENT_CANCELLED: "A document is cancelled",
            TAX_DEADLINE_EXPIRES: "A payment deadline expires",
            RESPONSE_DEADLINE_EXPIRES: "A response deadline expires",
            MESSAGE_SENT: "A message is sent.",
            NEW_COMPLAIN: "A new complaint is received",
            COMPLAIN_STATUS_CHANGED: "The status of a complaint changes",
            NEW_COMMENT: "A new message is received",
            OTHER_APPLICATION_RELATED_UPDATES: "Updates from the app are received",
            INTERNAL_DOCUMENT_STATUS_CHANGED: "The status of an internal document changes",
            CONTROLS_STATUS_CHANGED: "The status of an inspection changes",
            APPLICATION_SIGNED: "A signature is applied to the assigned documents",
            APPLICATION_TO_BE_SIGNED: "A document is received for signing",
        },
        ERRORS: {
            NOTIFICATIONS: "Error generating the notification list!",
            UPDATE: "Error updating the notification!",
        },
        SUCCESS: {
            UPDATE: "The notification was updated successfully.",
        },
        TEMPLATES: {
            TITLE: "Notification templates",
            TABLE: {
                ACTIONS: "Actions",
                EDIT: "Edit",
            },
            EDIT: {
                PAGE_TITLE: "Edit template",
                SUBJECT: "Subject",
                MESSAGE: "Message",
                COPY_HINT: "Click a placeholder to copy it",
                COPIED: "Copied",
                TITLE: "Title",
                SMS: "SMS",
                EMAIL: "Email",
                IN_APP: "In-app",
                ACCEPTED_PLACEHOLDERS: "Accepted placeholders",
                SAVE: "Save",
                MAX_CHARS: "Max: {chars} characters.",
                REMAINING_CHARS: "Remaining: {chars}",
            },
            FIELDS: {
                TITLE: "Name",
                TYPE: "Template code",
                CHANNEL: "Delivery channel",
            },
            PLACEHOLDERS: {
                TITLE: "Search by name",
                CHANNEL: "Delivery channel",
            },
            SECTIONS: {
                DETAILS: "Template details",
                CONTENT: "Message content",
            },
        },
    },
    NOTIFICATIONS_IN_APP: {
        TITLE: "Notifications",
        MESSAGE: {
            INPUT_CODE: "Entry code",
            BENEFICIARY: "Beneficiary",
        },
        LOCALE: {
            FUTURE: "in",
            PAST: "ago",
            SECOND: "a few seconds ago",
            SECONDS: "seconds ago",
            MINUTE: "a minute ago",
            MINUTES: "minutes ago",
            HOUR: "an hour ago",
            HOURS: "hours ago",
        },
        NOW: "Received",
    },
    BENEFICIARY: {
        BENEFICIARY_DETAILS: {
            HEADER: "Beneficiary details",
            ADD_BTN: "Add beneficiary",
            REMOVE_BTN: "Delete beneficiary",
            PERSON: {
                HEADER: "Person type",
                INDIVIDUAL: "Natural person",
                LEGAL: "Legal entity",
            },
            CITIZENSHIP: {
                HEADER: "Citizenship",
                ROMANIAN: "Romanian citizen",
                FOREIGNER: "Foreign citizen",
            },
            FOOTER_CHECKBOX: "The beneficiary is the contact person",
            FORM: {
                AUTHORIZATION_CODE: "TNA",
                SUBSIDIARY: "Branch",
            },
            ADDRESS: "Address",
            CONTACT: "Contact",
            PERSON_DETAILS_HEADER: "LEGALLY REPRESENTED BY",
            ID_DETAILS_HEADER: "IDENTITY DOCUMENT DETAILS",
            OFFICE_DETAILS_HEADER: "REGISTERED OFFICE DETAILS",
            ID_LEGAL_DETAILS_HEADER: "LEGAL REPRESENTATIVE'S IDENTITY DOCUMENT DETAILS",
            BANK_DETAILS_HEADER: "LEGAL ENTITY BANK DETAILS",
        },
        APPLICANT_DETAILS: {
            HEADER: "Applicant details",
            FOOTER_CHECKBOX: "The applicant is the contact person",
        },
        SINGLE: "Total {total} beneficiary",
        MULTIPLE: "Total {total} beneficiaries",
        LIST_HEADER: "Beneficiary list",
        MODAL: {
            ADD_HEADER: "Add beneficiary",
            EDIT_HEADER: "Edit beneficiary",
        },
        CARD: {
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Home address",
            CONTACT: "Contact",
            CITIZENSHIP: "Citizenship",
            ADDRESS_COUNTY: "County",
            ADDRESS_STREET: "St.",
            ADDRESS_NUMBER: "no.",
            ADDRESS_STAIRCASE: "staircase",
            ADDRESS_APARTMENT: "apt.",
        },
        SEARCH_DESCRIPTION: "Select the beneficiary or add a new one",
        SEARCH_PLACEHOLDER: "Search for the beneficiary by CNP/CUI or add a new one",
        SEARCH_PLACEHOLDER_ON_APPLICATION: "Search for the beneficiary",
        SEARCH_DESCRIPTION_ON_APPLICATION: "Select the beneficiary",
        ANAF_VALIDATION: "The ANAF validation system is unavailable. The beneficiary must be added manually and will be validated when edited or when added to an application",
        ANAF_ADDRESS_INFO: "ANAF info - county name: {county}, locality name: {locality}",
    },
    ERRORS: {
        DEFAULT_ERROR_MESSAGE: "An error occurred, please try again",
        AUTH_REQUIRED: "Authorisation required.",
        AUTH_INVALID: "Authentication failed.",
        AUTH_INVALID_ATTEMPTS_REMAINING: "Authentication failed. {0} attempts remaining.",
        REGISTRATION_EMAIL_ALREADY_EXISTS: "The email address already exists.",
        REGISTRATION_INVALID_PASSWORD: "Invalid password",
        REGISTRATION_INVALID: "Invalid registration.",
        FACEBOOK_EMAIL_NOT_RECEIVED: "Something went wrong, could not get your email address. Check your Facebook settings and try again!",
        PASSWORD_EXPIRED: "Your password has expired and must be changed.",
        AUTH_FAILED: "Authentication failed.",
        AUTH_FAILED_ATTEMPTS_REMAINING: "Authentication failed. {0} attempts remaining.",
        RESET_PASSWORD_ALREADY_USED: "The password must be different from the current one.",
        FORBIDDEN: "Sorry, you do not have the necessary permissions to continue.",
        TOKEN_INVALID: "Invalid token",
        DUPLICATE_FUNCTION_NAME: "The name of the added position already exists!",
        CATEGORY_NOT_EMPTY: "The category cannot be deleted!",
        NAME_NOT_UNIQUE: "The name is not unique.",
        ERROR_PAGE_MESSAGE: "OOPS! Something went wrong here",
        AUTH_ACCOUNT_NOT_FOUND: "The credentials entered are incorrect!",
        PARENT_MUST_BE_ADMIN_OF_LEGAL_ENTITY: "You do not have permission to add or edit an account!",
        USER_ALREADY_EXISTS: "This user already exists!",
        TAX_ALREADY_EXISTS: "This fee already exists!",
        VERIFICATION_SERVICE_UNAVAILABLE: "The code entered is not valid!",
        CANNOT_DELETE_ORGANISATION: "This organisation cannot be deleted because there are associated users",
        ORGANISATION_ALREADY_EXISTS: "This organisation already exists",
        DOCUMENT_SERIES_ALREADY_EXISTS: "This series already exists!",
        REGISTER_CONFIG_EXISTS: "A register with this name already exists.",
        REGISTER_TYPE_EXISTS: "A register type with this name already exists.",
        REGISTER_TYPE_CANNOT_BE_DELETED: "This register type cannot be deleted because there are documents associated with it.",
        PREFIXLESS_SERIES_ALREADY_EXISTS: "A document series without prefix already exists for this organisation!",
        DOCUMENT_SERIES_NOT_EXIST: "No series has been defined!",
        DOCUMENT_SERIES_NOT_ACTIVE: "The series is not active!",
        RESPONSIBILITY_ALREADY_EXISTS: "This responsibility already exists!",
        INDEX_CANNOT_BE_LOWER_THAN_CURRENT_VALUE: "The value of the index cannot be less than the current value!",
        CONFLICT: "Duplicate record",
        PAYMENT_ALREADY_PROCESSED: "The payment has already been processed!",
        PAYMENT_STATE_CHANGED: "The payment was changed in the meantime.",
        DUPLICATE_MANUAL_PAYMENT: "A payment with the same amount, method, date and document number is already added.",
        PAYMENT_DATE_IN_FUTURE: "The payment date cannot be in the future.",
        INVALID_MANUAL_PAYMENT: "The payment details are not valid.",
        PAYMENT_NOT_ALLOWED: "This payment cannot be changed.",
        PAYMENT_LOG_NOT_FOUND: "The payment was not found.",
        PAYMENTS_SERVICE_UNAVAILABLE: "The payments service is not answering. Try again in a few minutes.",
        PAYMENT_ACTION_FORBIDDEN: "You do not have permission for this action, or your session has ended. Reload the page and try again.",
        PAYMENT_RESULT_UNKNOWN: "The payments service did not answer. Check the payment in the list before trying again.",
        INVALID_PAYMENT_PROOF: "The proof of payment could not be verified. Remove the file and upload it again.",
        PAYMENT_PROOF_UNAVAILABLE: "The proof of payment cannot be verified right now, so nothing was saved. Try again in a few minutes.",
        AUTH_INVALID_CONFIRMATION_VALIDATIONS: "Password reset request expired!",
        CERTSIGN_CONFIRMING_SIGNING_FAILED: "The code entered is not valid!",
        ATLAS_NO_SEARCH_RESULT: "Address not found!",
        DECISION_TARGET_CANNOT_BE_DELETED: "This location cannot be deleted because it is associated with a decision",
        DECISION_PURPOSE_CANNOT_BE_DELETED: "This purpose cannot be deleted because it is associated with a decision",
        DECISION_PURPOSE_ALREADY_EXISTS: "This purpose already exists!",
        DECISION_TARGET_ALREADY_EXISTS: "This location already exists!",
        DOCUMENT_SERIES_TYPE_CANNOT_BE_DELETED: "This type cannot be deleted because it is associated with a series",
        DOCUMENT_SERIES_TYPE_ALREADY_EXISTS: "This type already exists!",
        DUPLICATE_COMPLAIN_TYPE_NAME: "The complaint type name entered already exists!",
        DUPLICATE_RESPONSE_TEMPLATE_NAME: "The template name entered already exists!",
        INVALID_EMAIL: "The email address is not valid",
        INVALID_CERTSIGN_ENROLLMENT: "An error occurred during the signing process, enrolment is missing.",
        REQUEST_ALREADY_CONFIRMED: "The application has already been signed",
        INVALID_TOKEN: "Sorry, an error occurred. Try again!",
        SOURCE_FILE_ID_MISSING_ERROR: "Sorry, the file upload failed. Try again!",
        UAT_ALREADY_ASSIGNED: "The selected UAT is assigned to another staff member!",
        ERROR_VALIDATING_LAYER_CREATION_REQUEST: "An error occurred, please try again",
        NOT_OK: "An error occurred, check that the documents are signed and try again.",
        ARCHIVE_CONTENT_INVALID_FILES_BY_NAME: "An error occurred, check the document package name and try again.",
        INVALID_FILE: "An error occurred, the document package extension must be .zip",
        AUTH_FAILED_ACCOUNT_LOCKED: "Authentication failed. The account is locked. Try again in {0} minutes",
        AUTH_DISABLED: "Authentication error, the account is locked or inactive.",
        URBANISM_REQULATION_ZONE_NOT_UNIQUE: "The zone name (per UAT and purpose) is not unique.",
        AUTH_FAILED_PASSWORD_EXPIRED: "Your password has expired and must be changed.",
        WORKFLOW_EXISTS: "A process with this name already exists",
        MISSING_SIGN_PLACEHOLDER: "An error occurred during the signing process, please try again.",
        INVALID_TARGET_FOR_SIGN_PLACEHOLDER: "An error occurred during the signing process, please try again.",
        MISMATCH_TARGET_FILES_AND_META: "An error occurred during the signing process, please try again.",
        CERTSIGN_SIGNING_ID_NOT_GENERATED: "An error occurred during the signing process, please try again.",
        PERMISSIONS_ARE_EQUAL_TO_CURRENT_RESPONSIBILITY: "The saved permissions are the same as the initial ones.",
        TOO_MANY_FILES_OR_FILE_SIZE_EXCEEDED: "The maximum number of files has been reached or the document exceeds the maximum allowed size.",
        CERTSIGN_INTERNAL_ERROR: "An error occurred during the signing process, please try again.",
        ERROR_INIT_SIGNING: "An error occurred while starting the signing process, please try again.",
        ERROR_DOCUMENT_GENERATION: "An error occurred, please try again later.",
        CANNOT_DELETE_FUNCTION_ASSOCIATED_USERS_EXIST: "An error occurred while deleting, the position has associated users.",
        CANNOT_DELETE_FUNCTION_ASSOCIATED_DEPARTMENTS_EXIST: "An error occurred while deleting, the position is assigned to a department.",
        APPLICATION_NOT_SUBMITTED: "An error occurred during the submission process, please try again.",
        ERROR_VALIDATING_RU_SCOPE_AND_UAT_ALREADY_EXISTS_FOR_SIMPLE_LAYER: "An RU purpose with the selected UAT already exists.",
        ERROR_VALIDATING_CONTAINER_COMPONENT_MISMATCHED_RU_SCOPE: "The RU purpose does not match that of the Container.",
        ERROR_VALIDATING_RU_SCOPE_ALREADY_EXISTS_FOR_CONTAIANERS: "The RU purpose already exists in the Container list.",
        PDF_INVALID: "The file does not have a valid signature!",
        PDF_IS_ENCRYPTED: "The file does not have a valid signature or is encrypted!",
        ERROR_VALIDATING_PUBLISHED_LAYER_WAS_ALREADY_PUBLISHED: "The selected layer has already been published. ",
        DUPLICATE_DEPARTMENT_NAME: "A department with this name already exists",
        CAN_NOT_USE_SYSTEM_FUNCTIONS: "A system position with this name already exists",
        FUNCTION_NAME_ALREADY_EXIST: "A position with this name already exists",
        INVALID_PDF_ERROR: "The signature is invalid, please try again using a valid digital signature.",
        PDF_READING_ERROR: "The file could not be read, please try again.",
        EMPTY_RESPONSIBILITIES: "The position has no responsibilities assigned.",
        REJECT_FORM_STAFF: "This application type is missing the form interface or document template for rejection",
        ERROR_VALIDATING_TARGET_CONTAINER_IS_SYSTEM_LAYER: "Error publishing layer, the source layer is a system layer.",
        AUTH_SERVICE_UNAVAILABLE: "An error occurred, please try again later.",
        ERROR_VALIDATING_LAYER_NAME_ALREADY_EXISTS: "The layer name is already in use.",
        THE_REQUEST_IS_NOT_VALID: "An error occurred, please try again later.",
        EMPTY_TARGET_FILES: "No document generated, the application cannot be signed",
        ERROR_VALIDATING_ARCGIS_IMPORTED_ITEM_DOES_NOT_EXISTS: "The layer is not accessible or does not exist.",
        ERROR_VALIDATING_ARCGIS_IMPORTED_ITEM_INVALID: "The layer identifier is not valid.",
        ERROR_VALIDATING_APPLICATION_TYPE_ALREADY_LINKED_TO_ANOTHER_LAYER: "One of the selected application types is already linked to another layer.",
        FILE_NOT_EXISTS: "The file you are trying to delete does not exist!",
        ERROR_MISSING_DOCUMENT_REJECTED_SERIES: "The series for this document has not been set!",
        INVALID_FORM_VALUE: "The value entered in the form is not valid!",
        TOO_MANY_INTEREST_AREAS: "The maximum number of areas of interest that can be defined has been reached.",
        TOO_MANY_CITIZEN_FEATURES: "The maximum number of uploadable layers has been reached.",
        APPLICATION_TYPE_EXISTS: "An application type with this name already exists",
        ERROR_DOWNLOAD_COMPRESSION: "An error occurred while downloading the files, please try again.",
        APPLICATION_REQUEST_DENIED: "You do not have sufficient permissions to view the application",
        APPLICATION_ALREADY_SUBMITTED: "The application has already been submitted and cannot be saved as a draft.",
        CANNOT_INIT_PAYMENT: "The payment cannot be initiated.",
        USER_PROFILE_ALREADY_EXISTS: "A user with this email already exists in the system",
        BENEFICIARY_EMAIL_ALREADY_INVITED: "The beneficiary with this email has already been invited",
        UTILS_LINKS_CSV_PARSE_ERROR: "The useful links file cannot be processed",
        ANAF_VALIDATION: "The validation system against the ANAF database is currently unavailable, so the beneficiary has been added to the system without validating their data. Validation will automatically resume when the beneficiary is added to an application or edited.",
        EXCEEDED_MAX_COUNT: "The selected report exceeds the maximum number of records, please adjust the time interval or the number of types",
        AUTH_ROEID_ERROR: "An error occurred while connecting to ROeID, please try again.",
        AUTH_STS_ERROR: "An error occurred while authenticating with STS, please try again.",
        SERIES_TYPE_ID_NOT_FOUND_FOR_VIZA_TYPE_REJECTION_VIZA_SERIES_TYPE_ID: "The series for endorsement rejection has not been configured! Please contact the administrator.",
    },
    REQUESTS: {
        BUILDING: {
            DETAILS: "Property details",
            LAND: "Land",
            LAND_CONSTRUCTIONS: "Land + buildings",
            COUNTY: "County",
            LOCALITY: "Locality",
            VILLAGE: "Village",
            SECTOR: "Sector",
            STREET: "Street",
            POSTAL_CODE: "Postal code",
            NUMBER: "Number",
            STAIRCASE: "Staircase",
            BLOCK: "Block",
            FLOOR: "Floor",
            APARTMENT: "Apartment",
            LAND_AREA: "Land area",
            OTHER_IDENTIFICATION: "Other identification",
            CADASTRAL_NUMBER: "Cadastral number",
            ADD_CADASTRAL_NUMBER: "Add cadastral number",
            REMOVE_CADASTRAL_NUMBER: "Delete cadastral number",
        },
    },
    VALIDATION: {
        REQUIRED_FIELD: "This field is required!",
        NUMERIC_FIELD: "This field accepts only numeric values!",
        EMAIL_FIELD: "The email address is invalid",
        PHONE_FIELD: "The phone number is invalid",
        UPLOADED_FILE_SIZE: "The file size is too large",
        UPLOADED_FILE_SIZE_NAME: "The size of file {name} is too large",
        UPLOADED_FILE_TYPE: "The file type is not supported",
        MAX_UPLOADED_FILES: "The maximum number of files allowed is {max}. {amount} more files can be uploaded.",
        PDF_FIELD: "The selected file extension must be .pdf.",
        MULTIPLE_FILES: "Some files could not be uploaded due to their extension or size",
        ENTER_NUMBER: "Enter a number",
    },
    PLACEHOLDERS: {
        MP: "m²",
    },
    INSTITUTION: {
        MAIN_HEADER: "Selected organisation",
        PAGE_HEADER: "Organisations",
        LOGO_LABEL: "Logo",
        USEFUL_LINKS_CSV_UPLOAD_LABEL: "Useful information",
        USEFUL_LINKS_CSV_UPLOAD_INFO: "Upload a .csv file with useful information in the following format: <Nume, Link>",
        LIST: {
            TITLE: "Organisation list",
        },
        FIELDS: {
            NAME: "Name",
            STATUS: "Status",
            COUNTY: "County",
            LOCALITY: "Locality",
            TYPE: "Type",
            UAT: "UAT",
            DESCRIPTION: "Description",
            IS_TEST: "Test organisation",
            STAFF_USERS: "Staff member",
            ORGANISATION: "Organisation",
            LOGO: "Logo",
            EXTERNAL_LINK: "External link",
            IS_CITIZEN_VISIBLE: "Visible on the citizen dashboard",
            UNIQUE_REGISTRATION_CODE: "CIF or CUI",
            LEGAL_REPRESENTATIVE_FUNCTION: "Legal representative function",
            LEGAL_REPRESENTATIVE_NAME: "Legal representative name",
            ACCOUNT_BANK: "Bank",
            ACCOUNT_IBAN: "IBAN",
            ACCOUNT_ADDRESS: "Address",
            ACCOUNT_PHONE: "Phone",
            ACCOUNT_EMAIL: "Email",
            REMARKS: "Remarks",
            NOTES: "Notes",
            ADDITIONAL_DETAILS: "Additional details",
            DETAILS_SECTION: "Organisation details",
            LEGAL_REPRESENTATIVE_SECTION: "Legal representative data",
            ACCOUNT_SECTION: "Account data",
            OTHER_INFO_SECTION: "Other information",
        },
        PLACEHOLDERS: {
            NAME: "Name",
            STATUS: "Status",
            DESCRIPTION: "Enter the organisation description",
            IS_TEST: "Test organisation",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
            IS_TEST: {
                YES: "Yes",
                NO: "No",
            },
        },
        MAIN_PAGE: {
            SEARCH: {
                PLACEHOLDER: "Search organisation",
                ERASE_BUTTON: "Clear",
            },
            TABLE_HEADER: {
                NAME: "Name",
                DESCRIPTION: "Description",
                STATUS: "Status",
                IS_TEST: "Test organisation",
                ACTIONS: "Actions",
            },
            TOOLTIPS: {
                EDIT: "Edit",
                DELETE: "Delete",
                FUNCTIONS: "Positions",
                DEPARTMENTS: "Departments",
                USERS: "Users",
                ACCOUNTS: "Collector accounts",
                TAXES: "Fees",
                RESPONSIBILITIES: "Responsibilities",
            },
            STATUS_TYPE: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
        },
        TABS: {
            DETAILS: "Details",
            FUNCTIONS: "Positions",
            DEPARTMENTS: "Departments",
            ORGANISATION_TREE: "Organisation chart",
            TAXES: "Fees",
            USERS: "Users",
            ACCOUNTS: "BT iPay accounts",
            DOCUMENT_SERIES: "Document series",
            DOCUMENT_REGISTERS: "Document registers",
            RESONSIBILITIES: "Responsibilities",
            DECISIONS: "Decisions",
            URBANISM_REGULATIONS: "Regulations",
            AI: "AI",
        },
        ADD_EDIT_FORM: {
            NAME: "Organisation name",
            TYPE: "Type",
            DESCRIPTION: "Description",
            COUNTY: "County",
            CITY: "Locality",
            STATUS_FIELD: "Status",
            TEST_INST: "Test organisation",
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
            TYPES: {
                COUNTY_COUNCIL: "County council",
                CITY_HALL: "Town hall",
                SERVICES: "Services",
            },
            PLACEHOLDER: "Enter the organisation description",
        },
        ADD_MODAL: {
            HEADER: "Add organisation",
        },
        BUTTON: {
            ADD: "Add",
            CANCEL: "Cancel",
            SAVE: "Save",
            UPDATE: "Update",
        },
        FUNCTIONS: {
            SEARCH: {
                PLACEHOLDER: "Search position",
                ERASE_BUTTON: "Clear",
            },
            TABLE_HEADER: {
                NAME: "Position name",
                DESCRIPTION: "Description",
                ACTIONS: "Actions",
            },
            TOOLTIPS: {
                EDIT: "Edit",
                DELETE: "Delete",
                USERS: "Users",
                RESPOSABILITIES: "Assign responsibilities",
            },
        },
        ERRORS: {
            ORG: "Error loading the institution list!",
            SINGLE_ORG: "Error loading the institution data!",
            FUNCTIONS: "Error loading the position list!",
            UPDATE_ORG: "Error updating the institution.",
            ADD_ORG: "Error adding the institution.",
            DELETE_ORG: "This institution cannot be deleted because it has associated users",
            PROTECTED_FIELDS: "Only a super administrator can change the organisation's type, county, UAT or test flag.",
        },
        SUCCESS: {
            UPDATE_ORG: "Institution updated successfully.",
            ADD_ORG: "Institution added successfully.",
            DELETE_ORG: "Institution deleted successfully.",
        },
        ORG_SELECTION_FORM: {
            HEADER: "Select active organisation",
        },
        NAME_FORMAT: {
            COUNTY_COUNCIL_CLUJ: "Cluj County Council",
            CITY_HALL: "{name} Town Hall",
        },
        ORGANISATION_TREE: {
            SEARCH: {
                PLACEHOLDER: "Search department/service/unit/position/user",
            },
            LEGEND: "Legend",
            COLLAPSE_ALL: "Collapse all",
            EXPAND_ALL: "Expand all",
            SHOW_INACTIVE: "Show inactive",
            MODAL: {
                ADD_TITLE: "{parent} - Add {type}",
                EDIT_TITLE: "{node} - Edit {type}",
            },
            TYPES: {
                COMPARTMENT: "unit",
                SERVICE: "service",
                FUNCTION: "position",
                USER: "user",
                DEPARTMENT: "department",
            },
            TOOLTIPS: {
                EDIT_DEPARTMENT: "Edit department",
                ADD_SERVICE: "Add service",
                ADD_COMPARTMENT: "Add unit",
                EDIT_SERVICE: "Edit service",
                EDIT_COMPARTMENT: "Edit unit",
                EDIT_USER: "Edit user",
            },
        },
    },
    INSTITUTION_AI: {
        LOAD_ERROR: "The AI settings could not be loaded.",
        FIELDS: {
            API_KEY: "API key",
            MONTHLY_CAP_USD: "Monthly budget (USD)",
            ALERT_EMAILS: "Alert emails",
            VALIDATED_AT: "Validated",
        },
        PLACEHOLDERS: {
            API_KEY: "sk-ant-…",
            MONTHLY_CAP_USD: "Unlimited budget",
            ALERT_EMAILS: "No email set",
        },
        KEY: {
            TITLE: "Anthropic API key",
            DESCRIPTION: "Used for AI translations for all organisations. Costs are billed to this key's Anthropic account.",
            STATUS_ACTIVE: "Active",
            STATUS_NOT_CONFIGURED: "Not configured",
            STATUS_UNREADABLE: "Key cannot be read",
            STATUS_REJECTED: "Rejected",
            DISABLED_TEXT: "AI translations are off until a key is saved.",
            SAVE_AND_TEST: "Save & test",
            REPLACE: "Replace key",
            REMOVE: "Remove key",
            REMOVE_CONFIRM: "Remove the API key?",
            REJECTED: "Anthropic rejected this key. Nothing was saved.",
            UNAVAILABLE: "The key could not be checked right now (Anthropic or the platform is not responding). Nothing was saved, please try again.",
            INVALID_FORMAT: "The key does not have the right format (sk-ant-…).",
            UNREADABLE_HINT: "The saved key can no longer be decrypted. Enter the key again to restart AI.",
            REJECTED_AUTH_HINT: "Anthropic rejected the key (invalid or revoked). Enter a new key.",
            REJECTED_BILLING_HINT: "The Anthropic account has run out of credit. Top up the account, then save the key again.",
            STORAGE_HINT: "The key is checked with Anthropic and stored encrypted.",
            BUDGET_AFTER_KEY: "Budget and alerts appear once the key is saved.",
            SAVED: "Key validated and saved. AI is now active; pending translations for all organisations are queued.",
            REMOVED: "API key removed. AI is now off for all organisations.",
        },
        BUDGET: {
            TITLE: "Budget & alerts",
            DESCRIPTION: "AI pauses for all organisations when the monthly budget is reached. Alerts at 50%, 80% and 100%.",
            NO_CAP_WARNING: "No monthly budget: spending is unlimited and no alerts are sent.",
            INVALID_EMAIL: "One of the addresses is not valid",
            EMAIL_LIMIT: "You can enter up to {max} addresses",
            SPEND_THIS_MONTH: "Spend this month",
            SPEND_OF_CAP: "{spent} USD of {cap} USD",
            SAVED: "Budget and alerts saved.",
        },
        ERRORS: {
            FORBIDDEN: "You do not have access to the AI settings.",
            NOT_MANAGED: "AI settings are managed by the county council.",
            TOO_MANY_ATTEMPTS: "Too many attempts. Try again in a few minutes.",
            UNCONFIRMED: "The change could not be confirmed (the platform did not respond). The settings were reloaded; check them and try again if needed.",
        },
    },
    DEPARTMENTS: {
        PAGE_HEADER: "Departments",
        LIST: {
            TITLE: "Department list",
        },
        FIELDS: {
            NAME: "Name",
            STATUS: "Status",
            DESCRIPTION: "Description",
        },
        PLACEHOLDERS: {
            NAME: "Name",
            STATUS: "Status",
            DESCRIPTION: "Description",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
        },
        TABLE_HEADER: {
            NAME: "Department/service name",
            DESCRIPTION: "Description",
            STATUS: "Status",
            ACTIONS: "Actions",
        },
        TOOLTIPS: {
            FUNCTIONS: "Assign positions",
            USERS: "Users",
        },
        ADD_EDIT_MODAL: {
            HEADER: {
                ADD: "Add department",
                EDIT: "Edit department",
            },
            NAME: "Department name",
            DESCRIPTION: "Description",
            STATUS: "Status",
            STATUS_TYPE: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
            TYPES: {
                COUNTY_COUNCIL: "County council",
                CITY_HALL: "Town hall",
                SERVICES: "Services",
            },
            PLACEHOLDER: "Enter the department description",
        },
        ASSOCIATED_FCT_MODAL: {
            HEADER: "Assign positions",
            ERRORS: {
                LIST: "Error loading the assigned position list!",
                ADD_FUNCTION: "Error adding the position to the department.",
            },
        },
        ASSOCIATED_USERS_MODAL: {
            HEADER: "Assign users",
            ERRORS: {
                LIST: "Error loading the assigned user list!",
                ADD_FUNCTION: "Error adding the user to the department.",
            },
        },
        ERRORS: {
            DEP_LIST: "Error loading the department list!",
            ADD: "Error adding the department.",
            UPDATE: "Error updating the department.",
        },
        SUCCESS: {
            ADD: "Department added successfully.",
            UPDATE: "Department updated successfully.",
        },
        BUTTON: {
            ADD_DEPARTMENT: "Add department",
        },
    },
    FUNCTIONS: {
        PAGE_HEADER: "Positions",
        LIST: {
            TITLE: "Positions list",
            SYSTEM_FUNCTIONS: "The following positions are created automatically by the system: {systemFunctions}.",
        },
        FIELDS: {
            NAME: "Name",
            ALIAS: "Alias",
            DESCRIPTION: "Description",
        },
        PLACEHOLDERS: {
            NAME: "Name",
            DESCRIPTION: "Description",
        },
        ASSOCIATED_RESPOSABILITIES_MODAL: {
            HEADER: "Assign responsibilities",
            BODY: {
                TOP: "Position",
            },
        },
        ADD_EDIT_FORM: {
            HEADER_ADD: "Add position",
            HEADER_EDIT: "Edit position",
            NAME: "Name",
            NAME_DESCRIPTION: "Enter an alias as well. It will be displayed on the signature.",
            ALIAS: "Alias",
            DESCRIPTION: "Description",
            PLACEHOLDER: "Enter the position description",
            ALIAS_PLACEHOLDER: "Enter the position alias.",
            SYSTEM_FUNCTIONS: "System positions cannot be edited.",
        },
        SUCCESS: {
            ADD: "Position added successfully.",
            UPDATE: "Position updated successfully.",
            DELETE: "Position deleted successfully.",
        },
        BUTTON: {
            ADD_FUNCTION: "Add position",
        },
    },
    TERRITORIAL_UNIT_ALLOCATION: {
        HEADER: "UAT assignment",
        FIELDS: {
            TU_NAME: "Name",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
        },
        PLACEHOLDERS: {
            TU_NAME: "Name",
        },
        MODAL: {
            HEADER: "Add UAT",
            OBS: "Already assigned UATs do not appear in the list",
        },
        BUTTON: {
            ADD_UAT: "Add UAT",
        },
        TABLE_EMPTY_TEXT: "No UATs are assigned to this user.",
    },
    ADMIN_USERS_MODAL: {
        HEADER: "User account list",
        PLACEHOLDER: "Search user",
        TABLE_HEADER: {
            LAST_NAME: "Last name",
            FIRST_NAME: "First name",
            FUNCTION: "Position",
            STATUS: "Status",
            STATUS_ACTIVE: "Active",
            STATUS_INACTIVE: "Inactive",
        },
        FUNCTIONS: {
            ERRORS: {
                LIST: "Error generating the user list for a position!",
            },
        },
        DEPARTMENTS: {
            ERRORS: {
                LIST: "Error generating the user list for a department!",
            },
        },
    },
    ACCOUNTS: {
        BUTTONS: {
            ADD_ACCOUNT: "Add account",
            CANCEL: "Cancel",
            INVITE: "Invite by email",
            RESEND_LINK: "Resend link",
            SAVE: "Save",
        },
        ENUMS: {
            ROLES: {
                ADMINISTRATOR: "Administrator",
                EDITOR: "Editor",
            },
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
                PENDING: "Sent",
            },
        },
        FIELDS: {
            CREATED_BY_NAME: "Created by",
            EMAIL: "Email",
            FIRST_NAME: "First name",
            LAST_NAME: "Last name",
            PHONE: "Phone",
            STATUS: "Status",
            ROLE: "Role",
            USER_NAME: "Name",
        },
        LABELS: {
            CREATED_BY: "Created by",
            USER: "User",
        },
        LIST: {
            ACTIONS: "Actions",
            EDIT: "Edit",
            HEADER: "Linked accounts",
        },
        MODALS: {
            EDIT_ACCOUNT: "Edit account",
            ADD_NEW_ACCOUNT: "Add new account",
        },
        NOTIFIERS: {
            EDITED_SUCCESS: "Account updated!",
            INVITE_TEXT: "An invitation was sent successfully to <strong>{email}</strong>. Once the account is validated, it will appear within the organisation",
            INVITE_TITLE: "Invitation sent",
            RESEND_SUCCESS: "Link resent!",
        },
        PLACEHOLDERS: {
            CHOOSE: "Choose",
            ROL: "Role",
            SEARCH_NAME: "Search by name",
            STATUS: "Status",
        },
        TITLE: "Manage accounts",
    },
    COLLECTOR_ACCOUNTS: {
        PAGE_HEADER: "BT iPay accounts",
        LIST: {
            TITLE: "BT iPay account list",
        },
        FIELDS: {
            NAME: "Account name",
            BANK: "Bank",
            USERNAME: "BT iPay username",
            PASSWORD: "BT iPay password",
            STATUS: "Status",
        },
        PLACEHOLDERS: {
            NAME: "Account name",
            BANK: "Bank",
            USERNAME: "BT iPay username",
            PASSWORD: "BT iPay password",
            STATUS: "Status",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
        },
        TABLE_HEADER: {
            NAME: "Account name",
            BANK: "Bank",
            USERNAME: "BT iPay username",
            PASSWORD: "BT iPay password",
            STATUS: "Status",
            ACTIONS: "Actions",
        },
        STATUS_TYPE: {
            ACTIVE: "Active",
            INACTIVE: "Inactive",
        },
        TOOLTIPS: {
            EDIT: "Edit",
            DELETE: "Delete",
        },
        MANAGE_ACCOUNT_MODAL: {
            HEADER: {
                EDIT: "Edit BT iPay account",
                ADD: "Add BT iPay account",
            },
            FORM: {
                NAME: "Name",
                BANK: "Bank",
                USERNAME: "BT iPay username",
                PASSWORD: "BT iPay password",
                STATUS: "Status",
            },
        },
        CONFIRMATION_MESSAGE: "Are you sure you want to delete the collector account?",
        SUCCESS: {
            DELETE: "Collector account deleted successfully.",
            ADD: "Collector account added successfully.",
            UPDATE: "Collector account updated successfully.",
        },
        BUTTON: {
            ADD_COLLECTOR_ACCOUNT: "Add account",
        },
    },
    BENEFICIARIES: {
        DGEVP: {
            CONNECT: "Connect",
            CONNECT_TITLE: "Connect to DGEVP",
            VALIDATE: "Validate",
            INFO: "DGEVP info: For security reasons, this content is only available to users who have been granted IP-based access by DGEVP.",
        },
        BUTTONS: {
            ADD_ACCOUNT: "Add beneficiary",
            CANCEL: "Cancel",
            SAVE: "Save",
        },
        FIELDS: {
            BENEFICIARY: "Beneficiary",
            IDENTIFIER: "Name, CNP or CIF",
            CREATED_BY_NAME: "Created by",
            EMAIL: "Email",
            FIRST_NAME: "First name",
            LAST_NAME: "Last name",
            ID_CARD_SERIAL: "ID card series",
            ID_CARD_NUMBER: "ID card number",
            ID_CARD_EXPIRATION_DATE: "Expiry date",
            ID_CARD_ISSUED_DATE: "Issue date",
            ID_CARD_ISSUER: "Issued by",
            PHONE: "Phone",
            STATUS: "Status",
            ROLE: "Role",
            USER_TYPE: "Person type",
            PERSONAL_NUMERIC_CODE: "CNP",
            USER_NAME: "Name",
            LOCALITY: "Municipality / Town / Commune",
            PAYMENT: "Payment",
            EMPLACEMENT_LOCALITY: "Locality",
            USER_TYPE_NAME: "Person type",
            COUNTY: "County",
            VILLAGE: "Locality",
            SECTOR: "Sector",
            STREET: "Street",
            STREET_NUMBER: "Street number",
            POSTAL_CODE: "Postal code",
            STAIRCASE: "Staircase",
            BLOCK: "Block",
            FLOOR: "Floor",
            APARTMENT: "Apartment",
            USE_PROFILE_DATA: "Use profile data",
            PASSPORT_NUMBER: "Passport number",
            CITY: "City",
            ADDRESS: "Address",
            LICENSE: "Licence",
            COMPANY_NAME: "Entity name",
            IBAN: "IBAN account",
            BANK: "Bank",
            UNIQUE_REGISTRATION_CODE: "CIF or CUI",
            REGISTRATION_NUMBER: "Trade Register number",
            USERNAME: "Username",
            PASSWORD: "Password",
        },
        LABELS: {
            CREATED_BY: "Created by",
            USER: "User",
        },
        LIST: {
            ACTIONS: "Actions",
            EDIT: "Edit",
            HEADER: "Beneficiaries",
            DELETE: "Delete",
        },
        MODALS: {
            EDIT_ACCOUNT: "Edit beneficiary",
            ADD_NEW_ACCOUNT: "Add a new beneficiary",
        },
        NOTIFIERS: {
            ADDED_SUCCESS: "Beneficiary added!",
            EDITED_SUCCESS: "Beneficiary updated!",
            DELETE_SUCCESS: "Beneficiary deleted successfully!",
        },
        PLACEHOLDERS: {
            CHOOSE: "Choose",
            ROL: "Role",
            SEARCH_NAME: "Search by name",
            STATUS: "Status",
        },
        TITLE: "Manage beneficiaries",
        SUCCESS: {
            DELETE: "Beneficiary deleted successfully!",
        },
    },
    TAX_CATEGORY: {
        LIST: {
            TITLE: "Fee categories",
        },
        FILTER: {
            TITLE: "Fee categories",
        },
        ADD_BUTTON: "New category",
        FIELDS: {
            NAME: "Name",
            STATUS: "Status",
        },
        FORM: {
            EDIT_TITLE: "Edit category",
            ADD_TITLE: "New category",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
            STATUS: "Status",
        },
    },
    COMPLAIN_TYPE: {
        LIST: {
            TITLE: "Complaint types",
        },
        ADD_BUTTON: "New type",
        FIELDS: {
            NAME: "Name",
            STATUS: "Status",
            COMPLAIN_DOCUMENT_SERIES_TYPE: "Document series type",
            TENANT_ID: "Organisation",
        },
        FORM: {
            EDIT_TITLE: "Edit complaint type",
            ADD_TITLE: "New complaint type",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
            STATUS: "Status",
        },
    },
    COMPLAIN: {
        LIST: {
            TITLE: "Complaints",
            TABLE_HEADER: "Complaint history",
            ADD_BUTTON: "New complaint",
            NO_ASSIGNEE: "Unassigned",
        },
        STAFF_LIST: {
            TITLE: "Complaints",
            TABLE_HEADER: "Complaints",
            ADD_BUTTON: "New inspection",
        },
        FIELDS: {
            COMPLAIN_TYPE: "Complaint type",
            LOCALITY: "Locality",
            ADDRESS: "Address",
            ADDRESS_DETAILS: "Additional location details",
            DESCRIPTION: "Complaint description",
            FIRST_NAME: "First name",
            LAST_NAME: "Last name",
            EMAIL: "Email",
            PHONE: "Phone",
            STATUS: "Status",
            REPORTED_BY: "Created by",
            REPORTED_FOR: "Contact person",
            IDENTIFICATION_NUMBER: "Entry code",
            CREATED_DATE: "Date",
            USE_PROFILE_DATA: "Use my profile data",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            MESSAGE_COMMENT: "Your message",
            RESPONSE_TEMPLATES: "Response templates",
            DISMISSED_COMMENT: "Template message",
            UAT: "Municipality / Town / Commune",
            ASSIGNED_TO: "Resolved by",
        },
        FORM: {
            TITLE: "New complaint form",
            TITLE_CLASSIFY: "Dismiss complaint",
            TITLE_RESOLVED: "Resolve complaint",
            COMPLAIN_DETAIL_SECTION_TITLE: "Complaint details",
            USER_DETAIL_SECTION_TITLE: "Contact person details",
            ATLAS_PREVIEW_SECTION_TITLE: "Location",
            DOCUMENTS_SECTION_TITLE: "Upload documents / photos",
            VIEW_DOCUMENTS_SECTION_TITLE: "View documents / photos",
            UPLOAD_DOCUMENT_BUTTON: "Upload document",
            SUBMIT_BUTTON: "Send complaint",
            VIEW_GOOGLE_MAPS_BUTTON: "View in Google Maps",
            CLASSIFY_BUTTON: "Dismiss",
            RESOLVED_BUTTON: "Resolve",
            EMPTY_DOCUMENT_LABEL: "No documents attached",
            RESOLVE_BUTTON: "Send response - Resolved",
            RESPONSE: "Complaint response",
            PREVIEW_TITLE: "Notification preview",
            NOTIFICATION_TEMPLATE_TEXT: "The complaint of type '{type}' with unique registration number {number}, created by {user}, has been dismissed in Ghișeul Unic for the following reason:",
            FILE_PLACEHOLDER_NAME: "File {0}",
        },
        TABS: {
            COMPLAIN: "Complaint",
            DISCUSSIONS: "Activities",
        },
        PLACEHOLDERS: {
            DESCRIPTION: "Your message",
            STATUS: "Status",
            REPORTED_BY: "Created by",
            REPORTED_FOR: "Contact person",
            LOCALITY: "Locality",
            IDENTIFICATION_NUMBER: "Search by code",
            ASSIGNED_TO: "Resolved by",
        },
        ENUMS: {
            STATUS: {
                NEW: "Registered",
                PENDING: "Processing",
                RESOLVED: "Resolved",
                REJECTED: "Rejected",
                DISMISSED: "Dismissed",
            },
        },
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "Complaint sent",
            CREATED_SUCCESS_TEXT: "Complaint number <strong>{number}</strong> has been sent successfully.</br> After analysis and verification, you will be notified about its resolution.",
            CLASSIFICATION_MESSAGE: "Are you sure you want to dismiss the complaint?",
            CLASSIFICATION_SUCCESS_TEXT: "The complaint has been dismissed.",
            RESOLVE_MESSAGE: "Are you sure you want to resolve the complaint?",
            RESOLVE_SUCCESS_TEXT: "The complaint has been resolved.",
            LOCATION_TITLE: "Missing location!",
            LOCATION_TEXT: "Please select the location/town of the complaint on the map to submit the complaint.",
        },
    },
    FORM_FIELDS: {
        SAVE_BTN: "Save",
        INVITE_BTN: "Invite by email",
        CANCEL_BTN: "Cancel",
        FIRST_NAME: "First name",
        LAST_NAME: "Last name",
        FULL_NAME: "Full name",
        EMAIL: "Email",
        PHONE: "Phone",
        DEPARTMENT: "Department",
        ORGANISATION: "Institution",
        ROLE: "Role",
        TAG_ID: "Badge number",
        TAG_RELEASED_BY: "Badge issued by",
        EXTERNAL_ENROLLMENT_ID: "External ID (enrolment)",
        FUNCTION: "Position",
        RESPONSIBILITIES: "Responsibilities",
        PERMISSIONS: "Permissions",
        STATUS: "Status",
        IS_ORGANISATION_ADMIN: "Organisation administrator",
        MESSAGES: {
            ACCOUNT_CREATED: "Account created",
            ACCOUNT_UPDATED: "Account updated",
            ACCOUNT_NOT_CREATED: "An error occurred while creating the account",
            ACCOUNT_NOT_UPDATED: "An error occurred while updating the account",
            NO_FUNCTIONS_SELECTED: "No position selected",
            ASSIGNMENT_NO_FUNCTIONS: "Assignment {assignmentNumber} ({departmentName}) must have at least one position selected.",
            ASSIGNMENTS_NO_FUNCTIONS: "The following assignments must have at least one position selected: {assignmentDetails}",
            NO_ASSIGNMENTS: "No assignments have been added.",
        },
        ASSIGNED_TERRITORIAL_ADMINISTRATIVE_UNIT: "Assigned UATs",
        SERVICE: "Service",
        COMPARTMENT: "Unit",
        SERVICE_COMPARTMENT: "Unit within the service",
        FUNCTIONS: "Positions",
        SELECTED_FUNCTIONS_SUMMARY: "Positions",
        DEPARTMENT_FUNCTIONS: "Department positions",
        ASSIGNMENT: "Select from existing assignments",
        ALREADY_ASSIGNED: "Already assigned",
        SERVICES: "Services",
        SERVICE_FUNCTIONS: "Service positions",
        COMPARTMENTS: "Units",
        COMPARTMENT_FUNCTIONS: "Unit positions",
        SERVICE_COMPARTMENTS: "Units under the service",
        SERVICE_COMPARTMENTS_SECTION_TITLE: "Units under the services",
        SERVICE_COMPARTMENT_FUNCTIONS: "Service unit positions",
        NO_COMPARTMENTS_AVAILABLE: "No units available",
        NO_DEPARTMENTS_AVAILABLE: "No departments available",
        NO_SERVICES_AVAILABLE: "No services available",
        NO_FUNCTIONS_AVAILABLE: "No positions available",
        NO_SERVICE_COMPARTMENTS_AVAILABLE: "No service units available",
        NO_DEPARTMENT_FUNCTIONS_AVAILABLE: "No department positions available",
        NO_SERVICE_FUNCTIONS_AVAILABLE: "No service positions available",
        NO_COMPARTMENT_FUNCTIONS_AVAILABLE: "No unit positions available",
        NO_SERVICE_COMPARTMENT_FUNCTIONS_AVAILABLE: "No service unit positions available",
        PERSONAL_INFORMATION: "Personal details",
        IDENTIFICATION_AND_ORGANIZATION: "Organisation details",
        ORGANIZATIONAL_ASSIGNMENTS: "Organisational assignments",
        DEPARTMENT_AND_STRUCTURE: "Department structure",
        FUNCTIONS_AND_ROLES: "Position assignment in the department",
        FUNCTIONS_AND_ROLES_STAFF: "Positions in the department",
        SELECT_SERVICES: "Select services",
        SELECT_COMPARTMENTS: "Select units",
        SELECT_SERVICE_COMPARTMENTS: "Select units under the service",
        NO_DEPARTMENT: "No department selected",
        NO_RESPONSIBILITIES: "No responsibilities available",
        NO_TERRITORIAL_UNITS: "No UATs assigned",
    },
    FUNCTIONARY: {
        LIST: {
            TITLE: "Staff list",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
                PENDING: "Pending",
            },
        },
        FIELDS: {
            FIRST_NAME: "First name",
            LAST_NAME: "Last name",
            EMAIL: "Email",
            STATUS: "Status",
            FULL_NAME: "Full name",
            DEPARTMENTS: "Departments",
            SERVICES: "Services",
            COMPARTMENTS: "Units",
            SERVICE_COMPARTMENTS: "Sub-units",
            FUNCTIONS: "Positions",
            ACCOUNT_TYPE: "Account type",
            ADMIN: "Administrator",
            STAFF: "Staff",
        },
        PLACEHOLDERS: {
            EMAIL: "Email",
            STATUS: "Status",
            FULL_NAME: "Full name",
            DEPARTMENTS: "Department",
            FUNCTIONS: "Position",
            SERVICES: "Service",
            COMPARTMENTS: "Unit",
            SERVICE_COMPARTMENTS: "Sub-unit",
            LAST_NAME: "Last name",
        },
        HEADER_LIST: "Manage staff accounts",
        ADD_BTN: "Add account",
        ADD_ACCOUNT_HEADER: "Add new staff account",
        EDIT_ACCOUNT_HEADER: "Edit account",
        TABLE_HEADER: {
            ACTIONS: "Actions",
        },
        DELETE_ACCOUNT_MESSAGE: "Are you sure you want to delete the staff account?",
        DELETED_ACCOUNT_SUCCESS: "Account deleted",
        RESET_PASS_SUCCESS: "A password reset link has been sent to <strong>{email}</strong>.",
        CHANGE_STATUS_SUCCESS: "Account status modified",
        DENY_DELETE_ACCOUNT: "The account cannot be deleted",
        CHANGE_ACCOUNT_STATUS: "<p>Are you sure you want to change the account status?<p><small>Current status: <b>{status}</b></small>",
        RESET_PASSWORD: "Reset password",
        RESET_PASSWORD_CONFIRM: "Are you sure you want to reset the password?",
        CHANGE_ACCOUNT_STATUS_ACTION: "Activate/deactivate account",
        DENY_RESET_PASSWORD: "You cannot reset the password for an inactive account",
        PERMISSIONS_TOOLTIP: "Permissions",
        PERMISSIONS: {
            HEADER: "Permissions list",
            FILTER_PLACEHOLDER: "Search by name",
            PERMISSION_NAME_LABEL: "Name",
        },
        TOOLTIPS: {
            TERRITORIAL_UNIT_ALLOCATION: "Add/delete UATs",
        },
        UNKNOWN: {
            SERVICE: "Unknown service",
            SERVICE_COMPARTMENT: "Unknown sub-unit",
            COMPARTMENT: "Unknown unit",
        },
    },
    RESPONSE_TEMPLATES: {
        LIST: {
            TITLE: "Response templates",
            ACTIONS: "Actions",
        },
        ADD_BUTTON: "Add template",
        FIELDS: {
            TITLE: "Title",
            CATEGORY: "Category",
            MESSAGE: "Template message",
        },
        FORM: {
            EDIT_TITLE: "Edit template",
            ADD_TITLE: "Add template",
        },
        ENUMS: {
            CATEGORY: {
                COMPLAINS: "Complaints",
                APPLICATIONS: "Applications",
                NOTICE: "Approvals",
            },
        },
        PLACEHOLDERS: {
            TITLE: "Search by title",
            CATEGORY: "Category",
            MESSAGE: "Template message",
        },
        CATEGORY: {
            COMPLAINS: "complaint",
            APPLICATIONS: "application",
            NOTICE: "approval",
        },
    },
    TRANSLATIONS: {
        LIST: {
            TITLE: "Translations",
            ACTIONS: "Actions",
            OVERRIDE: "Correct manually",
            RETRANSLATE: "Retranslate",
            RETRANSLATE_SELECTED: "Retranslate ({count})",
        },
        FIELDS: {
            NAMESPACE: "Domain",
            ENTITY_ID: "Entity",
            PATH: "Field",
            SOURCE_TEXT: "Source (RO)",
            TEXT: "Translation",
            CONTENT: "Text search",
            LANGUAGE: "Language",
            STATUS: "Status",
            ORIGIN: "Origin",
            TRANSLATED_AT: "Updated",
            SOURCE_TERM: "Source term (RO)",
            TARGET_TERM: "Translated term",
            NOTES: "Notes",
            TERM: "Term",
            UPDATED_AT: "Updated",
        },
        PLACEHOLDERS: {
            NAMESPACE: "Domain",
            ENTITY_ID: "Entity ID",
            CONTENT: "Search in source and translation",
            LANGUAGE: "Language",
            STATUS: "Status",
            ORIGIN: "Origin",
            SOURCE_TERM: "Source term",
            TARGET_TERM: "Translated term",
            NOTES: "Notes",
            TERM: "Search for a term",
        },
        ENUMS: {
            LANGUAGE: {
                HU: "Hungarian",
                EN: "English",
            },
            STATUS: {
                PUBLISHED: "Published",
                STALE: "Outdated",
                FAILED: "Failed",
                UNTRANSLATABLE: "Untranslatable",
                NO_API_KEY: "No API key",
            },
            ORIGIN: {
                MACHINE: "Automatic",
                HUMAN: "Manual",
            },
        },
        OVERRIDE: {
            TITLE: "Manual correction",
            NOTE: "A manual correction is never overwritten by an automatic retranslation.",
            SUCCESS: "The translation has been corrected.",
            REJECTED: "The translation could not be saved: {reason}",
            SOURCE_LABEL: "Source text (RO)",
            TEXT_LABEL: "Translation",
        },
        RETRANSLATE: {
            QUEUED: "Retranslation has been scheduled.",
            QUEUED_COUNT: "Scheduled for retranslation: {count}.",
            PARTIALLY_FAILED: "Scheduled for retranslation: {queued}. Could not be scheduled: {failed}.",
        },
        GLOSSARY: {
            TITLE: "Translation glossary",
            ADD_BUTTON: "Add term",
            RETRANSLATE_ALL_BUTTON: "Retranslate all",
            FUTURE_ONLY_NOTE: "Glossary changes only affect future translations. Existing translations remain unchanged until they are retranslated.",
            FORM: {
                ADD_TITLE: "Add term",
                EDIT_TITLE: "Edit term",
            },
            RETRANSLATE_MODAL: {
                TITLE: "Retranslate all forms",
                SCOPE_LABEL: "Languages to retranslate",
                ONLY_LANGUAGE: "{language} only",
                BOTH_LANGUAGES: "Both languages",
                COST_ESTIMATE: "Estimated cost: ~{cost} USD for {forms} forms.",
                COST_UNAVAILABLE: "The estimated cost is currently unavailable.",
                CONFIRM: "Start retranslation",
            },
        },
        DASHBOARD: {
            TITLE: "Translations dashboard",
            CATALOGUE_COVERAGE: "Catalogue coverage — {language}",
            FORMS_OPTED_IN: "Translatable forms",
            SPEND: "Spend this month",
            SPEND_OF_CAP: "{spent} USD of {cap} USD",
            USAGE_UNAVAILABLE: "AI usage data is currently unavailable.",
            STATUS_BREAKDOWN: "Statuses by language",
            SPEND_PANEL: "AI usage",
            REQUESTS: "Requests",
            REFUSED: "Refused",
            CACHE_HIT: "Cache hits",
            BY_PURPOSE: "By purpose",
            PURPOSE: {
                BACKFILL: "Initial translation",
                CHURN: "Content updates",
                LAZY_FILL: "On demand",
            },
            BY_LANGUAGE: "By language",
            NO_DATA: "—",
        },
    },
    TAXES: {
        BUTTONS: {
            ADD_TAX: "Add fee",
        },
        FIELDS: {
            NAME: "Name",
            ENTRY_DATE: "Effective date",
            JUSTIFICATION: "HCL/NO./DATE",
            CATEGORY: "Category",
            FIXED_VALUE: "Fixed value",
            PERCENTAGE_VALUE: "Percentage value",
            PRICE_CALCULATION_MODEL: "Calculation type",
            START: "Start",
            END: "End",
            VALUE: "Value",
        },
        LABELS: {},
        LIST: {
            ACTIONS: "Actions",
            EDIT: "Edit",
            HEADER: "Fee list",
        },
        MODALS: {
            ADD_TITLE: "Add fee",
            EDIT_TITLE: "Edit fee",
            HCL: "HCL / Other justification",
            ADD: "Add",
            SAVE: "Save",
            CANCEL: "Cancel",
        },
        NOTIFIERS: {
            SAVED: "Fee saved successfully",
            EDITED: "Fee updated successfully",
            INVALID_RANGES: "The ranges or values are not valid",
        },
        PLACEHOLDERS: {
            NAME: "Name",
            CATEGORY: "Category",
        },
        ENUMS: {
            PRICE_CALCULATION_MODEL: {
                FIXED: "Fixed",
                RANGE: "Ranges",
                MIXED: "Mixed",
                PERCENTAGE: "Percentage",
            },
        },
    },
    DOCUMENT_SERIES: {
        BUTTONS: {
            ADD_SERIES: "Add series",
        },
        FIELDS: {
            NAME: "Name",
            SEPARATOR: "Separator",
            DESCRIPTION: "Description",
            PREFIX: "Prefix",
            REJECTED_PREFIX: "Response letter prefix",
            CURRENT_INDEX: "Current index",
            CATEGORY: "Category/Registers",
            YEARLY_RESET: "Yearly reset",
            ACTIVE: "Active",
            SERIES_TYPE: "Series type",
            REJECTED_INDEX: "Response letter index",
        },
        LIST: {
            EDIT: "Edit",
            HEADER: "List of document series",
        },
        MODALS: {
            ADD_TITLE: "Add document series",
            EDIT_TITLE: "Edit document series",
            ADD: "Add",
            SAVE: "Save",
            CANCEL: "Cancel",
        },
        NOTIFIERS: {
            SAVED: "The document series has been saved",
            EDITED: "The document series has been updated",
            LOCATION_ALREADY_ADDED: "This location has already been added",
        },
        PLACEHOLDERS: {
            NAME: "Name",
        },
    },
    DOCUMENT_REGISTERS: {
        BUTTONS: {
            ADD_REGISTER: "Add register",
        },
        FIELDS: {
            NAME: "Name",
            DESCRIPTION: "Description",
            REGISTER_TYPE: "Register type",
            IS_CUSTOM: "Custom register",
            APPLICATION_TYPE_IDS: "Application types",
            DOCUMENT_SERIES_IDS: "Document series",
        },
        LIST: {
            VIEW: "View",
            EDIT: "Edit",
            DELETE: "Delete",
            HEADER: "List of document registers",
        },
        MODALS: {
            ADD_TITLE: "Add document register",
            EDIT_TITLE: "Edit document register",
            ADD: "Add",
            SAVE: "Save",
            CANCEL: "Cancel",
        },
        NOTIFIERS: {
            SAVED: "The document register has been saved",
            EDITED: "The document register has been updated",
            DELETED: "The document register has been deleted",
        },
        VALIDATION: {
            REQUIRED_SELECTION_TITLE: "Required selection",
            REQUIRED_SELECTION_TEXT: "Please select at least one {field}.",
            NO_APPLICATION_TYPES_TEXT: "The selected document series have no application types. Select document series that have at least one application type.",
            MAX_COLUMNS_TITLE: "Maximum number of columns",
            MAX_COLUMNS_TEXT: "You have selected {selected} columns. A register can contain at most {max} columns.",
            RECOMMENDED_COLUMNS_TITLE: "Large number of columns",
            RECOMMENDED_COLUMNS_TEXT: "You have selected {selected} columns. More than {recommended} columns may reduce performance. You can select up to {max} columns.",
            MIN_COLUMNS_TITLE: "Columns required",
            MIN_COLUMNS_TEXT: "Please select at least one column for the register.",
        },
        PLACEHOLDERS: {
            NAME: "Name",
            DESCRIPTION: "Description",
            APPLICATION_TYPE: "Select application type",
            DOCUMENT_SERIES: "Select document series",
            SEARCH_APPLICATION_TYPES: "Search application types",
        },
    },    
    ORG_RESPONSIBILITIES: {
        BUTTONS: {
            ADD_RESPONSIBILITY: "Add responsibility",
        },
        LIST: {
            TITLE: "Responsibilities",
        },
        FILTER: {
            TITLE: "Responsibilities list",
        },
        FIELDS: {
            RESPONSIBILITY_NAME: "Name",
            RESPONSIBILITIES: "Responsibilities",
        },
        PLACEHOLDERS: {
            RESPONSIBILITY_NAME: "Search by name",
            RESPONSIBILITIES: "Responsibilities",
        },
        FORM: {
            ADD_TITLE: "Add responsibility",
            EDIT_TITLE: "Edit responsibility",
            SELECTED_RESPONSIBILITY: "Selected responsibility",
            PERMISSIONS: "Permissions",
            CLONE_TITLE: "Clone responsibility",
        },
        CLARIFICATION: {
            ADD: "The responsibility can be added if a responsibility and permissions are selected.",
            EDIT: "The responsibility can be edited only if permissions are selected.",
        },
    },
    RESPONSIBILITY: {
        FILTER: {
            TITLE: "Responsibilities",
        },
        FIELDS: {
            NAME: "Name",
            DESCRIPTION: "Description",
            CREATED_DATE: "Created date",
            UPDATED_DATE: "Last updated",
            ACTIONS: "Actions",
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
            PERMISSIONS: "Search permissions",
        },
        FORM: {
            ASSOCIATED_PERMISSIONS: "Associated permissions",
            EDIT_TITLE: "Edit responsibility",
            ADD_TITLE: "Add responsibility",
        },
        LOGS: {
            TITLE: "History",
        },
    },
    APPLICATION: {
        LIST: {
            TITLE_STAFF: "General registry",
            TITLE: "Applications",
            TABLE_HEADER: "Application list",
            ADD_BUTTON: "New application",
            REFRESH_BUTTON: "Refresh",
            REPORT_BUTTON: "Generate report",
            ADD_DOCUMENT_BUTTON: "Document",
            DOCUMENT_CREATED_HEADER: "Created documents",
            DOCUMENT_RECEIVED_HEADER: "Received documents",
            DOCUMENT_PUBLIC_HEADER: "Public documents",
            PAYMENTS_HEADER: "Recorded payments",
            NO_ASSIGNEE: "Unassigned",
            SIGN_DOCUMENT_BULK: "Sign documents",
            SIGN_DOCUMENT_BULK_PERSONALIZED: "Sign documents with custom signature",
            SIGN_DOCUMENT_BULK_STS: "Sign documents with STS",
            CONFIRM_DELETE_TEXT: "Are you sure you want to delete this application? Deleted applications can no longer be accessed!",
            REFRESH_DOCUMENT_BUTTON: "Refresh",
            REFRESH_PAYMENTS_BUTTON: "Refresh",
            OFFLINE_APPLICATION: "Counter",
            ASSIGN_MULTIPLE: "Bulk assignment",
        },
        FIELDS: {
            APPLICATION_TYPE_NAME: "Select application type",
            ORGANISATION_NAME: "Select institution",
            APPLICATION_REGISTER_TYPE_NAME: "Select document type",
            APPLICATION_TYPE_NAME_COLUMN: "Type",
            ORGANISATION_NAME_COLUMN: "Institution",
            APPLICATION_TYPE_PURPOSE: "Select application purpose",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "UAT type",
            PAYMENT: {
                CREATED_DATE: "Registration date",
                AMOUNT: "Amount",
                CURRENCY: "Currency",
                DESCRIPTION: "Details",
                PAYMENT_TYPE: "Payment type",
                STATUS: "Status",
                EMAIL: "Email",
                CLIENT_USER_NAME: "Client name",
                CLIENT_USER_EMAIL: "Client email",
                CLIENT_USER_PERSONAL_NUMERIC_CODE: "CNP",
                PRODUCT_IDENTIFIER_TYPE_DESCRIPTION: "Description",
                BT_PAYMENT_ID: "Transaction ID",
                APPLICATION_TYPE_NAME: "Application type",
                RECEIPT_FILE_ID: "Proof of payment",
            },
            STATUS: "Status",
            LOCALITY: "Municipality / Town / Commune",
            EMPLACEMENT_LOCALITY: "Locality",
            FIRST_NAME: "First name",
            LAST_NAME: "Last name",
            ID_CARD_SERIAL: "ID card series",
            ID_CARD_NUMBER: "ID card number",
            ID_CARD_EXPIRATION_DATE: "Expiry date",
            ID_CARD_ISSUED_DATE: "Issue date",
            ID_CARD_ISSUER: "Issued by",
            EMAIL: "Email",
            PHONE: "Phone",
            SIGNER_FUNCTION_CURRENT: "Current signatory",
            SIGNER_FUNCTION_NEXT: "Next signatory",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Parent application",
            IDENTIFICATION_NUMBER: "Entry code",
            CREATED_DATE: "Created date",
            APPLICATION_DATE: "Entry date",
            LAST_REVIEW_DATE: "Last update",
            ISSUED_DATE: "Completion date",
            RESPONSE_DUE_IN: "Remaining time",
            CADASTRAL_NUMBER: "Cadastral number",
            USER_TYPE_NAME: "Person type",
            PERSONAL_NUMERIC_CODE: "CNP",
            COUNTY: "County",
            VILLAGE: "Locality",
            SECTOR: "Sector",
            STREET: "Street",
            STREET_NUMBER: "Street number",
            POSTAL_CODE: "Postal code",
            STAIRCASE: "Staircase",
            BLOCK: "Block",
            FLOOR: "Floor",
            APARTMENT: "Apartment",
            REAL_ESTATE_TYPE: "Site type",
            AUTHORISATION_CODE: "TNA",
            SUBSIDIARY: "Branch",
            LAND_AREA: "Land area",
            OTHER_IDENTIFICATION: "Other identification",
            CREATED_BY: "Created by",
            FILE_TYPE: "Document type",
            RESOLVED_DATE: "Resolved date",
            PIN: "Confirmation code",
            USE_PROFILE_DATA: "Use profile data",
            PASSPORT_NUMBER: "Passport number",
            CITY: "City",
            ADDRESS: "Address",
            LICENSE: "Licence",
            COMPANY_NAME: "Entity name",
            IBAN: "IBAN account",
            BANK: "Bank",
            UNIQUE_REGISTRATION_CODE: "CIF or CUI",
            REGISTRATION_NUMBER: "Trade Register number",
            FILENAME: "Document name",
            IS_CONTACT_PERSON: "The applicant is the contact person",
            TITLE: "Title",
            MESSAGE: "Message",
            COMMENTS: "Comments",
            CITIZEN_REVIEW: "Please list the changes made to the application",
            ASSIGNED_TO: "Assignee",
            ASSIGNMENT_NOTE: "Assignment note",
            CLARIFICATION_COMMENT: "Remarks",
            MESSAGE_COMMENT: "Your public message",
            CONTACT_PERSON: "Contact person",
            BENEFICIARY: "Beneficiary",
            BENEFICIARY_LEGAL: "Company",
            PAYMENT_STATUS: "Payment",
            IS_PAID: "Payment",
            IS_SIGNED: "Signature",
            TOTAL_TAX: "Total",
            ALLOCATED_DOCUMENT_SERIES: "Exit code",
            FIRST_VIZA_SERIES_NUMBER: "CFP endorsement code",
            SECOND_VIZA_SERIES_NUMBER: "Legality endorsement code",
            REJECTION_VIZA_SERIES_NUMBER: "Rejection endorsement code",
            SCOPE_CU: "Scope",
            PAYMENT_TYPE: "Payment type",
            PAYMENT_TYPE_CARD: "Online card payment",
            PAYMENT_TYPE_OP: "Payment order",
            PAYMENT_TYPE_DISCOUNT: "Payment exemption",
            TRANSACTION_NUMBER: "Transaction number",
            QUICK_SEARCH_VALUES: "Quick search",
            REJECTED_REASON: "Rejection reason - visible only to staff",
            PERSONAL_NUMERIC_CODE_OR_CIF: "CNP/CIF",
            DOCUMENT_SERIES_REGISTERS: "Category / Registers",
            STATUS_RESOLUTION: "Resolution",
            PROJECT_ID: "Project ID",
            CATEGORY_TYPE: "Category",
        },
        ENUMS: {
            STATUS_RESOLUTION: {
                PENDING_DOCUMENT_REGENERATION: "Document regeneration",
                PENDING_APPLICATION_ALLOCATED: "Application assigned",
                PENDING_CLARIFICATION_RESPONSE: "Clarification response",
                PENDING_CLARIFICATION_REJECTED: "Clarification document rejected",
            },
            STATUS: {
                REGISTERED: "Registered",
                NEW: "New",
                PENDING: "Under review",
                RESOLVED: "Resolved",
                REJECTED: "Rejected",
                APPROVED: "In progress",
                DRAFT: "Draft",
                GENERATED: "Generated",
                SIGNED: "Signed",
                SIGN_PENDING: "Pending signature",
                CLOSED: "Completed",
                REVIEW: "In clarification",
                REJECTED_IN_PROGRESS: "Being rejected",
                ERROR: "Error",
                SEALED: "Sealed",
                INTERNAL: "Internal",
                SEAL_ERROR: "Sealing error",
                SEAL_PENDING: "Sealing",
                SIGN_APPLICANT_USER_PENDING: "Pending applicant signature",
                WAITING_FOR_CITIZEN: "Clarification required",
                CLARIFICATION_PENDING: "Clarification under review",
                CLARIFICATION_SIGN_PENDING: "Clarification pending signature",
                CLARIFICATION_SIGNED: "Clarification signed",
                CLARIFICATION_SEALED: "Clarification sealed",
                CLARIFICATION_APPROVED: "Clarification in progress",
                PROCESSED: "Processed",
            },
            REAL_ESTATE_TYPE: {
                LAND: "Land",
                LAND_CONSTRUCTIONS: "Land + buildings",
            },
            PAYMENT_TYPE: {
                DISCOUNT: "Payment exemption",
                LINK: "Link",
                CARD: "Card",
                OP: "Payment order",
                OFFICE: "Cashier's desk",
                MANUAL: "Added payment",
            },
            PAYMENT_STATUS: {
                CREATED: "Pending",
                SUCCESSFUL: "Processed",
                FAILED: "Failed",
            },
            PAYMENT_METHOD: {
                TRANSFER: "Bank transfer",
                CASH: "Cash",
                POS: "Card at the counter",
                OTHER: "Other method",
            },
        },
        PLACEHOLDERS: {
            TYPE_OF_SUBMISSION: "Submitted",
            DIGITALIZED_APPLICATION: "Submitted at the counter",
            ONLINE_APPLICATION: "Submitted online",
            BENEFICIARY: "Natural person's full name",
            BENEFICIARY_LEGAL: "Legal entity name",
            BENEFICIARY_PNC_OR_UNIQUE_CODE: "Beneficiary CNP/CIF",
            SERVICE: "Choose",
            ALLOCATED_STAFF: "Choose",
            IDENTIFICATION_NUMBER: "Entry code",
            APPLICATION_TYPE_NAME: "Application type",
            ORGANISATION_NAME: "Institution",
            CADASTRAL_NUMBER: "CF number",
            APPLICATION_TYPE_PURPOSE: "Application purpose",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            STATUS: "Status",
            COUNTY: "County",
            LOCALITY: "Locality",
            RESPONSE_DUE_IN: "Remaining time",
            VILLAGE: "Locality",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "UAT type",
            CREATED_BY: "Created by",
            EMPLACEMENT_LOCALITY: "Locality",
            COMMENTS: "Comments",
            MESSAGE: "Message",
            ASSIGNED_TO: "Assignee",
            ASSIGNMENT_NOTE: "Note for the assignee (optional)",
            EMAIL: "Email",
            QUICK_SEARCH_VALUES: "Application number",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Parent application",
            DOCUMENT_SERIES_REGISTERS: "Category/Registers",
            PAYMENT: {
                CREATED_DATE: "Registration date",
                AMOUNT: "Amount",
                CURRENCY: "Currency",
                DESCRIPTION: "Details",
                PAYMENT_TYPE: "Payment type",
                STATUS: "Status",
                EMAIL: "Email",
                CLIENT_USER_NAME: "Client name",
                CLIENT_USER_EMAIL: "Client email",
                CLIENT_USER_PERSONAL_NUMERIC_CODE: "CNP",
                PRODUCT_IDENTIFIER_TYPE_DESCRIPTION: "Description",
                BT_PAYMENT_ID: "Transaction ID",
                APPLICATION_TYPE_NAME: "Application type",
            },
            STATUS_RESOLUTION: "Resolution",
        },
        FORM: {
            TITLE: "New application form",
            SUBMIT_BUTTON: "Send application",
            SAVE_AS_DRAFT_BUTTON: "Save as draft",
            CONTINUE_BUTTON: "Continue",
            FILL_APPLICATION_BUTTON: "Fill in application",
            CANCEL_BUTTON: "Cancel application",
            DETAILS_SECTION: "Application details",
            TAXES_BUTTON: "Calculate fees",
            TAXES_ERROR: "Please select the application type and fill in the land area",
            WIZARD_TITLE: "Application submission",
            GO_BACK: "Back",
            GENERATE_DOCUMENT: "Finalise document",
            NO_TEMPLATE: "There is no template for this application type",
            PAY_BUTTON: "Pay",
            SEND_LINK_BUTTON: "Send payment link",
            SIGN_BUTTON: "Sign and submit",
            APPLY_BUTTON: "Submit application",
            SEND_MESSAGE_BUTTON: "Send message",
            PREVIEW_DOC: "Preview",
            SEND_REVIEW: "Send clarifications",
            PENDING_RELATED_APPLICATIONS: "Mayor's approval in progress",
            PENDING_INTERNAL_APPLICATIONS: "Internal documents in progress",
            HELP_DESCRIPTION: "If you need help, visit the",
            HELP_FREQUENT_QUESTIONS: "FAQ",
            DOWNLOAD_BUTTON: "Download",
            VALIDATE_FILE_BUTTON: "Validate and save file",
            GIS_ATTACHMENTS: "GIS attachments",
            GENERATE_BUTTON: "Generate application",
            FINALIZE_BUTTON: "Finalise",
            TAKE_DATA_FROM_CONNECTED_APPLICATIONS: "Retrieve data",
            SIGNATURE_TITLE: "This area is for configuring the document signatories",
            SIGNATURE_DESCRIPTION: "This area is for configuring the document signatories. </br> THE SIGNING ORDER IS FROM BOTTOM TO TOP AND FROM LEFT TO RIGHT. </br> The number indicates the signing order, 1 = first signatory",
            SAVE_AS_DRAFT_TITLE: "Warning: if you leave the page, your changes will be lost!",
            SAVE_AS_DRAFT_CONFIRM: "Do you want to save before continuing?",
        },
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "Application sent",
            CREATED_SUCCESS_TEXT: "Application number {number} has been sent successfully. After analysis and verification, you will be notified about its resolution.",
            DRAFT_SAVED_SUCCESS: "The application has been saved as a draft",
            CHOOSE_SIGN_PACKAGE: "Please choose the signature package",
            OFFLINE_SIGN_FAILED: "The documents are not signed",
            PAYMENT_FAILED: "Payment failed",
            PAYMENT_SUCCESS: "Payment completed successfully",
            INVALID_PROFILE_FOR_SIGNING_TITLE: "The profile data is not valid",
            INVALID_PROFILE_FOR_SIGNING_TEXT: "Please check the CNP and identity card details in the <b>My profile</b> section, which are required for online signing!",
            INVALID_PROFILE_FOR_SIGNING_BUTTON_TEXT: "Go to My profile",
            INVALID_STAFF_ENROLLMENT_TITLE: "An error occurred during the signing process",
            INVALID_STAFF_ENROLLMENT_TEXT: "Please complete your enrolment to be able to sign",
            INVALID_STAFF_ENROLLMENT_BUTTON_TEXT: "Go to My profile",
            DUPLICATE_BENEFICIARY_PNC: "A beneficiary with the same CNP ({pnc}) has already been added.",
            DUPLICATE_BENEFICIARY_REG_CODE: "A beneficiary with the same CIF/CUI ({unique_registration_code}) and CNP has already been added.",
            GENERATE_OFFLINE_PACKAGE: "The application is being downloaded. Please wait!",
            REVIEW_SENT: "The clarifications have been sent",
            REVIEW_NOT_SENT: "An error occurred while sending the clarifications. Please try again",
            UPLOADING_FILES: "The files are being uploaded",
            AUTOSAVE_LOADER_TEXT: "The application is automatically saved 1 time every 10 minutes so that the data you entered is not lost.",
            MISSING_UAT: "The locality selected for the site(s) is not available",
            UNAUTHORIZED_PAYMENT: "We apologise, this application cannot be paid for at the moment. The application type is currently inactive.",
            INACTIVE_APPLICATION_TYPE: "The application type is inactive. This application can no longer be paid for or submitted.",
            GENERATION_ERROR: "An error occurred while generating the document!",
            GENERATION_ERROR_TEXT: "Please try sending the clarifications again.",
            SENDING_ERROR: "An error occurred. Please try submitting the application again later",
            BULK_SIGN_LIMIT: "Please do not select more than {number} applications for bulk signing",
            REVIEW_APPLICATION_TYPE: "Please set the corresponding clarification note in the admin section",
            INVALID_GIS_FILE: "The uploaded file is not valid. Please upload another file!",
            DOC_RECEIVED_BULK_SIGN_LIMIT: "A maximum of {number} documents can be signed at once.",
            TAKE_DATA_FROM_CONNECTED: "Data found in a single related document will be retrieved and will overwrite the current values. Are you sure you want to retrieve the data?",
            CLARIFICATION_SIGNED: "The clarification has been signed and sent successfully.",
        },
        VIEW: {
            TITLE_STAFF: "Applications register",
            TITLE: "Applications",
            SAVE_AS_DRAFT_BUTTON: "Save as draft",
            REASSIGN_STAFF: "Reassign application",
            ASSIGN_STAFF: "Assign application",
            SEARCH_PLACEHOLDER_USERS: "Search by staff member name",
            MODIFY_APPLICATION_TYPE: "Change application type",
            SEND_TO_REVIEW: "Send for consultation",
            REVIEW_STATUS: "Consultation",
            ASSIGN_REVIEWER: "Choose consultant",
            REASSIGN_REVIEWER: "Change consultant",
            SEND_TO_REVIEW_DOCUMENT_MESSAGE: "Are you sure you want to send this document for consultation?",
            SEND_RESPONSE: "Send response",
            APPLICATION_DETAILS_SECTION_TITLE: "Application details",
            BENEFICIARY_DETAILS_SECTION_TITLE: "Beneficiary details",
            BENEFICIARY_DETAILS_TITLE: "Beneficiary",
            REAL_ESTATE_DETAILS_SECTION_TITLE: "Property details",
            REAL_ESTATE_EMPLACEMENT_DETAILS_SECTION_TITLE: "Site details",
            APPLICANT_DETAILS_SECTION_TITLE: "Applicant / designer details",
            PAYMENT_DETAILS_SECTION_TITLE: "Payments",
            ATLAS_DETAILS_SECTION_TITLE: "Territorial Atlas preview",
            ATTACHMENTS_DETAILS_SECTION_TITLE: "Documents",
            CITIZEN_ATTACHMENTS_DETAILS_SECTION_TITLE: "Citizen documents",
            ATTACHMENTS_SECTION_OUTPUT: "Issued documents",
            ATTACHMENTS_SECTION_INPUT: "Submitted documents",
            ATTACHMENTS_SECTION_PUBLIC: "Public documents",
            ATTACHMENTS_SECTION_REVIEW: "Clarifications",
            NEXT_STEP: "Next step",
            SIGN_DOCUMENT: "Sign document",
            SIGN_DOCUMENT_PERSONALIZED: "Sign document with personalised signature",
            SIGN_DOCUMENT_STS: "Sign document with STS",
            ASSIGN_STAFF_MESSAGE: "Are you sure you want to take over this application?",
            APPROVE_DOCUMENT: "Approve",
            REJECT_DOCUMENT: "Reject",
            APPROVE_DOCUMENT_MESSAGE: "Are you sure you want to approve this application?",
            REJECT_DOCUMENT_MESSAGE: "Are you sure you want to reject this application?",
            GENERATE_DOCUMENT_MESSAGE: "Document generated",
            GENERATE_DOCUMENT_ERROR: "The document cannot be generated",
            SIGN_DOCUMENT_ERROR: "The document cannot be signed",
            SIGN_SUCCESS: "Document signed",
            AUTOSAVE_SUCCESS: "Saved successfully",
            AUTOSAVE_FAILED: "Error while saving",
            SEND_CLARIFICATIONS: "Clarification required",
            CREATE_INTERNAL_DOCUMENT: "Create internal document",
            RETURN_DOCUMENT: "Regenerate document",
            RETURN_DOCUMENT_MESSAGE: "Are you sure you want to return this document? This action is irreversible and requires the document to be regenerated.",
            SIGN_ATTACHMENTS_BUTTON: "Sign attachments",
            SIGN_ATTACHMENTS_BUTTON_PERSONALIZED: "Sign attachments with personalised signature",
            SIGN_ATTACHMENTS_BUTTON_STS: "Sign attachments with STS",
            DOWNLOAD_COMPRESSION: "Download .zip",
            VIEW_INTERNAL_DOCUMENTS: "View internal documents",
            CLOSE_APPLICATION: "Complete application",
            CREATE_PAYMENT_LINK: "Send payment link",
            UPLOAD_FILES: "Please upload the required documents in the Attachments section below",
            PROCESS_ERROR: "Process error",
            SUBPROCESS_ERROR: "Sub-process error",
            START_PROCESS: "Start process",
            START_SUBPROCESS: "Start sub-process",
            SEAL_ATTACHMENTS_BUTTON: "Seal attachments",
            ASSIGN_MULTIPLE_DIFFERENT_APPLICATION_TYPE_ERROR: "Applications can only be bulk-assigned if they are of the same type.",
            SEND_TO_CLARIFICATION_MESSAGE: "The clarification process has been started",
            SEND_TO_CLARIFICATION_CITIZEN_MESSAGE: "Clarification sent",
            SEND_CLARIFICATION_ERROR: "Error while sending the clarification",
            WAITING_FOR_CITIZEN: "Awaiting the citizen's response",
            CLARIFICATION_REVIEW_STATUS: "In clarification",
            FORM_DATA_ERROR: "An error occurred while generating the form data",
            FILE_UPLOAD_ERROR: "An error occurred while uploading the files",
            CLARIFICATION_ID_MISSING: "The clarification could not be identified",
            PREVIEW_DOCUMENT_ERROR: "The document cannot be previewed",
            SEAL_DOCUMENT_ERROR: "The documents cannot be sealed",
        },
        INIT_SIGN_MODAL: {
            TITLE: "Personalise digital signature",
            MESSAGE: "Add a complementary image to the signature",
            MAX_FILE_SIZE: "Maximum 10MB (png, jpg, jpeg)",
            FILE_UPLOAD_INFO_MESSAGE: "Drag and drop the image or click to upload",
            FILE_UPLOAD_ERROR_INVALID: "The file is invalid!",
            FILE_UPLOAD_ERROR_SIZE: "The file is too large!",
        },
        CONFIRM_SIGN_MODAL: {
            TITLE: "Digital signature validation",
            MESSAGE_SENT: "An SMS has been sent to the phone number <strong>{0}</strong>. Enter the code you received to sign the application using the electronic signature and send the application.",
            STS_SIGNING: "You will receive an email or a push notification in the StSign mobile app (if you selected confirmation). Authorise it, then sign the application.",
        },
        REJECT_VIZA_MODAL: {
            REJECTION_TITLE: "Endorsement rejection",
            REJECTION_COMMENT: "Rejection reason: ",
        },
        GENERATE_REPORT_MODAL: {
            DEFAULT_COLUMNS: {
                STATUS: "Status",
                PROJECT_IDS: "Project ID",
                APPLICATION_TYPE_NAME: "Application type",
                IDENTIFICATION_NUMBER: "Identification number",
                APPLICATION_DATE: "Application date",
                TERRITORIAL_ADMINISTRATIVE_UNIT_NAME: "UAT",
                REAL_ESTATE_TARGET: {
                    COUNTY: "County",
                    TERRITORIAL_ADMINISTRATIVE_UNIT: "Territorial administrative unit",
                    LAND_AREA: "Area",
                },
                PAYMENT_DATE: "Payment date",
                TOTAL: "Total",
                ORDER_NUMBER: "Order number",
                ISSUED_DATE: "Issue date",
                ALLOCATED_DOCUMENT_SERIES: "Allocated document series",
                OP_PAYMENT_ID: "Payment id (OP)",
                PAYMENT_DETAILS: {
                    PAYMENT_TYPE: "Payment type",
                    PAYMENT_DATE: "Payment date (OP)",
                },
            },
            GENERATE: "Generate",
            NAME_DESCRIPTION: "Select an existing predefined report or enter a new name",
            NAME: "Name",
            NAME_PLACEHOLDER: "Enter or choose",
            APPLICATION_TYPE_PLACEHOLDER: "Select one or more types",
            APPLICATION_TYPE_NAME: "Application type",
            APPLICATION_TYPE_NAME_PLACEHOLDER: "Choose",
            DATE_RANGE: "Report period",
            COLUMNS: "Report columns",
            SAVE_AS_PREDEFINED: "Save as predefined report",
            MAX_APPLICATION_TYPES_TITLE: "Maximum number of types",
            MAX_APPLICATION_TYPES_TEXT: "A maximum of 5 types can be selected for a report",
            MAX_COLUMNS_TITLE: "Maximum number of columns",
            MAX_COLUMNS_TEXT: "A maximum of 50 columns can be selected for a report",
            INVALID_DATE_RANGE_TITLE: "Invalid date range",
            INVALID_DATE_RANGE_TEXT: "Select a valid start and end date",
            END_BEFORE_START_TEXT: "The end date must not be before the start date",
        },
        TABS: {
            APPLICATION: "Application details",
            DOCUMENTS: "Documents",
            ACTIVITY: "Activities",
            ACTIVITY_SUBTAB_ACTIVITIES: "Activities",
            ACTIVITY_SUBTAB_COMMENTS: "Comments",
            PAYMENTS: "Payments",
            DOCUMENT_CREATED: "Submitted documents",
            DOCUMENT_RECEIVED: "Issued documents",
            DOCUMENT_PUBLIC: "Public documents",
            DOCUMENT_REVIEW: "Clarifications",
            DOCUMENT_INTERNAL: "Internal",
            REAL_ESTATE: "Property",
            TAXES: "Fees",
            BENEFICIARY: "Beneficiary",
            NEW_APPLICATION: "Details",
            SIGN: "Signature",
            SUMMARY: "Summary",
            CERTIFICAT_URBANISM: "Urbanism certificate",
            APPLICATION_FORM: "Fill in application",
            REGISTRY_DETAILS: "Registration details",
            CLARIFICATIONS: "Clarifications",
        },
        TERRITORIAL_ATLAS: {
            HEADER: "Territorial Atlas preview",
            SUBTITLE: "The map is populated as sites are added.",
            GENERATE_BUTTON: "Refresh",
            REAL_ESTATES_LABEL: "View site",
            PLACEHOLDER: "Enter the property details, then press the “Generate” button to preview the map.",
            NOT_FOUND: "Sorry, the cadastral number was not found. Please try again!",
            ERROR: "Sorry, the synchronisation was unsuccessful. Please try again!",
            INACTIVE: "The cadastral number is inactive in ANCPI records.",
            PRESET_SELECT_PLACEHOLDER: "Layer visibility preset",
        },
        PAYMENT: {
            SECTION_TITLE: "Pay",
            TITLE: "Choose the payment method",
            HELP_TEXT_CARD: "For online submission of the application, the fees can be paid online by bank card. The payment process can be completed remotely, and for this you need to confirm the payment according to the settings of the bank that issued the card.",
            HELP_TEXT_LINK: "For online submission of the application, the fees can be paid by the actual beneficiary via a payment link sent by email to the specified address. The payment can be made remotely, online, by bank card, by opening the link received at the beneficiary's email address.",
            HELP_TEXT_EXEMPT: "The chosen exemption covers all fees; no payment method is needed.",
            HELP_TEXT_NO_FEES: "This application has no fees to pay; no payment method is needed.",
            STATUS_PAID: "paid",
            STATUS_UNPAID: "unpaid",
            STATUS_UNPROCESSED: "unprocessed",
            SELECT: {
                ONLINE: "bank card",
                LINK: "beneficiary link",
            },
            RECEIPT_DEFAULT_FILE_NAME: "Proof of payment.pdf",
            LINK_EMAIL_REQUIRED: "The beneficiary's email address is required to send the payment link.",
        },
        PAYMENT_ORDER: {
            FIELDS: {
                ORDER_NUMBER: "Order number",
                PAYMENT_DATE: "Payment date",
            },
        },
        PAYMENT_LINK: {
            TITLE: "Payment link",
        },
        MANUAL_PAYMENT: {
            ACTIONS: {
                RECORD: "Record the payment",
                ADD: "Add a received payment",
                CHECK: "Check with the bank",
                HISTORY: "History",
            },
            HINTS: {
                VALID_UNTIL: "expires on {date}",
                LINK_EXPIRED: "expired on {date}",
                INITIAL_TYPE: "initially: {type}",
                ADDED: "added payment",
                PREVIOUS_STATUS: "previously: {status}",
                RECORDED_BY_INSTITUTION: "Recorded by the institution",
                RECORDED_MANUALLY: "recorded manually",
            },
            LABELS: {
                AMOUNT: "Amount",
                STATUS: "Status",
                STATUS_NOW: "Current status",
                STATUS_BEFORE: "Previous status",
                INITIAL_TYPE: "Initial type",
                SENT_TO: "Sent to",
                VALID_UNTIL: "Valid until",
                REQUEST_DATE: "Request date",
            },
            FORM: {
                RECORD_TITLE: "Record the payment",
                ADD_TITLE: "Add a received payment",
                APPLICATION: "Application {number}",
                PAYMENT_REQUEST: "Payment request",
                REQUEST_LINK: "Link sent to {email}",
                REQUEST_CARD: "Card payment",
                AMOUNT_DUE: "Amount due",
                APPLICATION_TOTAL: "Application total",
                COLLECTED_SO_FAR: "Received so far",
                METHOD: "Payment method",
                PAID_AT: "Payment date",
                DOCUMENT_NUMBER: {
                    TRANSFER: "Payment order no.",
                    CASH: "Receipt no.",
                    POS: "POS slip no.",
                    OTHER: "Document no.",
                },
                OPTIONAL: "optional",
                METHOD_DESCRIPTION: "Describe the method",
                AMOUNT: "Amount received",
                DESCRIPTION: "Details",
                DESCRIPTION_DEFAULT: "Fees",
                PAYER: "Payer",
                PROOF: "Proof of payment",
                NOTE: "Notes",
                SUBMIT_RECORD: "Record the payment",
                SUBMIT_ADD: "Add the payment",
                PAID_AT_FUTURE: "The payment date cannot be in the future.",
                AMOUNT_INVALID: "The amount must be above zero, with at most two decimals.",
                NOTE_TOO_LONG: "At most {max} characters.",
                PENDING_WARNING: "This application has a pending payment of {amount}, from {date}. If the payment you are adding is that one, cancel and use “Record the payment” on its row.",
                PENDING_WARNING_MANY: "This application has several pending payments: {payments}. If the payment you are adding is one of them, cancel and use “Record the payment” on its row.",
                PENDING_ITEM: "{amount} from {date}",
                CONFIRM_RECORD: "Record the payment of {amount} by {method} for application {application}?",
                CONFIRM_ADD: "Add a received payment of {amount}, {method}, for application {application}?",
                RECORDED: "The payment was recorded.",
                ADDED: "The payment was added.",
                PROOF_UPLOAD_FAILED: "The file could not be uploaded. Nothing was saved. Try again or remove the file.",
            },
            HISTORY: {
                TITLE: "Payment history",
                EMPTY: "No history for this payment.",
                ACTORS: {
                    BANK: "The bank",
                    SYSTEM: "System",
                    CITIZEN: "Applicant",
                    STAFF: "Staff member",
                },
                EVENTS: {
                    LINK_SENT: "Payment link sent",
                    CARD_STARTED: "Card payment started",
                    PAID_ONLINE: "Paid online",
                    FAILED_AT_BANK: "Failed at the bank",
                    EXEMPTION: "Payment exemption",
                    RECORDED: "Payment recorded manually",
                    ADDED: "Payment added",
                    BANK_CHECKED: "Checked with the bank",
                },
                DETAILS: {
                    EXEMPTION: "the application has no fees to pay",
                },
                BANK_RESULTS: {
                    CONFIRMED: "The bank confirmed the payment.",
                    NOT_PAID: "The bank has recorded no payment.",
                    EXPIRED: "The payment was not made. The order expired at the bank.",
                    DECLINED: "The payment was not made. The bank declined it or the attempts ran out.",
                    REFUNDED: "The bank reports the amount as returned to the payer.",
                    UNAVAILABLE: "The bank did not answer.",
                    ALREADY_PROCESSED: "The payment was already processed.",
                },
            },
            CHECK: {
                CONFIRMED_TITLE: "The bank confirms the payment",
                CONFIRMED_TEXT: "The payment of {amount} was marked “Processed” and the application shows as paid.",
                NOT_PAID_TITLE: "The bank has recorded no payment",
                NOT_PAID_TEXT: "Nothing was changed.",
                NOT_PAID_TEXT_LINK: "The link is valid until {date}. Nothing was changed.",
                NOT_PAID_TEXT_LINK_EXPIRED: "The link expired on {date}. Nothing was changed.",
                EXPIRED_TITLE: "The payment was not made",
                EXPIRED_TEXT: "The order expired at the bank. You can record the payment if it was made another way.",
                EXPIRED_TEXT_LINK: "The link expired at the bank. You can send a new link, or record the payment if it was made another way.",
                DECLINED_TITLE: "The payment was not made",
                DECLINED_TEXT: "The bank declined the payment or the attempts ran out. You can record the payment if it was made another way.",
                DECLINED_TEXT_LINK: "The bank declined the payment or the attempts ran out. You can send a new link, or record the payment if it was made another way.",
                REFUNDED_TITLE: "The amount was returned",
                REFUNDED_TEXT: "The bank reports that the amount was paid and then returned to the payer. Nothing was changed.",
                UNAVAILABLE_TITLE: "The bank did not answer",
                UNAVAILABLE_TEXT: "Try again in a few minutes. Nothing was changed.",
                ALREADY_PROCESSED_TITLE: "The payment is already processed",
                ALREADY_PROCESSED_TEXT: "The application was brought up to date.",
            },
            BANNER: {
                TEXT: "The payment status of the application does not match the payments in the list.",
                BUTTON: "Update the application",
                DONE: "The application was updated.",
                UP_TO_DATE: "The application is already up to date with its payments.",
            },
        },
        DISCOUNTS: {
            TITLE: "Choose a payment exemption",
            NO_DISCOUNT: "No exemption",
            HELP_TEXT: "For online submission of the application, an exemption from the payment of fees may be applied in accordance with the fiscal code and the laws in force.",
            DESCRIPTION_HEADER: "The exemption applies only to:",
            DESCRIPTION_WARNING: "For the exemption to be applied successfully, supporting documents must be attached to this application.",
        },
        MODALS: {
            ADD: "Add",
            CANCEL: "Cancel",
            SAVE: "Save",
            SIGN_STATUS: {
                TITLE: "Signing status",
                IDENTIFICATION_NUMBER: "Entry code",
                LOCALITY: "Municipality/Town/Commune",
                SIGNING_BY: "Currently being signed at:",
                LAST_SIGNING_DATE: "Last signing date",
                CITIZEN_SIGNING: "Citizen",
                LAST_SIGNING_DATE_CITIZEN: "Citizen signing date",
            },
            COMMENT_TITLES: {
                APPROVE: "Approved by: {userName}, comment: {comment}",
                REJECT: "Rejected by: {userName}, reason: {comment}",
                RETURN: "Regenerated by: {userName}, reason: {comment}",
                REJECT_VIZA: "Rejected by: {userName}. ",
            },
        },
        SIGNATURE: {
            TITLE: "Choose the signing method",
            SECTION_TITLE: "Sign applications and attachments",
            TABS: {
                ONLINE: "Online signing",
                OFFLINE: "Offline signing",
            },
            ONLINE: {
                HELP_TEXT: "For online submission, the application will be signed digitally using a digital signature. The signing process can be completed remotely, and for this you need a digital signature.",
                INFO_TEXT: "To facilitate the purchase of the digital signing certificate from certSIGN, we will use the identification data from your account. You will provide it only once, and based on it a unique identification code will be created that guarantees the authenticity of your requests.",
                PACKAGE_LABEL: "Their cost will be included in the total.",
                SUMMARY_DIGITAL_SIGNATURE_LABEL: "Digital signatures",
                SUMMARY_REQUIRED_SIGNATURES: "Required",
                SUMMARY_AVAILABLE_SIGNATURES: "Available",
                SUMMARY_LEFTOVER_SIGNATURES: "Remaining",
                SUMMARY_TEXT: "Remote electronic signature",
            },
            OFFLINE: {
                HELP_TEXT: "Choose \"ONLINE SIGNING\" if you want to purchase a certificate for the required digital signatures, or \"OFFLINE SIGNING\" if you already have one from an authorised provider.",
                INFO_TEXT: "Download the document to your device, sign it and upload the document to continue. Please note: a digital signature validated with a qualified certificate is required, not a simple electronic (or handwritten) one.",
                ACTION_DOWNLOAD_TITLE: "Download the application",
                ACTION_DOWNLOAD_SUBTITLE: "which must be digitally signed",
                ACTION_UPLOAD_TITLE: "Upload the application",
                ACTION_UPLOAD_SUBTITLE: "which must be digitally signed",
                STEP_DOWNLOAD: "Download",
                STEP_SIGN: "Sign",
                STEP_VERIFY: "Verification",
                STEP_CHECKED: "Documents OK",
                SUMMARY_TEXT: "Personal electronic signature",
                UPLOAD_NOTIFICATION: "Once the signed documents are uploaded, the application can no longer be modified. Are you sure you want to continue?",
            },
            OFFICE: {
                SUMMARY_TEXT: "Handwritten signature",
            },
        },
        CLARIFICATION_MODAL: {
            TITLE: "Send response",
        },
        SEND_REVIEW_MODAL: {
            TITLE: "Send clarification request",
        },
        SUMMARY: {
            SIGN_TYPE_TITLE: "Signing method",
            APPLICATION_DETAIL_TITLE: "Application details",
            PAYMENT_TYPE_TITLE: "Payment method",
            SIGN_TYPE_FOOTER: "Provided by CertSign",
            APPLICATION_OBJECTIVE: "Application objective",
            APPLICANT: "Applicant",
            PAYMENT_TYPE: "Online card payment",
            PAYMENT_TYPE_OP: "Payment order",
            PAYMENT_TYPE_LINK: "Payment link",
            FILE_NAME: "Payment order",
            PAYMENT_TYPE_HELP_TEXT: "After initiating the payment, you will be redirected to the payment processor to complete the payment.",
            PAYMENT_TYPE_HELP_TEXT_FAILED: "The payment could not be completed.",
            PAYMENT_TYPE_HELP_TEXT_SUCCESS: "The payment was completed successfully.",
            PAYMENT_TYPE_LINK_HELP_TEXT_SUCCESS: "The payment link was sent successfully.",
            PAYMENT_TYPE_LINK_HELP_TEXT: "A payment link will be sent to the specified email address, which will redirect the beneficiary to the payment processor to complete the payment.",
            PAYMENT_TYPE_HELP_OP_TEXT_SUCCESS: "The payment order was uploaded successfully.",
            PAYMENT_DISCOUNT: "Payment exemption",
            PAYMENT_DISCOUNT_TEXT: "You are exempt from payment. After confirmation, you will be redirected to the application page.",
            PAYMENT_DISCOUNT_TEXT_SUCCESS: "The payment exemption has been recorded.",
            PAYMENT_NO_FEES: "No fees",
            PAYMENT_NO_FEES_TEXT: "This application has no fees to pay. After confirmation, you will be redirected to the application page.",
            PAYMENT_NO_FEES_TEXT_SUCCESS: "This application had no fees to pay.",
            DETAILS: "Breakdown",
            CERTIFICATE_TOTAL_TAXES: "Total digital certificate costs",
            TOTAL_TAXES: "Total fees and approvals",
            SECTION_TITLE: "Review and send application",
            TOTAL: "Total",
            SELECTED_REAL_ESTATES_TEXT: "no property selected | + 1 property selected | + {count} properties selected",
            PAY_AS_YOU_GO_SUMMARY_TEXT: "Digital signature",
            TAX_TEXT: "Fee",
            DISCOUNT: "Exemption",
        },
        ENROLLMENT_DETAILS: {
            PERSON: {
                HEADER: "Person type",
                INDIVIDUAL: "Natural person",
                LEGAL: "Legal entity",
            },
            CITIZENSHIP: {
                HEADER: "Citizenship",
                ROMANIAN: "Romanian citizen",
                FOREIGNER: "Foreign citizen",
            },
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Home address",
            CONTACT: "Contact",
            ADDRESS_COUNTY: "County",
            ADDRESS_STREET: "St.",
            ADDRESS_NUMBER: "no.",
            ADDRESS_STAIRCASE: "staircase",
            ADDRESS_APARTMENT: "apt.",
        },
        SEND_SUCCESS_TITLE: "Congratulations, your application was sent without wasting any paper! So far we have saved <span>{treeNumbers}</span> trees.",
        SEND_SUCCESS_TEXT: "Application number <strong>{number}</strong> has been registered successfully.</br> Once we have analysed and verified it, you will be notified (here and by email) about its resolution.",
        PAYMENT_SUCCESS_TITLE: "The payment was recorded successfully.",
        PAYMENT_FAILED_TITLE: "The payment could not be processed.",
        PAYMENT_SUCCESS_TEXT: "The payment does not automatically complete the application. Continue to sign and submit the application.",
        PAYMENT_FAILED_TEXT: "You can retry the payment from the application.",
        PAYMENT_FAILED_LINK_TEXT: "Contact the institution to receive a new payment link.",
        PAYMENT_STEP_PAY: "Payment",
        PAYMENT_STEP_SIGN: "Signing",
        PAYMENT_STEP_SUBMIT: "Submission",
        MISSING_PAYMENT_CALLBACK_PAYLOAD: "An error occurred while processing the payment, please try again.",
        RESPONSE_MODAL: {
            APPROVE_APPLICATION_TITLE: "Approval notification",
            REJECT_APPLICATION_TITLE: "Rejection reason",
        },
        MODIFY_APPLICATION_TYPE_MODAL_TITLE: "Change application type",
        MODIFY_APPLICATION_TYPE_MODAL_LABEL: "Application type",
        MODIFY_APPLICATION_TYPE_MODAL_PLACEHOLDER: "Select a new type",
        ASSIGN_MODAL_TITLE: "Assign application",
        ASSIGN_REVIEWER_MODAL_TITLE: "Choose consultant",
        APPROVE_REJECT_MODAL_TITLE: "Consultation response",
        ASSIGN_SUCCESS: "The application was successfully assigned to <strong>{name}</strong>!",
        ASSIGN_ERROR: "The application could not be assigned to <strong>{name}</strong>",
        ASSIGN_MULTIPLE_SUCCESS: "The {count} selected applications were successfully assigned to <strong>{name}</strong>!",
        ASSIGN_MULTIPLE_ERROR: "The {count} selected applications could not be assigned to <strong>{name}</strong>",
        SIGN_CONFIRMATION: {
            INVALID_PIN: "The code is not valid, please try again",
            PIN_EXPIRED: "The code has expired, please try again",
            SESSION_EXPIRED: "The session has expired, please try again",
            ERROR: "An error occurred, please try again",
            BULK_FAILED: "The following applications cannot be signed {0}",
        },
        SIGN_AND_APPLY_LOADER: {
            TITLE: "Submission takes a few moments",
            TEXT: "Please wait, the application is being submitted and this may take a few minutes, without wasting paper or time.",
        },
        UPLOAD_DOCUMENTS_MODAL: {
            TITLE: "Add documents",
        },
        CREATE_PAYMENT_MODAL: {
            TITLE: "Create payment",
            BUTTON: "Send",
        },
        DELETE_CONFIRMATION: "Are you sure you want to delete this document?",
        INFO_TEXT: {
            FIRST_CITIZEN_REVIEW_DATE: "First clarification received",
            LAST_CITIZEN_REVIEW_DATE: "Last clarification received",
            FIRST_STAFF_REVIEW_DATE: "First clarification sent",
            LAST_STAFF_REVIEW_DATE: "Last clarification sent",
        },
        COPY_FILE_MODAL: {
            TITLE: "Set file name",
        },
        BULK_COPY_FILE_MODAL: {
            TITLE: "Select files to copy",
            CONFIRM_MSG: "Are you sure you want to copy all the files?",
        },
        DYNAMIC_FORMS: {
            GENERATE_BUTTON: "Generate",
            CONFIGURE_POSITIONS: "Signature configuration area",
            CONFIGURE_POSITIONS_DESCRIPTIONS: "Area dedicated to configuring the signatures that will appear on the final document and the signing order. </br> This digitised process replaces the classic physical signature folder.",
            NUMBER_OF_ROWS: "Rows",
            NUMBER_OF_COLUMNS: "Columns",
            SIGN_TEXT_PREFIX: "Signature",
            SIGN_TEXT_ASSIGNED_STAFF: "Assigned staff member",
            ADD_SIGNATURE: "Choose signatory",
            SELECT_SIGNATURE: "Search signature",
            SAVE_CHANGES: "Save changes",
            SAVE_AS_NEW_TEMPLATE: "Save as new template",
            TEMPLATE_NAME: "Template name",
            TEMPLATE_INFO_TEXT: "Select a previously defined template or enter a new name",
            TEMPLATE_PLACEHOLDER: "Choose template",
            OVERWRITE_WARNING: "Saving the changes will overwrite the selected template. Do you want to continue?",
            SELECT_AT_LEAST_ONE_TEMPLATE: "Select the template you want to save the changes to",
            CONFIGURE_AT_LEAST_ONE_SIGNATURE: "Configure at least one signature to be able to save the changes",
            NO_TEXT_IN_DOCUMENT: "Please enter text in the document before generating",
            SIGNATURES_LOST: "Changing the row or column configuration will discard the signatures already configured. Do you want to continue?",
            DOCUMENT_DETAILS_TITLE: "Document details",
            DOCUMENT_DETAILS_DESCRIPTION: "Area dedicated to the document content",
            SELECT_TEMPLATE_DESCRIPTION: "Choose a predefined template to load the content and signatories",
            INFO_TITLE: "Instructions for configuring signatures on electronic forms - Ghișeul Unic",
            INFO_DESCRIPTION: "<div style='text-align: left'>On the right-hand side of the application interface is the section for <b>configuring the signatures</b> that will be applied to the generated document. </br></br> <b>Signing order (approval flow)</b> </br> </br> <li>The signing index assigned to each person determines the order in which the signatures are applied to the document.</li> <li>Example: <ul style='margin-top: 8px'>The person with index <b>1</b> signs first.</ul><ul>The person with index <b>2</b> signs second, and so on.</ul></li><li>This index can be changed manually in the configurator after the signatures have been added.</li> </br> <b>Display order in the document (visual position)</b> </br> </br> <li><b>The position of the signatures on the page</b> is determined by <b>the order in which they appear in the configurator list</b>, regardless of the index.</li> <li>This order determines how the signatures are arranged in a column or in rows, depending on the chosen format.</li> </br> <b>Mandatory rule: the President's position</b> </br> </br> <li>The President must always be first in the list, i.e. the first signature displayed visually on the document, at the top or on the left (depending on the layout).</li><li>This position is NOT affected by the signing index.</li><li>Even if the President signs last, they must appear first in the displayed signature list.</li></div>",
            GENERATE_SUCCESS: "Generation completed successfully",
            SAVE_DRAFT_SUCCESS: "Draft saved",
            TEMPLATE_SUCCESS: "Template saved",
            SAVING_DOCUMENT: "The document is being generated, do not reload the page.",
            PRESIDENT_POSITION_WARNING: "The President's signature must be on the first line",
            MAX_ROWS_COLS_MESSAGE: "Please configure a minimum of 1 and a maximum of 7 rows",
            GENERIC_ERROR_MESSAGE: "An error occurred. Please try again.",
            NO_SIGNATURES: "The document has no signature attached. Please add at least one signature.",
            PRESIDENT_SIGNATURE_WARNING: "The President's signature must be added on the first line (at the top), and the President must sign last, having the highest index in the signing order.",
        },
        CLARIFICATIONS: {
            NO_CLARIFICATIONS: "No clarifications for this application",
            NO_SCHEMA: "Form schema is not available",
            STAFF_REQUEST: "Clarification request from staff",
            CITIZEN_RESPONSE: "Citizen response",
            NO_CITIZEN_RESPONSE: "The citizen has not yet responded to this clarification request",
        },
        FILTERS: {
            PROJECT_ID_ADD: "Add",
            PROJECT_ID_INVALID: "Invalid characters for the filter: ",
            PROJECT_ID_DUPLICATE: "This filter is a duplicate",
        },
    },
    ARCHIVE: {
        BUTTONS: {
            MANUAL_ARCHIVE: "Manual archiving",
            ADD_WORKSPACE: "Add workspace",
            DOWNLOAD: "Download",
        },
        MENU: {
            DASHBOARD: "Dashboard",
            DOCUMENTS: "Documents",
            ADMINISTRATION: "Administration",
        },
        WORKSPACE: {
            LIST: {
                TITLE: "Workspaces",
            },
            FIELDS: {
                NAME: "Name",
                ENTITY_TYPE: "Type",
                CREATED_DATE: "Archived",
                DIMENSION: "Size",
                FOLDERS_NUMBER: "No. of folders",
                DESCRIPTION: "Description",
            },
            PLACEHOLDERS: {
                NAME: "Name",
                ENTITY_TYPE: "Type",
                CREATED_DATE: "Archived",
            },
            FORM: {
                EDIT_TITLE: "Edit workspace",
                ADD_TITLE: "Add workspace",
            },
        },
        SUBFOLDER: {
            LIST: {
                TITLE: "Documents",
            },
            FIELDS: {
                NAME: "Name",
                TYPE: "Type",
                CREATED_DATE: "Archived",
                DIMENSION: "Size",
                DOCUMENT_NUMBER: "No. of documents",
                WORKSPACE: "Workspace",
                DESCRIPTION: "Description",
                DOCUMENT_TYPE_CODE: "Document type",
            },
            PLACEHOLDERS: {
                NAME: "Name",
                ACHIVE_DATE: "Archived",
            },
            ACTIONS: {
                EDIT: "Edit folder",
                ADD: "Add folder",
            },
            FORM: {
                WORKSPACE: "Workspace",
                TYPE: "Related document type",
                NAME: "Folder name",
            },
        },
        DOCUMENTS: {
            LIST: {
                TITLE: "Documents",
            },
            FIELDS: {
                DOCUMENT_NAME: "Name",
                DOCUMENT_TYPE_NAME: "Type",
                DOCUMENT_SIZE: "Size",
                CREATED_DATE: "Created date",
                UPDATED_DATE: "Modified date",
            },
            PLACEHOLDERS: {
                NAME: "Name",
                ACHIVE_DATE: "Archived",
            },
            ACTIONS: {
                EDIT: "Edit folder",
                ADD: "Add folder",
            },
        },
        DOCUMENT: {
            TITLE_MANUAL_ARCHIVE: "Manual archiving",
            TITLE_VIEW_ARCHIVE: "View archive",
            HEADERS: {
                ATTACHMENTS: "Attachments",
                DETAILS: "Details",
                METADATA: "Metadata",
            },
            FIELDS: {
                WORKSPACE: "Workspace",
                DOCUMENT_NAME: "Document name",
                DOCUMENT_FOLDER: "Folder",
                DOCUMENT_TYPE: "Document type",
            },
        },
        CONFIRMATION_TEXT: "For data consistency, please check that the data is valid and matches the archived documents. For any later changes, please contact a system administrator. Are you sure you want to save the document?",
        MESSAGES: {
            SUCCESS: "Manual archiving completed successfully!",
            ERRORS: "Error during manual archiving!",
        },
        ATTACHMENTS: {
            PLACEHOLDER: "files selected",
            EMPTY: "There are no attached documents.",
            EMPTY_WARNING: "To save, the archive must contain attached files.",
            LABEL: "File",
            ADD_BUTTON: "Add attachment",
        },
        REPORTS: {
            WORKSPACE_LABEL: "Workspace",
            WORKSPACE_DIMENSION: {
                TITLE: "Total archived space",
                DESCRIPTION: "Workspace report",
            },
            EXPIRATION: {
                TITLE: "Expiry deadline",
                DESCRIPTION: "Documents about to expire",
                MONTHLY: "This month",
                WEEKLY: "This week",
            },
            WORKSPACE_DOCUMENTS: {
                TITLE: "Total number of archived documents",
                DESCRIPTION: "Workspace report",
            },
            WORKSPACE_FOLDERS_DIMENSION: {
                TITLE: "Size per folder",
                DESCRIPTION: "Including subfolders",
            },
            WORKSPACE_FOLDERS_DOCUMENTS: {
                TITLE: "Documents per folder",
                DESCRIPTION: "Including subfolders",
            },
            SHARES: {
                OTHER_FOLDERS: "Other folders ({count})",
                OTHER_WORKSPACES: "Other workspaces ({count})",
                SHOW_ALL_FOLDERS: "Show all folders ({count})",
                SHOW_ALL_WORKSPACES: "Show all workspaces ({count})",
                SHOW_FEWER: "Show fewer",
            },
            WORKSPACE_PROGRESS_ANNUAL: {
                TITLE: "Archiving progress",
                DESCRIPTION: "Documents and size archived in the chosen period",
                TOTAL_DESCRIPTION_DOC: "Documents in the selected period",
                TOTAL_DESCRIPTION_DIMENSION: "Size in the selected period",
                Y_AXIS_DOC: "Documents",
                Y_AXIS_DIMENSION: "Size",
                RANGE_HINT: "The range is counted in whole months.",
                RANGE_REQUIRED: "Choose the range to display.",
                BACKFILL: {
                    ONE: "History is still being computed ({done} of {total} month)",
                    FEW: "History is still being computed ({done} of {total} months)",
                    OTHER: "History is still being computed ({done} of {total} months)",
                },
                SNAPSHOT_REFRESHED_AT: "Statistics updated on {date}",
                MONTHS_REFRESHED_AT: "months updated on {date}",
            },
            NO_DATA: "No data for the current selection.",
            STATE: {
                COMPUTING: "The statistics are being computed and will be available soon.",
                NO_WORKSPACES: "You do not have access to any archive workspace.",
                WORKSPACES_ERROR: "The workspace list could not be loaded from the archive.",
                STATS_ERROR: "The archive statistics could not be loaded.",
                RETRY: "Retry",
            },
        },
        PERIOD: {
            CURRENT_MONTH: "Current month",
            LAST_3_MONTHS: "3 months",
            LAST_12_MONTHS: "12 months",
            YEARLY: "Yearly",
            RANGE: "Custom range",
        },
    },
    FORMS: {
        LIST: {
            TITLE: "Form interfaces",
            ADD_BUTTON: "Add form",
            TABLE_HEADER: "Form interface models",
        },
        FIELDS: {
            NAME: "Name",
            STATUS: "Status",
            DESCRIPTION: "Description",
            TRANSLATABLE: "Translate automatically (HU, EN)",
        },
        BUTTONS: {
            ADD: "Add",
            DELETE: "Delete",
        },
        PLACEHOLDERS: {
            NAME: "Name",
            STATUS: "Status",
        },
        ENUMS: {
            STATUS: {
                DRAFT: "Draft",
                PUBLISHED: "Published",
            },
        },
        CREATE_MODAL: {
            TITLE: "Save form interface",
        },
        COMPONENTS: {
            FIELDS: {
                input: "Text field",
                textarea: "Text area",
                number: "Number",
                radio: "Radio",
                checkbox: "Checkbox",
                time: "Time",
                date: "Date",
                rate: "Rating",
                color: "Colour",
                select: "Select",
                switch: "Switch",
                slider: "Slider",
                text: "Text",
                blank: "Custom",
                fileupload: "File",
                imgupload: "Image",
                editor: "Editor",
                cascader: "Cascader",
                table: "Sub-table",
                grid: "Grid",
                section: "Section",
                inline: "Inline",
                tabs: "Tabs",
                divider: "Divider",
                file: "File",
                html: "HTML",
                "beneficiary-list": "Beneficiary",
                "applicant-form": "Applicant",
                "application-detail-form": "Application details",
                "real-estate-list": "Property",
                "decision-list": "Decisions",
                attachments: "Attachments",
                "urbanism-regulation-picker": "Regulations",
                "related-application": "Related documents",
                "offender-list": "Offender",
                "witness-list": "Witness",
                "realty-list": "Building details",
                "staff-form": "Staff member details",
                "gis-attachments": "GIS attachments",
                "ac-tax-validator": "Minimum investment value",
                richtexteditor: "HTML editor",
                "locality-list": "Site details",
                "buildings-list": "Building bodies",
                "urbanism-regulations-list": "RLU details",
                "gis-intersections": "GIS intersections",
                "document-expiry": "Document validity",
                "document-extension": "Document extension",
                "repeatable-grid": "Repeatable table",
            },
            BASIC: {
                TITLE: "Basic components",
            },
            ADVANCE: {
                TITLE: "Advanced components",
            },
            LAYOUT: {
                TITLE: "Layout",
            },
            CUSTOM: {
                TITLE: "Custom components",
            },
        },
        DESCRIPTION: {
            CONTAINER_EMPTY: "Drag and drop an item from the left to add components",
            CONFIG_EMPTY: "Please add a component",
            TABLE_EMPTY: "Drag and drop an item from the left to add components",
            UPLOAD_JSON_INFO: "Below is the JSON format; you can replace it with your own JSON code",
        },
        MESSAGE: {
            COPY_SUCCESS: "Copied successfully",
            COPY_FAILED: "Copy failed",
            VALID_JSON: "Valid JSON",
            INVALID_JSON: "Invalid JSON",
            VALID_ERROR: "Please fill in all the required fields.",
            UPLOAD_MAX_FILES: "The maximum number of uploaded files is {max}",
        },
        PLACEHOLDER: {
            PASTE_JSON: "Paste JSON...",
        },
        ACTIONS: {
            IMPORT: "Import JSON",
            CLEAR: "Clear",
            PREVIEW: "Preview",
            JSON: "Generate JSON",
            CODE: "Generate code",
            GET_DATA: "Get data",
            RESET: "Reset",
            COPY_DATA: "Copy data",
            CANCEL: "Cancel",
            CONFIRM: "Confirm",
            ADD_OPTION: "Add option",
            ADD_COLUMN: "Add column",
            ADD_TAB: "Add tab",
            UPLOAD: "Upload",
            ADD: "Add",
        },
        CONFIG: {
            FORM: {
                TITLE: "Form attributes",
            },
            WIDGET: {
                TITLE: "Component attributes",
                MODEL: "ID",
                NAME: "Name",
                ALIAS: "Alias",
                META: "Meta",
                WIDTH: "Width",
                HEIGHT: "Height",
                SIZE: "Size",
                LABEL_WIDTH: "Label width",
                CUSTOM: "Custom",
                PLACEHOLDER: "Placeholder",
                LAYOUT: "Layout",
                BLOCK: "Block",
                INLINE: "Inline",
                CONTENT_POSITION: "Content position",
                LEFT: "Left",
                RIGHT: "Right",
                CENTER: "Centre",
                SHOW_INPUT: "Show input field",
                MIN: "Minimum",
                MAX: "Maximum",
                STEP: "Step",
                MULTIPLE: "Multiple selection",
                FILTERABLE: "Searchable",
                ALLOW_HALF: "Allow half",
                SHOW_ALPHA: "Support transparency options",
                SHOW_LABEL: "Show label",
                OPTION: "Option",
                STATIC_DATA: "Static data",
                REMOTE_DATA: "Remote data",
                REMOTE_FUNC: "Remote function",
                VALUE: "Value",
                LABEL: "Label",
                OPTION_LABEL_HELP: "The value is saved in the application and used in conditions. The label is the text the citizen sees, and it is the text that gets translated.",
                CHILDREN_OPTION: "Sub-option",
                DEFAULT_VALUE: "Default value",
                LIMIT: "Maximum number of uploads",
                IMAGE_ACTION: "Image upload address",
                TIP: "Help text",
                ACTION: "Upload address",
                DEFAULT_TYPE: "Data type",
                STRING: "Text",
                OBJECT: "Object",
                ARRAY: "Array",
                NUMBER: "Number",
                BOOLEAN: "Boolean",
                INTEGER: "Integer",
                FLOAT: "Decimal",
                URL: "URL",
                EMAIL: "Email",
                HEX: "Hexadecimal",
                GUTTER: "Grid spacing",
                COLUMN_OPTION: "Column configuration",
                SPAN: "Grid span",
                JUSTIFY: "Horizontal alignment",
                JUSTIFY_START: "Start",
                JUSTIFY_END: "End",
                JUSTIFY_CENTER: "Centre",
                JUSTIFY_SPACE_AROUND: "Space around",
                JUSTIFY_SPACE_BETWEEN: "Space between",
                ALIGN: "Vertical alignment",
                ALIGN_TOP: "Top",
                ALIGN_MIDDLE: "Middle",
                ALIGN_BOTTOM: "Bottom",
                TYPE: "Type",
                DEFAULT: "Default",
                CARD: "Tabs",
                BORDER_CARD: "Bordered card",
                TAB_POSITION: "Tab position",
                TOP: "Top",
                BOTTOM: "Bottom",
                TAB_OPTION: "Label configuration",
                TAB_NAME: "Tab name",
                CUSTOM_CLASS: "Custom class",
                ATTRIBUTE: "Attribute action",
                DATA_BIND: "Data binding",
                HIDDEN: "Hidden",
                READONLY: "Read-only",
                DISABLE: "Disabled",
                CALCULATOR: "Calculator",
                PRESELECTION: "Preselection",
                CONVERT_NUMBER_TO_TEXT: "Convert number to text",
                CONVERT_NUMBER_TO_TEXT_FROM_FIELD: "Convert number to text from field:",
                SUM_NUMBERS: "Sum of numbers",
                SUM_NUMBERS_FROM_FIELDS: "Sum of numbers from fields:",
                MULTIPLY_NUMBERS: "Multiply numbers",
                MULTIPLY_NUMBERS_FROM_FIELDS: "Multiply numbers from fields:",
                SUM_MONTHS: "Sum of months",
                SUM_MONTHS_FROM_FIELDS: "Sum of months from fields:",
                DIFF_MONTHS: "Difference in months",
                DIFF_MONTHS_FROM_FIELDS: "Difference in months from fields:",
                DIFF_DAYS: "Difference in days",
                DIFF_DAYS_FROM_FIELDS: "Difference in days from fields:",
                PERCENTAGE_VALUE: "Percentage value",
                PERCENTAGE_VALUE_FROM_FIELDS: "Percentage value from fields:",
                EDITABLE: "Text field is editable",
                CLEARABLE: "Show clear button",
                ALLOW_CONTROL: "Use arrows to select the time",
                IS_DELETE: "Deletable",
                IS_EDIT: "Editable",
                SHOW_PASSWORD: "Show password",
                VALIDATE: "Validation",
                REQUIRED: "Required",
                CITIZEN_ID_CARD_VALIDATION: "ID card required (natural person)",
                LEGAL_ENTITY_ID_CARD_VALIDATION: "ID card required (legal entity)",
                LEGAL_ENTITY_BANK_DETAILS_VALIDATION: "Bank details required (legal entity)",
                PATTERN_PLACEHOLDER: "Enter the regular expression",
                PATTERN_MESSAGE_PLACEHOLDER: "Validation message for the regular expression",
                NEW_OPTION: "New option",
                TAB: "Tab",
                VALIDATOR_REQUIRED: "Required",
                VALIDATOR_TYPE: "Invalid format",
                VALIDATOR_PATTERN: "Does not match the pattern",
                COLLAPSIBLE: "Collapsible",
                COLLAPSED: "Collapsed (default)",
                SECTION_TITLE: "Title",
                IS_CONDITIONED: "Conditional",
                CONDITION: "Condition",
                FONT_SIZE: "Font size",
                IS_BOLD: "Bold",
                HIDE_LABEL: "Hide label",
                IS_SHARED: "Shared",
                SHOW_TOOLTIP: "Show tooltip",
                TOOLTIP_TEXT: "Tooltip text",
                ROWS: "Rows",
                MAX_ROWS: "Maximum rows",
                PLAINTEXT: "Read-only",
                ACCEPTED_FILE_TYPES: "Accepted file types",
                MAX_FILE_SIZE: "Maximum file size: {0} MB",
                FILE_SIZE: "File size",
                FILE_TYPE: "File type",
                MAX_FILES: "Maximum number of files",
                ADVANCED_CONDITIONS: "Advanced conditions",
                CONDITION_EXPRESSION: "Condition expression",
                CONDITION_FIELD: "Field",
                CONDITION_OPERATION: "Operation",
                CONDITION_VALUE: "Value",
                AUTOCOMPLETE_FORM: "Autofill form",
                LOAD_ALL_GUEST_APPLICATIONS: "All issued documents regardless of submitter",
                LOAD_ALL_ORG_APPLICATIONS: "All issued documents regardless of organisation",
                LOAD_EXTERNAL_DOCUMENTS: "Load series reservations",
                FORCE_SHOW_DOCUMENT_UPLOAD_BTN: "Always show the upload button",
                DOCUMENT_KEY: "Document key",
                CUSTOM_NOTFOUND_MESSAGE: "Custom error message",
                COEFFICIENTS: "Coefficients",
                UAT: "UAT",
                VILLAGE: "Locality",
                COEFF_VALUE: "Coefficient value",
                AC_TAX_CATEGORIES: "Fee per construction system",
                AC_TAX_A: "Construction system A (concrete)",
                AC_TAX_B: "Construction system B (wood, stone)",
                AC_TAX_C: "Construction system C (outbuildings)",
                AC_TAX_OTHER: "Other",
                RU_SCOPE: "RU purpose",
                UTR_PDF_DOCUMENT_TEMPLATE: "Document template used to generate the PDF from the UTR",
                MIN_INSTANCES: "Minimum instances",
                MAX_INSTANCES: "Maximum instances",
                OPERATION_EQUAL: "Equal",
                OPERATION_NOT_EQUAL: "Not equal",
                OPERATION_INCLUDES: "Contains",
                OPERATION_NOT_INCLUDES: "Does not contain",
                OPERATION_GREATER_THAN: "Greater than",
                OPERATION_LESS_THAN: "Less than",
                OPERATION_GREATER_THAN_OR_EQUAL: "Greater than or equal",
                OPERATION_LESS_THAN_OR_EQUAL: "Less than or equal",
                DEFAULT_OPTION: "Option {0}",
                DEFAULT_TEXT: "This is some text",
                RU_SCOPE_OTHER: "Other",
            },
        },
        UPLOAD: {
            PREVIEW: "preview",
            EDIT: "replace",
            DELETE: "delete",
        },
    },
    APPLICATION_TYPE: {
        LIST: {
            TITLE: "Application types",
        },
        ADD_BUTTON: "New type",
        FIELDS: {
            NAME: "Name",
            STATUS: "Status",
            DESCRIPTION: "Description",
            FORM_CITIZEN: "Citizen form interface",
            FORM_STAFF: "Staff form interface",
            REJECT_FORM_STAFF: "Staff rejection form interface",
            CLARIFICATION_FORM_CITIZEN: "Citizen clarification form interface",
            CLARIFICATION_FORM_STAFF: "Staff clarification form interface",
            DOCUMENT_TEMPLATE: "Staff document template",
            REJECT_DOCUMENT_TEMPLATE: "Staff rejection document template",
            CLARIFICATION_DOCUMENT_TEMPLATE: "Staff clarification document template",
            CLARIFICATION_DOCUMENT_TEMPLATE_CITIZEN: "Citizen clarification template",
            REVIEW_DOCUMENT_TEMPLATE: "Citizen clarification document template",
            PUBLIC_DOCUMENT_TEMPLATE: "Public document template",
            APPLICATION_DOCUMENT_TEMPLATE: "Citizen document template",
            DOCUMENT_SERIES_TYPE: "Outgoing document series type",
            APPLICATION_DOCUMENT_SERIES_TYPE: "Incoming document series type",
            FIRST_VIZA_SERIES_TYPE: "CFP endorsement series type",
            SECOND_VIZA_SERIES_TYPE: "Legality endorsement series type",
            REJECTION_VIZA_SERIES_TYPE: "Endorsement rejection series type",
            TAX_CATEGORY: "Fee category",
            CONSTRUCTION_TAX_CATEGORY: "Fee category 1 (construction_value metadata)",
            LAND_TAX_CATEGORY: "Fee category 2 (land_value metadata)",
            EXTRA_TAX_CATEGORY: "Fee category 3 (other fee applied to the value)",
            APPLICATION_TYPE_REF: "Reference documents",
            ARCHIVE_DOCUMENT_TYPE_CODE: "Archive document type",
            WORKFLOW: "Process",
            SUB_WORKFLOW: "Sub-process",
            TENANT_ID: "Organisation",
            IS_AUTO: "Automatic type",
            REMAINING_PERIOD: "Remaining time",
            ORDER: "List priority (order)",
            DISCOUNTS: "Available discounts",
            UATS: "Available UATs",
            IS_INTERNAL: "Document type",
            IS_INBOUND_CATEGORY: "Incoming",
            IS_INTERNAL_CATEGORY: "Internal",
            IS_OUTBOUND_CATEGORY: "Outgoing",
            IS_DYNAMIC_FORM: "Dynamic form type",
            HAS_DIGITAL_SEAL: "Apply CertSign seal to the issued document",
            HAS_STS_DIGITAL_SEAL: "Apply STS seal to the issued document",
            IS_GENERATING_PROJECT_ID: "Generate Project ID",
            DIGITAL_SEAL_CUSTOM_IMAGE_ID: "Add an additional image for the seal",
            REVIEW_APPLICATION_TYPE_ID: "Related clarification note",
            INTERNAL_APPLICATION_TYPE_ID: "Related internal document",
            DEPARTMENTS: "Departments",
            FUNCTIONS: "Positions",
            OPTION_APPLICATION: "Application",
            OPTION_DOCUMENT: "Document",
            USAGE_CATEGORIES: "Usage categories",
            VISIBLE_FOR: "Visible to",
            DOMAIN: "Domains",
            ENTIRE_ORGANIZATION: "Entire organisation",
            EXPIRY_NOTIFICATION_ENABLED: "Document expiry notification",
            DAYS_BEFORE_EXPIRY: "Notification period (days)",
            IS_EXPIRY_EXTENSION_TYPE: "Expiry extension application type",
            IS_PCUEL_SYNCED: "Synchronised with PCUEL",
            THIRD_PARTY_EMAILS: "Third-party emails",
        },
        FORM: {
            EDIT_TITLE: "Edit application type",
            ADD_TITLE: "New application type",
            USAGE_CATEGORY: "Usage category",
            MAX_FILE_SIZE: "Maximum 10MB (png, jpg, jpeg)",
            FILE_UPLOAD_INFO_MESSAGE: "Upload the image by drag and drop or by clicking",
            FILE_UPLOAD_ERROR_INVALID: "The file is invalid!",
            FILE_UPLOAD_ERROR_SIZE: "The file is too large!",
            DEPARTMENTS_TREE: "Visible to (departments, positions, services, units)",
            INVALID_EMAIL: "Invalid email",
            DUPLICATE_EMAIL: "Email already added",
            THIRD_PARTY_EMAILS_PLACEHOLDER: "Enter email",
            THIRD_PARTY_EMAILS_ADD_BUTTON: "Add",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
            DOMAIN: {
                URBANISM: "Urbanism",
                ADMINISTRATION: "Administration",
                CITY_HALL: "Town halls",
                APPROVALS: "Approving authorities",
                ROADS: "Transport",
                ECONOMIC: "Economic",
                SUBORDINATION: "Subordinate institutions",
                MAPS: "Maps",
                INVESTMENTS: "Investments",
                TOURISM: "Tourism",
                EVENTS: "Rentals",
            },
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
            STATUS: "Status",
            NO_REF_DOC: "No reference document",
            NO_DISCOUNTS: "No discount",
            APPLY_DISCOUNT: "Apply discount for rural UAT",
            IS_TAX_FIXED: "Fee per application (without sites)",
            IS_TAX_CATEGORY_CONDITIONAL: "Fee conditional on value",
            NO_UATS: "No UAT",
            DOMAIN: "Domain",
            VISIBLE_FOR_DEPARTMENT: "Department",
            VISIBLE_FOR_SERVICE: "Service",
            VISIBLE_FOR_COMPARTMENT: "Unit",
        },
        MESSAGES: {
            IS_AUTO: "An automatic type has no reference documents",
        },
    },
    DOCUMENT_TEMPLATE: {
        LIST: {
            TITLE: "Document templates",
            ADD_BUTTON: "New template",
            TABLE_HEADER: "Templates",
        },
        FIELDS: {
            NAME: "Name",
            DESCRIPTION: "Description",
            STATUS: "Status",
            CREATED_DATE: "Created date",
            TYPE: "System document template",
        },
        PLACEHOLDERS: {
            STATUS: "Status",
            NAME: "Name",
            TYPE: "System document template",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
        },
        CREATE_MODAL: {
            TITLE: "Save document template",
        },
        EDIT_MODAL: {
            TITLE: "Edit document template",
        },
        FORM: {
            TITLE: "Document template",
            DOWNLOAD_BUTTON: "Download",
            FIELDS_LIST_TITLE: "Insert fields",
            FIELDS_PANE_COLLAPSE: "Hide fields",
            FIELDS_PANE_EXPAND: "Show fields",
            ORGANISATION_LABEL: "Select organisation",
            APPLICATION_TYPES_LABEL: "Select application type",
            RELATED_APPLICATION_TYPES_LABEL: "Select related application type",
            FORM_TYPE_LABEL: "Select form type",
            CITIZEN_LABEL: "Citizen",
            STAFF_LABEL: "Staff",
            CITIZEN_CLARIFICATION_LABEL: "Citizen clarifications",
            STAFF_CLARIFICATION_LABEL: "Staff clarifications",
            SELECT_TYPE: "Select type",
            APPLICATION_TYPE: "Application",
            CONTROL_TYPE: "Inspection",
            FIELD_SEARCH_PLACEHOLDER: "Search field...",
            NO_FIELDS_FOUND: "No fields found",
            SELECT_TYPE_TO_SEE_FIELDS: "Select a type to see the fields",
        },
    },
    PROCESS_EDITOR: {
        HEADER: "Process management",
        NEW_PROCESS_BTN: "New process",
        GENERAL: {
            HEADER: "Process editor",
            HEADER_LIST: "Process list",
            TITLE: "New process",
            SAVE_BTN: "Save",
            EDIT_BTN: "Edit",
            FIELDS: {
                NAME: "Name",
                DESCRIPTION: "Description",
                STATUS: "Status",
                EXECUTION_SCOPE: "Scope",
            },
            PLACEHOLDERS: {
                NAME: "Search by name",
                DESCRIPTION: "Description",
                EXECUTION_SCOPE: "Scope",
                MAIN: "Process",
                SUBPROCESS: "Sub-process",
            },
        },
        TABS: {
            GENERAL: "General",
            STEPS: "Steps",
        },
        STEPS: {
            HEADER: "Process editor",
            HEADER_LIST: "Created steps",
            EDIT_MODAL_HEADER: "Edit step",
            ADD_MODAL_HEADER: "Add step",
            ADD_BTN: "Add step",
            SAVE_LIST_BTN: "Save steps",
            PUBLISH_BTN: "Publish",
            PUBLISH_MSG: "The start step is not first in the list! The list cannot be published.",
            PUBLISH_CONFIRM_MSG: "Are you sure you want to publish this process? It will become available for use.",
            SHOW_GIS_INTERSECTION_SETTINGS_MODAL: "GIS intersection settings",
            EDIT_GIS_INTERSECTION_SETTINGS_MODAL_HEADER: "Edit GIS metadata mappings for step \"{0}\"",
            ADD_GIS_INTERSECTION_SETTINGS_MODAL_HEADER: "Save GIS metadata settings for step \"{0}\"",
            EDIT_GIS_INTERSECTION_SETTINGS_VIEW_MODAL_HEADER: "View settings",
            VIZA_SERIES_TYPE_FIRST_OPTION: "CFP endorsement",
            VIZA_SERIES_TYPE_SECOND_OPTION: "Legal endorsement",
            FIELDS: {
                NAME: "Step name",
                ACTION_NAME: "Action",
                ACTION_TYPE: "Action type",
                NEXT_STEP: "Next step",
                CONDITIONAL_ROUTING: "Conditional routing",
                FILE_STATUS: "File status",
                FILE_TYPE: "File type",
                EXTRA_DOCUMENT_TEMPLATE_ID: "Document template",
                EXTRA_DOCUMENT_VISIBILITY: "Generated file visibility",
                FUNCTION_TYPE: "Position",
                SIGN_BY_ASSIGNED_USER: "Signing by the assigned user",
                APPLICATION_STATUS: "Application status",
                RETURN_ACTION: "Return to",
                SIGN_WITH_VIZA: "Signing with endorsement",
                VIZA_SERIES_TYPE: "Endorsement series type",
                CLARIFICATION_STATUS: "Clarification status",
            },
            PLACEHOLDERS: {
                NAME: "Name",
                ACTION_NAME: "Action",
                ACTION_TYPE: "Action type",
                NEXT_STEP: "Next step",
                CONDITIONAL_ROUTING: "Conditional routing",
                FILE_STATUS: "File status",
                FILE_TYPE: "File type",
                EXTRA_DOCUMENT_TEMPLATE_ID: "Document template",
                EXTRA_DOCUMENT_VISIBILITY: "Generated file visibility",
                FUNCTION_TYPE: "Position",
                APPLICATION_STATUS: "Application status",
                CLARIFICATION_STATUS: "Clarification status",
                VIZA_SERIES_TYPE: "Endorsement series type",
            },
            ACTIONS: {
                START: "Start",
                END: "End",
            },
            GIS_INTERSECTIONS: {
                ADD_MAPPINGS: "Add metadata",
                SAVE_MAPPINGS: "Save metadata",
                MAPPINGS_LIST_DESC: "Existing mappings",
                GIS_VALUE_LABEL: "GIS value",
                GIS_VALUE_LABEL_EXTENDED: "GIS attribute value",
                FIELDS: {
                    TENANT_ID: "Organisation",
                    TENANT_NAME: "Organisation",
                    LAYER_ID: "GIS Feature Layer",
                    LAYER_NAME: "GIS Feature Layer",
                    SUBLAYER_ID: "GIS sublayer",
                    SUBLAYER_NAME: "GIS sublayer",
                    GIS_ATTRIBUTE_ID: "GIS attribute",
                    GIS_ATTRIBUTE_NAME: "GIS attribute name",
                    METADATA_NAME: "Ghișeul Unic metadata name",
                    INTERSECTION_TYPE: "Intersection type",
                    METADATA_COMPLETION_METHOD: "Metadata completion method",
                    GIS_ATTRIBUTE_VALUE_OVERRIDE: "Manual value",
                },
                PLACEHOLDERS: {
                    TENANT_ID: "Organisation",
                    TENANT_NAME: "Organisation",
                    LAYER_ID: "GIS Feature Layer",
                    LAYER_NAME: "GIS Feature Layer",
                    SUBLAYER_ID: "GIS sublayer",
                    SUBLAYER_NAME: "GIS sublayer",
                    GIS_ATTRIBUTE_ID: "GIS attribute",
                    GIS_ATTRIBUTE_NAME: "Attribute metadata name",
                    METADATA_NAME: "Ghișeul Unic metadata name",
                    INTERSECTION_TYPE: "Intersection type",
                    METADATA_COMPLETION_METHOD: "Metadata completion method",
                    GIS_ATTRIBUTE_VALUE_OVERRIDE: "Manual value",
                },
                ENUMS: {
                    INTERSECTION_TYPE: {
                        TOTAL: "Full intersection",
                        PARTIAL: "Partial intersection",
                        NONE: "No intersection",
                    },
                    METADATA_COMPLETION_METHOD: {
                        USE_GIS_VALUE: "Current GIS value",
                        MANUAL: "Manual entry",
                    },
                },
            },
            REAL_ESTATE_PLACEMENT: {
                SHOW_SETTINGS_MODAL: "Location plan layer settings",
                EDIT_SETTINGS_MODAL_HEADER: "Edit visible location plan layer settings for step \"{0}\"",
                ADD_SETTINGS_MODAL_HEADER: "Add visible location plan layer settings for step \"{0}\"",
                ADD_LAYER: "Add layer",
                CONFIGURED_LAYERS: "Configured layers",
                FIELDS: {
                    TENANT_ID: "Organisation",
                    LAYER_ID: "ID",
                    LAYER_NAME: "Name",
                    OPACITY: "Opacity",
                    SHOW_LABELS: "Show labels",
                    SUBLAYERS: "Sublayers",
                },
                PLACEHOLDERS: {
                    TENANT_ID: "Select organisation",
                    LAYER_ID: "Layer ID",
                    LAYER_NAME: "Layer name",
                },
                LAYER_ALREADY_EXISTS: "This layer has already been added.",
            },
        },
        ENUMS: {
            STATUS: {
                YES: "YES",
                NO: "NO",
                DRAFT: "Draft",
                ERROR: "Unpublished",
                PUBLISHED: "Published",
                PENDING: "Processing",
            },
            EXECUTION_SCOPE: {
                MAIN: "Main process",
                SUBPROCESS: "Sub-process",
            },
            EXTRA_DOCUMENT_VISIBILITY: {
                PRIVATE: "Private",
                PUBLIC: "Public",
            },
        },
        TABLE_HEADER: {
            TRANSITION: "Transition",
            ACTIONS: "Actions",
        },
        MESSAGES: {
            ALREADY_EXISTS: "A process with this name already exists",
        },
    },
    GIS_INTERSECTIONS: {
        LIST_HEADER: "Intersection list",
        SINGLE: "Total {total} intersected site",
        MULTIPLE: "Total {total} intersected sites",
        INTERSECTION_GIS_VALUE: "Value from GIS",
        INTERSECTION_MANUAL_VALUE: "Manual value",
        INTERSECTION_VIEW_MODAL_TITLE: "Intersections for {0} {1}",
        INTERSECTION_SECTION_TITLE: "Intersection {0}",
        CARD: {
            METADATA: "Metadata",
            LAYER_NAME: "Layer",
            SUBLAYER_NAME: "Sublayer",
            CADASTRAL_NUMBER: "Cadastral number",
            UAT: "Municipality / Town / Commune",
            ATTRIBUTE_NAME: "GIS attribute",
            VALUE: "Value",
        },
        INTERSECTION_TYPE_LABEL: "Intersection type",
        INTERSECTION_TYPE: {
            TOTAL: "Full intersection",
            PARTIAL: "Partial intersection",
            NONE: "No intersection",
        },
        COMPLETION_METHOD_LABEL: "Metadata completion method",
        METADATA_COMPLETION_METHOD: {
            USE_GIS_VALUE: "Current GIS value",
            MANUAL: "Manual entry",
        },
        INTERSECTION_VIEW_MODAL_COUNTER: "Intersection {0} of {1}",
    },
    PERMISSIONS: {
        HEADER: "Permissions",
        FILTER: {
            TITLE: "Permissions list",
        },
        BUTTONS: {
            SET_PERMISSIONS: "Set permissions",
        },
        FIELDS: {
            NAME: "Name",
            PERMISSION_NAME: "Name",
            DESCRIPTION: "Description",
            CATEGORY: "Category",
            SCOPE: "Scope",
            ORGANISATIONS: "Organisation",
            SYSTEM_DEFAULT: "Default assignment",
            DEFAULT_ASSIGNED_TO: "Default user",
            APPLY_DEFAULT_TO_ORGANISATION: "Default organisation",
        },
        PLACEHOLDERS: {
            NAME: "Name",
            PERMISSION_NAME: "Name",
            CATEGORY: "Category",
        },
        FORM: {
            TITLE: "Set permissions",
            PERMISSIONS: "Permissions",
        },
    },
    REAL_ESTATE: {
        FORM: {
            HEADER: "Add site",
            ADD_BTN: "Add new site",
            ADD_FILE_LABEL: "Add cadastral plan (pdf/zip)",
            ADD_FILE_BTN: "Choose files",
            DUPLICATE_CADASTRAL_NUMBER: "This cadastral number has already been added",
            DUPLICATE_CADASTRAL_NUMBER_PLURAL: "Some of the selected cadastral numbers have already been added",
            DIFFERENT_AREA: "The area entered differs from the one recorded by ANCPI",
            WRONG_COUNTY: "Applications can only be submitted for {county} county",
            CADASTRAL_NUMBER_UNAVAILABLE: "I do not have a site registered in the cadastre (entered in the land register/with a land register extract)",
            DRAW_PARCEL: "Draw the site",
            DRAW_SEARCH_INTERSECT: "Draw and search sites",
        },
        VIEW: {
            ADDRESS: "Address",
            CONTACT: "Contact",
            CADASTRAL_PLAN: "Cadastral plan",
            NO_FILES: "No files",
            FILES_LABEL: "Identification files",
        },
        SKETCH: {
            MODAL_HEADER: "Draw a site",
            MODAL_HEADER_INTERSECT: "Find a site by drawing",
            MODAL_HEADER_MIXED: "Draw or find a site",
            VIEW_MODAL_HEADER: "View site",
            TITLE_UNDER_EDIT: "Use the polygon drawing tool from the toolbar in the bottom-right corner of the map to outline the site. Click on the map to place each corner of the parcel, and double-click on the last point to finish the shape. After drawing, you can adjust the outline by dragging the vertex points, or delete it and draw again from the toolbar. Press 'Add' once the outline correctly reflects the site.",
            TITLE_UNDER_INTERSECT: "Use the polygon drawing tool from the toolbar in the bottom-right corner of the map to outline an area covering one or more parcels. Once you finish drawing (double-click on the last point), the app will automatically search for parcels within the drawn area; you will then be able to select which parcels to add from the results list.",
            TITLE_UNDER_MIXED: "Use the polygon drawing tool from the toolbar in the bottom-right corner of the map to outline the site. If the drawn area overlaps one or more existing parcels, you will be able to select which ones to add from the results list; otherwise the drawing itself will be added as a new site.",
            INTERSECT_CANDIDATES_HEADER: "Sites found",
            INTERSECT_NO_MATCHES: "No site was found in the drawn area",
            INTERSECT_CADASTRAL_NUMBERS_LABEL: "Cadastral numbers found, validated in ANCPI",
            INTERSECT_VALIDATION_SUMMARY: "{valid} validated in ANCPI, {invalid} not validated",
            INTERSECT_STATUS_SKETCH: "Not validated in ANCPI, will be added as a sketch",
            INTERSECT_UAT_UNRESOLVED: "UAT could not be determined",
            INTERSECT_SELECT_ALL: "Select all / Deselect all",
        },
        SINGLE: "Total {total} site",
        MULTIPLE: "Total {total} sites",
        REAL_ESTATES: "Sites",
        SKETCHES: "Drawn sites",
        NO_REAL_ESTATES: "No sites added",
        DOCUMENTS: "Documents",
        LIST_HEADER: "Site list",
        MODAL: {
            ADD_HEADER: "Add a site",
            SUMMARY_HEADER: "Full list of properties",
            VIEW_COUNTER: "Property {0} of {1}",
        },
        DETAILS_MODAL: {
            HEADER: "Site details (ANCPI query date: {date})",
            SUBHEADER_DESCRIPTION: "A. Part I. Property description",
            SUBHEADER_REGISTRATIONS_FIRST: "B. Part II. Owners and documents",
            SUBHEADER_REGISTRATIONS_SECOND: "C. Part III. ENCUMBRANCES",
            NO_DATA: "No data",
            GENERAL: {
                HEADER: "General data",
                UAT: "UAT",
                CADASTRAL_NUMBER: "Cadastral number",
                PREVIOUS_CAD_NO: "Previous cadastral number",
                PREVIOUS_LAND_BOOK_NO: "Previous CF number",
                MEASUREAD_AREA: "Measured area",
                LEGAL_AREA: "Legal area",
            },
            ADDRESS: {
                HEADER: "Address",
                COUNTY: "County",
                ADMIN_UNIT: "UAT",
                LOCALITY: "Locality",
                STREET_TYPE: "Street type",
                STREET_NAME: "Street",
                POSTAL_NUMBER: "Street number",
                BUILDING_NUMBER: "Building number",
                BUILDING_PART_NUMBER: "Building number (part)",
                FLOOR_NUMBER: "Floor",
                BUILDING_UNIT_NUMBER: "Unit number",
                POSTAL_CODE: "Postal code",
            },
            PARCELS: {
                TITLE: "Parcels",
                HEADER: "Parcel {number}",
                MEASUREAD_AREA: "Measured area",
                LEGAL_AREA: "Legal area",
                PROPERTY_TITLE_NO: "Property title",
                USE_CATEGORY: "Use",
                IS_AGRICULTURAL: "Agricultural",
                INTRAVILAN: "Built-up area",
            },
            BUILDINGS: {
                TITLE: "Buildings",
                HEADER: "Building {number}",
                MEASUREAD_AREA: "Measured area",
                LEGAL_AREA: "Legal area",
                USE_CATEGORY: "Use",
                LEGAL: "Legal",
            },
            OWNERS: {
                HEADER: "Owners",
                NAME: "Name",
                CNP: "CNP",
                OWNERSHIP_TYPE: "Ownership type",
                IS_PART_HOLDER: "Part owner",
                DESCRIPTION: "{registration_type}, right of {right_type}, acquired by {property_transfer_type}, current share {actual_quota}.",
            },
            REGISTRATIONS: {
                HEADER_FIRST: "Entries regarding ownership and other real rights",
                HEADER_SECOND: "Entries regarding dismemberments of ownership, real security rights and encumbrances",
                DEED_TEXT: "{type} no. {number}, dated {date}, issued by {issuer}",
                INTAB_DESCRIPTION: "Land register entry, right of {right_type} {right_comment}, acquired through {transfer_type}, current share {quota}",
            },
        },
        CARD: {
            CADASTRAL_NUMBER: "Cadastral number",
            UAT: "UAT",
            LAND_AREA: "Area",
            ADDRESS_COUNTY: "{county} County",
            CATEGORY: "Category code",
            MISSING_COORDINATES_MESSAGE: "Missing ANCPI coordinates",
        },
    },
    METADATA_MAPPING: {
        FIELDS: {
            METADATA: "GU metadata",
            ARCHIVE_METADATA_NAME: "Archive metadata name",
            ALIAS: "GU metadata label",
            ARCHIVE_METADATA_LABEL: "Archive metadata label",
        },
        PAGE_TITLE: "Mapping archive metadata to GU metadata",
        TABLE_TITLE: "List of existing mappings",
        FORM: {
            ARCHIVE: {
                DOC_TYPE: "Select document",
                METADATA: "Select metadata - Archive",
            },
            GU: {
                APP_TYPE: "Select application type",
                METADATA: "Select metadata - GU",
            },
        },
        MANDATORY_NOTE: "Options prefixed with (M) are mandatory.",
        CONFIRMATION_MESSAGE: "The archive metadata <strong>{label}</strong> is associated with the GU metadata <strong>{metadata}</strong>. <hr> Do you want to overwrite it with <strong>{text}</strong>?",
        TABLE_TITLE_FOR: "List of existing mappings for {appType}",
    },
    ATLAS: {
        MENU: {
            LAYER_MANAGER: "Atlas",
            MY_APPLICATIONS: "My applications",
            INTEREST_ZONES: "Areas of interest",
            DISTANCE: "Distance",
            ARIA: "Area",
            SEARCH: "Search",
            HELP: "Help",
            VISIBILITY_MANAGER: "Visibility settings",
            PARCEL_SEARCH: "Property search",
            ARCGIS_APPS: "GIS applications",
        },
        LAYER_MANAGER: {
            TITLE: "Map manager",
            SEARCH_LAYER: "Search layers",
            MORE_ACTION: {
                SHARE: "Share",
                EDIT: "Edit",
                EXPORT: "Export",
                DELETE: "Delete",
                PUBLISH: "Publish",
            },
            ATLAS_LABEL: "Atlas layers",
            APPS_LABEL: "GIS applications",
            ORGANISATION_LABEL: "Organisation layers",
            PRIVATE_LABEL: "My layers",
            IMPORT_LAYER_LINK: "import a layer",
            EMPTY_LAYER_TEXT: "There are no layers",
            EMPTY_ARCGIS_APPS_TEXT: "There are no GIS applications",
            UPLOADING: "Uploading...",
            UPLOAD_DONE: "Layer uploaded successfully!",
            UPLOAD_ERROR: "Error uploading the layer!",
            UPLOAD_MORE: "Do you want to upload another layer?",
            UPLOAD_TRY: "Try again!",
            DELETE_MODAL_TITLE: "Are you sure you want to delete this layer?",
            DELETE_ARCGIS_APP_MODAL_TITLE: "Are you sure you want to delete this GIS application?",
            DELETE_MODAL_SUBTITLE: "All data on the sublayers will be lost.",
            UPLOAD_LAYER: {
                TITLE: "Upload a new layer now (.ZIP)",
            },
            UPDATE_CONTAINER_TITLE: "Edit container",
            UPDATE_LAYER_TITLE: "Edit layer",
            ADD_LAYER_TITLE: "Add layer",
            ADD_LAYER_BY_ID_BTN: "Add layer by ID",
            TOOLTIP_TEXT: "The layer is available at",
            TOOLTIP_URL: "gis.cluj.archi",
            SYSTEM_LAYER: "System layer",
            LAYER_SYNC_SUCCESS: "Layer updated successfully.",
            LAYER_SYNC_ERROR: "The layer could not be updated.",
            SHOW_LEGEND: "Show legend",
            HIDE_LEGEND: "Hide legend",
            LAYER_TITLE: "Layer title",
        },
        LAYER_PRESETS: {
            TITLE: "Map themes",
            PREDEFINED_TITLE: "Predefined filters",
            PERSONAL_TITLE: "My filters",
            ADD_BTN: "Add filter",
            PREDEFINED_ADD_BTN: "Add predefined filter",
            SAVE_BTN: "Save",
            APPLY_BTN: "Apply",
            DELETE_BTN: "Delete",
            NAME_PLACEHOLDER: "Filter name...",
            EMPTY_TEXT: "There are no saved filters.",
            PREDEFINED_EMPTY_TEXT: "There are no predefined filters.",
            PREDEFINED_SELECT_ORG_CTA: "Select the institution",
            SAVE_SUCCESS: "Filter saved.",
            PREDEFINED_SAVE_SUCCESS: "Predefined filter saved.",
            HELP_TITLE: "How does it work?",
            HELP_TEXT: "Save the current visible layer configuration as a named filter. Apply a saved filter to quickly restore the same layer visibility configuration.",
            APPLY_SUCCESS: "Filter applied.",
            DELETE_SUCCESS: "Filter deleted.",
            PREDEFINED_DELETE_SUCCESS: "Predefined filter deleted.",
            DELETE_CONFIRM_TITLE: "Delete the filter?",
            DELETE_CONFIRM_TEXT: "This action cannot be undone.",
            PREDEFINED_DELETE_CONFIRM_TITLE: "Delete the predefined filter?",
            PREDEFINED_DELETE_CONFIRM_TEXT: "This action cannot be undone.",
        },
        LAYER_SETTINGS: {
            TITLE: "Sublayer settings",
            SELECT_SUBLAYER: "Select sublayer",
            SELECT_SUBLAYER_PLACEHOLDER: "-- Choose a sublayer --",
            ALLOW_FEATURES_TABLE: "Allow attribute table view",
            ALLOW_COMMENTS: "Allow comments",
            SHOW_ID_COLUMN: "Show ID column",
            SELECT_ID_COLUMN_FIRST: "Select an ID column from the selected attributes first",
            NAME_COLUMN_FORMAT: "Sublayer table header column format",
            NAME_COLUMN_FORMAT_PLACEHOLDER: "e.g. {field1} - {field2}",
            NAME_FORMAT_INVALID: "Invalid format: fields must be from selected attributes",
            SELECT_ATTRIBUTES: "Select visible attributes",
            SELECTED_ATTRIBUTES: "Selected attributes",
            LOADING_ATTRIBUTES: "Loading attributes...",
            ATTRIBUTE_FETCH_ERROR: "Error loading attributes from ArcGIS",
            ALIAS: "Alias",
            SEARCHABLE: "Searchable",
            USE_AS_ID: "Use as ID",
        },
        APPLICATIONS_MANAGER: {
            TITLE: "My applications",
        },
        INTEREST_AREAS_MANAGER: {
            TITLE: "My areas of interest",
            TITLE_TOOLTIP: "To add a new area of interest, use the area measurement option in the map menu. Double-click to finish defining the area.",
            AREA: "Area",
            NOTIFICATIONS: "Notifications",
            NOTES: "Notes",
            PERIMETER: "Perimeter",
            ADD_NEW_ZONE_TITLE: "Add new area of interest",
            EDIT_NEW_ZONE_TITLE: "Edit area of interest",
            NOTES_PLACEHOLDER: "Add key information",
            BUTTONS: {
                NEW_AREA: "New area",
            },
            DELETE_CONFIRMATION_TEXT: "Are you sure you want to delete the area of interest?",
        },
        INTERSECTION_MANAGER: {
            TITLE: "Marked location",
            INFO_LAYER_TEXT: "Information",
            CU_INFO_LAYER_TEXT: "Urbanism certificate",
            AUTHORIZATION_INFO_LAYER_TEXT: "Permit",
            DETAILS_TEXT: "Details",
            SIRUTA_LABEL: "SIRUTA",
            COUNTY_NAME_LABEL: "County name",
            COUNTY_INDICATIV_LABEL: "County code",
            UAT_LABEL: "UAT name",
            APPROVAL_YEAR_LABEL: "PUG approval year",
            YEAR_OF_EXTENSION_LABEL: "PUG extension year",
            NO_YEAR_OF_EXTENSION: "Not applicable",
            URBANISM_REGULATION_LABEL: "Urbanism regulations",
            APPLICATION_ISSUED_DATE: "Issue date",
            APPLICATION_TYPE: "Type",
            APPLICATION_STATUS: "Status",
            HELP_TEXT: "No results found, select a point on the map!",
            TAB_LABEL: "Intersection",
            APPLICATION_STATUSES: {
                DRAFT: "Draft",
                NEW: "New",
                EMITTED: "Completed",
                REJECTED: "Rejected",
            },
        },
        INTERSECTION_DETAILS_MODAL: {
            HEADER: "Marked location information",
            RLU_RT: "Technical regime",
            RLU_RJ: "Legal regime",
            RLU_RE: "Economic regime",
            RLU_POT: "POT",
            RLU_CUT: "CUT ",
            RLU_RDA: "Update regime",
        },
        SUBLAYER_MANAGER: {
            TAB_LABEL: "Layer details",
            SUBLAYER_NAME: "Sublayer name",
            SUBLAYER_ACTIONS: "Actions",
            EMPTY_SUBLAYERS_TEXT: "There are no sublayers",
            SCALE_RANGE_SLIDER_TITLE: "Sublayer parameters",
            SUGGEST_SCALE_RANGE_TEXT: "Suggest a scale",
            SCALE_RANGE_SLIDER_TEXT: "Scale",
            OPACITY_SLIDER_TEXT: "Opacity",
            CLUSTERING_CHK_LABEL: "Clustering",
            HEATMAP_CHK_LABEL: "Heat map",
            FEATURES: {
                FEATURES_TABLE: "Parcel list",
                FEATURE_ATTRIBUTES: "Attributes",
                NAME: "Name",
                ACTION: "Action",
                COMMENTS: "Comments",
                NO_COMMENTS: "No comments yet.",
                DELETE: "Delete",
                DELETE_COMMENT_TITLE: "Delete comment",
                DELETE_COMMENT_MESSAGE: "Are you sure you want to delete this comment? This action cannot be undone.",
                ADD_PLACEHOLDER: "Add a comment...",
                SUBMIT: "Send",
                NO_SELECTION: "Select a parcel to view its details and comments.",
                SEARCH_PLACEHOLDER: "Search...",
                CLEAR_FILTER: "Clear filter",
                ID: "ID",
                COMMENTS_UNAVAILABLE_NO_ID: "This feature has no detectable ID field, so comments are unavailable.",
                NO_FEATURES: "No parcels found",
                EDITED: "(Edited)",
                EDIT: "Edit",
                VIEW_DETAILS: "View details",
                COPY_QR_LINK: "Copy QR link",
                QR_LINK_COPIED: "QR link copied",
                QR_LINK_COPY_ERROR: "The QR link could not be copied",
            },
        },
        SWIPE: {
            SET_LEADING: "Comparison layer (left)",
            SET_TRAILING: "Comparison layer (right)",
            SWIPE_LEFT: "Compare left",
            SWIPE_RIGHT: "Compare right",
            CLEAR: "Clear comparison layers",
            TOGGLE_ON: "Click to compare layers",
            TOGGLE_OFF: "Click to stop comparing",
        },
        COMMENTS_MANAGER: {
            COMMENTS: "Comments",
            ADD_COMMENT: "Add comment",
            DELETE_COMMENT: "Delete comment",
            DELETE_ALL_COMMENTS: "Delete discussion",
            REPLY_TO_COMMENT: "Reply to comment",
            EMPTY_COMMENTS_TEXT: "No comments",
            INSTRUCTIONS: "Double-click to select a point on the map",
            CONFIRMATION_MESSAGE_DELETE: "Are you sure you want to delete this message?",
            CONFIRMATION_MESSAGE_DELETE_ALL: "Are you sure you want to delete the entire discussion?",
        },
        VISIBILITY_MANAGER: {
            TITLE: "Visibility settings",
            ORDER_COLUMN_HEADER: "Order",
        },
        CREATE_LAYER_MODAL: {
            HEADER: "Add new layer",
            ERROR: "A container with the selected RU scope already exists!",
        },
        HOME_BUTTON: {
            TITLE: "Home",
        },
        PARCEL_SEARCH: {
            SHOW_PARCEL_SEARCH: "Search property",
            HIDE_PARCEL_SEARCH: "Close property search",
            COUNTY_PLACEHOLDER: "Choose county",
            UAT_PLACEHOLDER: "Choose UAT",
            CADASTRAL_NUMBER_PLACEHOLDER: "Enter the land register number",
            MODAL: {
                HEADER: "Property search",
            },
            TITLE: "Property search",
            SEARCH_BTN: "Search property",
            SEARCH_HISTORY_LABEL: "Search history",
        },
        LAYER_ATTRIBUTE_SEARCH: {
            TITLE: "Search in layers",
            PLACEHOLDER: "UAT / cadastral no. / application no.",
            LOADING: "Searching...",
            NO_RESULTS: "No results found",
            SUMMARY: "{count} results in {groups} layers",
        },
        PUBLISH_LAYER_MODAL: {
            HEADER: "Publish layer",
        },
        ARCGIS_APPS_MODAL: {
            ADD_NEW_APPLICATION: "Add application",
            HEADER_EDIT: "Edit GIS application",
            HEADER_ADD: "Add GIS application",
        },
        COMPARE_LAYER_MODAL: {
            HEADER: "Compare layers",
            TEMPLATE_LAYER: "Destination",
            TEMPLATE_LAYER_LABEL: "Template layer structure",
            SOURCE_LAYER: "Source: {layer}",
            SOURCE_LAYER_LABEL: "Source layer structure",
            FORCE_PUBLISH: "Force publish",
            STATUS: {
                READY: "The layer is ready to be published.",
                NOT_READY: "The layer cannot be published because its structure does not match the template layer structure.",
            },
        },
        LAYER_DETAILS: {
            TITLE: "Layer details: {name}",
            GENERAL_INFO: "General information",
            GIS_DETAILS: "GIS details",
            ID: "ID:",
            LAYER_TYPE: "Layer type:",
            ACCESS_LEVEL: "Access level:",
            CONTAINER_ID: "Container ID:",
            CREATED_DATE: "Created date:",
            RU_SCOPE: "RU scope:",
            UAT_NAME: "UAT:",
            UAT_ID: "UAT ID:",
            OWNER_ORG_NAME: "Owner organisation:",
            OWNERSHIP_TYPE: "Ownership model:",
            FEATURE_SERVICE_URL: "Feature Service URL:",
            GIS_LAYER_ID: "GIS layer ID:",
        },
        FIELDS: {
            NAME: "Layer name",
            CONTAINER_NAME: "Container name",
            ACCESS_LEVEL: "Access level",
            OWNERSHIP_TYPE: "Update type",
            ORGANIZATION: "Organisation",
            LAYER_TYPE: "Layer type",
            CONTAINER_LAYER: "Choose a container from the Atlas",
            RU_SCOPE: "RU scope",
            UAT: "UAT",
            USE_AS_TEMPLATE: "Add structure for all UATs",
            DECISION: "HCL (by which it was adopted)",
            HAS_DECISION: "Not applicable",
            LAYER: "Choose a layer from the Atlas",
            OWNER: "Owner",
            PUBLISH_NAME: "Name",
            TEMPLATE_NAME: "Name",
            GEOMETRY_TYPE: "Geometry type",
            STATUS: "Status",
            DECISION_ID: "Choose H.C.L.",
            TEMPLATE_LAYER_ID: "Template layer",
            ARCGIS_IMPORTED_ITEM: "GIS layer identifier",
            ARCGIS_IMPORTED_ITEM_TYPE: "GIS layer type",
            TITLE: "Title",
            NOTES: "Notes",
            NOTIFICATION_ENABLED: "Notifications enabled",
            SURFACE: "Area",
            PERIMETER: "Perimeter",
            ARCGIS_IMPORTED_ITEM_IS_LINKED: "Add without duplicating",
            PRIVATE_LAYER_OWNERSHIP_TYPE: "Private layer vs. organisation layer",
            FEATURE_SERVICE_URL: "GIS feature URL",
            GIS_LAYER_ID: "GIS layer identifier",
            APP_ID: "Application ID",
            APP_NAME: "Application name",
            APP_URL: "Application URL",
            CAN_ACCESS_CITIZEN: "Visible in \"Atlas preview\" for citizens",
            CAN_ACCESS_STAFF: "Visible in \"Atlas preview\" for staff",
            APPLICATION_TYPE: "Associated application type",
            APPLICATION_TYPE_HELP_TITLE: "What is this used for?",
            APPLICATION_TYPE_HELP_TEXT: "Pinpoints of applications with these application types will be synced to this layer.",
            INTEREST_AREA_NOTIFICATIONS: "Enable interest-area notifications",
            DELETE_PINPOINT_ON_REJECTION: "Delete pinpoint on rejection",
        },
        ENUMS: {
            LAYER_TYPE: {
                CONTAINER: "Container",
                SIMPLE: "Simple",
            },
            ACCESS_LEVEL: {
                PRIVATE: "Private",
                PUBLIC: "Public",
                PROTECTED: "Protected",
            },
            OWNERSHIP_TYPE: {
                CENTRALIZED: "Centralised",
                DISTRIBUTED: "Distributed",
            },
            RU_SCOPE: {
                PUG: "PUG",
                PUZ: "PUZ",
                PUD: "PUD",
                OTHER: "Other",
            },
            STATUS: {
                OK: "OK",
                MISSING: "Missing",
                NEW: "New",
                COMPLETED: "Complete",
                PENDING: "Processing",
            },
            ARCGIS_IMPORTED_ITEM_TYPE: {
                FEATURE_SERVER: "Feature Server",
                SHAPEFILE: "Shapefile",
            },
            PRIVATE_LAYER_OWNERSHIP_TYPE: {
                PLOT_PRIVATE: "Private layer",
                PLOT_ORGANISATION: "Organisation layer",
            },
            GEOMETRY_TYPE: {
                POLYGON: "Polygon",
            },
        },
        EDIT_MODAL: {
            LAYER_NAME: "Name",
            SUBLAYER_NAME: "Urbanism zones",
            ACCESS_LEVEL: "Access level",
            OWNER: "Organisation",
            RU_SCOPE: "RU scope",
            UAT: "UAT",
            TYPE: "Type",
            STATUS: "Status",
            TEMPLATE: "Template",
            UPLOAD_BROWSE_TXT: "Choose file",
            UPLOAD_BROWSE_PLACEHOLDER: "Choose a file or drop it here...",
            DUPLICATE_LAYER_NAME: "The layer name already exists!",
            SUBLAYERS_LIST: "Sublayer list",
        },
        BUTTONS: {
            ADD_SIMPLE_LAYER: "Add simple layer",
            CLOSE_SIMPLE_LAYER: "Close simple layer form",
            UPDATE_CONTAINER: "Edit container",
        },
        PUBLISH_STATUS: {
            PUBLISHED: "Published",
            NOT_PUBLISHED: "Unpublished",
            NEW: "New",
            PENDING: "Processing",
            ERROR: "Error",
            COMPLETED: "Published",
            MESSAGE_SUCCESS: "The layer was successfully published in the Atlas",
            MESSAGE_FAILED: "The layer could not be published in the Atlas. Please try again",
            MESSAGE_CONFIRMATION: "Publishing takes a few minutes. You can keep using the application in the meantime. Check the publishing result on the layer after reloading the page.",
        },
        POPUP_TEMPLATE_INFO_FIELDS: {
            APPLICATION_STATUS: "Application status",
            APPLICATION_ID: "Application ID",
            COLOR: "Colour",
            CADASTRAL_NUMBER: "Cadastral number",
            COMBINED_ID: "Combined ID",
            APPLICATION_TYPE: "Application type",
            APPLICATION_TYPE_NAME: "Application type name",
            APPLICATION_REQUEST_NUMBER: "Application number",
            APPLICATION_NUMBER: "Permit number",
            APPLICATION_REQUEST_DATE: "Application date",
            APPLICATION_ISSUED_DATE: "Issue date",
            REAL_ESTATE_TYPE: "Site type",
            UAT_ID: "UAT ID",
            COUNTY: "County",
            PLACEHOLDER: "UAT/cadastral number/application",
        },
        FEATURE_COMMENTS: {
            TITLE: "Comments",
            BULK_DELETE: "Delete selected",
            CONFIRM_DELETE_TITLE: "Delete confirmation",
            CONFIRM_DELETE_TEXT: "Are you sure you want to delete this comment? This action cannot be undone.",
            CONFIRM_BULK_DELETE_TITLE: "Bulk delete confirmation",
            CONFIRM_BULK_DELETE_TEXT: "Are you sure you want to delete {count} comments? This action cannot be undone.",
            DELETE_SUCCESS: "Comment deleted successfully.",
            DELETE_ERROR: "Error deleting comment.",
            BULK_DELETE_SUCCESS: "{count} comments deleted successfully.",
            BULK_DELETE_ERROR: "Error deleting comments.",
            COLUMN_ID: "ID",
            COLUMN_DATE: "Created date",
            COLUMN_UPDATED_DATE: "Updated date",
            COLUMN_USER: "User",
            COLUMN_OWNER_USER_ID: "Owner",
            COLUMN_COMMENT: "Comment",
            COLUMN_LAYER_ID: "Layer ID",
            COLUMN_LAYER: "Layer",
            COLUMN_SUBLAYER_ID: "Sublayer ID",
            COLUMN_SUBLAYER: "Sublayer",
            COLUMN_FEATURE_ID: "Parcel ID",
            COLUMN_COMMENTING_USER_NAME: "User",
            ACTION_VIEW: "View",
            ACTION_REPLY: "Reply",
            ACTION_DELETE: "Delete",
            REPLY_TO: "Reply to user's comment",
            REPLY_PLACEHOLDER: "Write your reply...",
            REPLY_SUCCESS: "Reply added successfully.",
            REPLY_ERROR: "Error adding reply.",
            FILTER_LAYER: "Layer",
            FILTER_SUBLAYER: "Sublayer",
            FILTER_FEATURE_ID: "Parcel ID",
            FILTER_DATE: "Created date",
            FILTER_USER: "User",
            FILTER_COMMENT: "Comment",
            FILTER_LAYER_ID: "Layer",
            COLUMN_APPLICATION_REQUEST_NUMBER: "Application number",
            FILTER_APPLICATION_REQUEST_NUMBER: "Application number",
            VIEW_ON_MAP: "View on map",
            NO_COMMENTS: "No comments.",
            ALL_LAYERS: "All layers",
            ALL_SUBLAYERS: "All sublayers",
            VALIDATION_FIELD_REQUIRED: "The {field} field is required",
            VALIDATION_FAILED: "Comment validation failed: {errors}",
        },
        CITIZEN_FEATURES: {
            SECTION_TITLE: "My layers",
            COLLEAGUE_SECTION_TITLE: "Colleagues' layers",
            COLLEAGUE_MEMBER_FILTER_LABEL: "Team member",
            COLLEAGUE_EMPTY_STATE: "No layers published by colleagues",
            UPLOAD_BTN: "Upload layer",
            EMPTY_STATE: "You have no uploaded layers",
            FORM: {
                CREATE_TITLE: "Upload new layer",
                EDIT_TITLE: "Edit layer",
                UPLOAD_BTN: "Upload",
                FILE_PLACEHOLDER: "Select a .zip file",
                FILE_HINT: "The ZIP file must contain the files: .shp, .dbf, .prj and any other required files.",
                FILE_TYPE_ERROR: "Only ZIP files are accepted",
                REPLACE_HINT: "To replace a shapefile, delete the current version and upload a new one.",
                PROCESSING: "Processing the file... This may take a few minutes.",
            },
            FIELDS: {
                NAME: "Name",
                DESCRIPTION: "Description",
                NOTIFICATIONS_ENABLED: "Enable notifications",
                IS_APP_PREVIEW_ENABLED: "Enable preview in the application",
                FILE: "File",
            },
            STATUS: {
                NEW: "New",
                PROCESSING: "Processing",
                COMPLETED: "Completed",
                ERROR: "Error",
            },
            CONFIRM_DELETE_TITLE: "Confirm deletion",
            CONFIRM_DELETE: "Are you sure you want to delete this shapefile? This action cannot be undone.",
            SIDEBAR: {
                TAB_LABEL: "My Layer",
                SUBLAYER_SECTION_TITLE: "Sublayers",
                FEATURES_SECTION_TITLE: "Features",
                ZOOM_TO_SUBLAYER: "Zoom to sublayer",
            },
        },
        SCALE_WIDGET: {
            LABEL: "Scale 1:",
        },
        COORDINATE_CONVERSION: {
            EASTING: "Easting",
            NORTHING: "Northing",
        },
        MAP_EXPORT: {
            EXPORTED_AT: "Exported: {date}",
            SCALE: "Scale: {scale}",
        },
    },
    DECISION: {
        PAGE_HEADER: "Decisions",
        LIST: {
            TITLE: "Decisions list",
            EDIT: "Edit",
            DELETE: "Delete",
            ADD_EXTENSION: "Add extension",
        },
        FIELDS: {
            NAME: "Name",
            DESCRIPTION: "Label",
            NUMBER: "Number",
            ENTRY_DATE: "Issue date",
            EXPIRATION_DATE: "Expiry date",
            TARGET_ID: "Location",
            PURPOSE_ID: "Purpose",
            COUNTY: "County",
            DECISION_ID: "Decision",
            KEY: "Key",
        },
        PLACEHOLDERS: {
            NAME: "Name",
            TARGET_ID: "Search by location",
            PURPOSE_ID: "Search by purpose",
        },
        ADD_EDIT_FORM: {
            HEADER_ADD: "Add decision",
            HEADER_EDIT: "Edit decision",
        },
        SUCCESS: {
            ADD: "Decision added successfully.",
            UPDATE: "Decision updated successfully.",
        },
        BUTTON: {
            ADD_DECISION: "Add decision",
        },
        TOTAL_TEXT: "Total 0 decisions| Total 1 decision | Total {total} decisions",
        CARD: {
            EXTENSION_LABEL: "Extended by",
            DECISION_LABEL: "Approved by",
            PURPOSE_LABEL: "Phase",
        },
    },
    SYSTEM_SETTINGS: {
        LIST: {
            TITLE: "System settings list",
        },
        FIELDS: {
            KEY: "Feature",
            DESCRIPTION: "Description",
            DEFAULT_VALUE: "Value",
        },
        FORM: {
            EDIT_TITLE: "Edit setting",
        },
        PLACEHOLDERS: {
            KEY: "Search by key",
        },
        KEYS: {
            MAINTENANCE: "Maintenance banner",
            MAINTENANCE_TEXT: "Maintenance banner text",
            SIGN_AND_SEAL_ERROR_TIMER_HOURS: "Signing and sealing lock duration (hours)",
            CITIZEN_MAINTENANCE: "Maintenance page for citizens",
            CITIZEN_MAINTENANCE_TEXT: "Maintenance page text for citizens",
        },
    },
    DECISION_TARGET: {
        LIST: {
            TITLE: "Locations list",
        },
        ADD_BUTTON: "Add location",
        FIELDS: {
            NAME: "Name",
        },
        FORM: {
            EDIT_TITLE: "Edit location",
            ADD_TITLE: "New location",
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
        },
    },
    DECISION_PURPOSE: {
        LIST: {
            TITLE: "Purposes list",
        },
        ADD_BUTTON: "Add purpose",
        FIELDS: {
            NAME: "Name",
        },
        FORM: {
            EDIT_TITLE: "Edit purpose",
            ADD_TITLE: "New purpose",
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
        },
    },
    DOCUMENT_SERIES_TYPE: {
        TITLE: "Series types",
        LIST: {
            TITLE: "Series types list",
        },
        ADD_BUTTON: "New type",
        FIELDS: {
            NAME: "Name",
        },
        FORM: {
            EDIT_TITLE: "Edit series type",
            ADD_TITLE: "New series type",
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
        },
    },
    REGISTERS_TYPE: {
        TITLE: "Registers typologies",
        LIST: {
            TITLE: "Registers typologies list",
        },
        ADD_BUTTON: "New typology",
        FIELDS: {
            NAME: "Name",
            DESCRIPTION: "Description",
        },
        FORM: {
            EDIT_TITLE: "Edit register typology",
            ADD_TITLE: "New register typology",
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
            DESCRIPTION: "Enter description",
        },
        FIELDS_SOURCE: {
            CITIZEN: "Citizen",
            STAFF: "Staff",
            CLARIFICATION_CITIZEN: "Citizen clarifications",
            CLARIFICATION_STAFF: "Staff clarifications",
        }
    },
    REGISTERS: {
        TITLE: "Register",
        STATUS: {
            CLOSED: "Closed",
            REJECTED: "Rejected",
        },
        ACTIONS: {
            EXPORT: "Export to CSV",
        },
    },
    PAYMENT_REGISTRY: {
        TITLE: "Payments",
        LIST: {
            TITLE: "Payment history",
        },
        CALCULATE_TAX: "Calculate fee",
        ADD_PAYMENT_ORDER: "Payment order",
        FIELDS: {
            NAME: "Name",
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
        },
        GENERATE_REPORT: "Settlement report",
    },
    REAL_ESTATE_REGISTER: {
        TITLE: "Land register data",
        LIST_HEADER: "Sites",
        SAVE_SEARCH: "Save search",
        TOTAL_REAL_ESTATES: "Total sites",
        ADD_REAL_ESTATE: "Add new site",
        NO_REAL_ESTATES: "No sites found",
        NO_REAL_ESTATES_DESCRIPTION: "No sites found in the current view.",
        REAL_ESTATE_DETAILS: "Site details",
        NO_REAL_ESTATE_SELECTED: "No sites selected",
        ALL_REAL_ESTATES: "All sites",
        ADD_MORE_REAL_ESTATES: "Add more sites",
        REMOVE_CONFIRMATION: "Are you sure you want to delete this site?",
        SYNC_SUCCESS: "Sites saved successfully.",
        REMOVE_SUCCESS: "Deleted successfully.",
        PLACEHOLDER: "Site {0}",
    },
    TAX_CALCULATOR: {
        TITLE: "Fee calculator",
        FORM_SECTION_TITLE: "Document issue fee",
        SUMMARY_SECTION_TITLE: "Order summary",
        FIELDS: {
            APPLICATION_TYPE: "Document type",
            EXEMPTION: "Fee exemptions under the Fiscal Code",
            LAND_AREA: "Land area",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
        },
        CALCULATE_BUTTON: "Calculate",
        SUMMARY: {
            OTHER_TAXES_LABEL: "Other fees",
            EXEMPTION_LABEL: "Exemptions",
            VAT_LABEL: "VAT",
        },
        TOTAL: "Total to pay",
        DEFAULT_TAX_NAME: "Document",
    },
    ISSUED_DOCUMENT: {
        TITLE: "Issued documents",
        LIST: {
            TITLE: "My issued documents",
            TITLE_STAFF: "General register of issued documents",
        },
        FIELDS: {
            DOCUMENT_SERIES: "Exit number",
            DOCUMENT_NAME: "Document type",
            ISSUED_DATE: "Issue date",
            BENEFICIARY_USER: "Beneficiary",
            ISSUED_YEAR: "Year",
            ISSUER_USER_FULL_NAME: "Issued by",
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
            DOCUMENT_NAME: "Document type",
            ISSUED_YEAR: "Year",
            BENEFICIARY_USER: "Search by name",
            DOCUMENT_SERIES: "Search by number",
            ISSUER_USER_FULL_NAME: "Issued by",
        },
    },
    CONTROL: {
        PAGE_HEADER: "Inspection register",
        CURRENT_LOCATION: "Current location",
        LIST: {
            TITLE: "Inspections",
            DOCUMENT_CREATED_HEADER: "Created documents",
            NO_ASSIGNEE: "Unassigned",
        },
        BUTTON: {
            ADD_CONTROL: "New inspection",
            ADD_COMPLAIN: "Add complaint",
            ADD_LOCATION: "Add location",
            NEXT_STEP: "Next step",
            DELETE_LOCATION: "Delete location",
            CLOSE_CONTROL: "Close inspection",
            GENERATE_PVCC: "Generate PVCC",
            ADD_DOCUMENT: "Document",
            SAVE: "Save",
            PREVIEW: "Preview",
        },
        FIELDS: {
            CREATED_DATE: "Created date",
            CONTROL_ID: "Entry code",
            COMPLAIN_REF: "Complaint reference",
            CREATED_BY: "Created by",
            STATUS: "Status",
            COMPLAIN_NUMBER: "Complaint number",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            ADDRESS: "Address",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "UAT type",
            LOCALITY: "Municipality / Town / Commune",
            FIRST_NAME: "First name",
            LAST_NAME: "Last name",
            EMAIL: "Email",
            PHONE: "Phone",
            IDENTIFICATION_NUMBER: "Entry code",
            CONTROL_DATE: "Entry date",
            CADASTRAL_NUMBER: "Cadastral number",
            USER_TYPE_NAME: "Person type",
            PERSONAL_NUMERIC_CODE: "CNP",
            COUNTY: "County",
            VILLAGE: "Locality",
            SECTOR: "Sector",
            STREET: "Street",
            STREET_NUMBER: "Street number",
            POSTAL_CODE: "Postal code",
            STAIRCASE: "Staircase",
            BLOCK: "Block",
            FLOOR: "Floor",
            APARTMENT: "Apartment",
            REAL_ESTATE_TYPE: "Site type",
            AUTHORISATION_CODE: "TNA",
            SUBSIDIARY: "Branch",
            LAND_AREA: "Land area",
            OTHER_IDENTIFICATION: "Other identification",
            FILE_TYPE: "Document type",
            RESOLVED_DATE: "Resolved date",
            PASSPORT_NUMBER: "Passport number",
            CITY: "Town",
            LICENSE: "Licence",
            COMPANY_NAME: "Company",
            UNIQUE_REGISTRATION_CODE: "CUI",
            FILENAME: "Document name",
            TITLE: "Title",
            MESSAGE: "Message",
            COMMENTS: "Comments",
            ALLOCATED_DOCUMENT_SERIES: "Exit code",
            EMPLACEMENT_LOCALITY: "Locality",
            OBJECTIONS: "Offender's objections",
            ID_CARD_SERIAL: "ID card series",
            ID_CARD_NUMBER: "ID card number",
            ID_CARD_EXPIRATION_DATE: "Expiry date",
            ID_CARD_ISSUER: "Issued by",
            CONSTRUCTION_TYPE: "Property type",
            CONTROL_TYPE_NAME: "Inspection type",
            ID_CARD_RELEASE_DATE: "Issue date",
            REGISTRATION_NUMBER: "Registration number",
            PERSON_TYPE: "Acting as",
            CONTRAVENTION_NUMBER: "Ticket number",
            CONTRAVENTION_SERIES: "Ticket series",
            CONTROL_PERSON: "Select a predefined witness",
        },
        PLACEHOLDERS: {
            CONTROL_ID: "Entry code",
            COMPLAIN_REF: "Complaint reference",
            CREATED_BY: "Created by",
            STATUS: "Status",
            IDENTIFICATION_NUMBER: "Entry code",
            CADASTRAL_NUMBER: "CF number",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            COUNTY: "County",
            LOCALITY: "Locality",
            VILLAGE: "Locality",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "UAT type",
            EMPLACEMENT_LOCALITY: "Locality",
            COMMENTS: "Comments",
            MESSAGE: "Message",
            EMAIL: "Email",
        },
        ENUMS: {
            STATUS: {
                REGISTERED: "Registered",
                RESOLVED: "Resolved",
                CLOSED: "Closed",
                GENERATED: "Generated",
                ERROR: "Error",
                DRAFT: "Draft",
            },
            PERSON_TYPE: {
                INVESTITOR: "Investor",
                EXECUTANT: "Contractor",
                PROIECTANT: "Designer",
            },
        },
        LABEL: {
            CONTROL_ID: "Register number",
        },
        FORM: {
            ADD_TITLE: "Add inspection",
            EDIT_TITLE: "Inspection no. {0}",
            NEW_CONTROL: "New inspection",
        },
        PREPARATION: {
            HEADER: "Complaint details",
            COMPLAIN_LIST_TAGS: "List of complaint entry codes",
            WARNING: "To add an inspection, add a location or select one from the complaints list!",
            LIST: "Location list",
            PREVIEW_MAP: "Territorial Atlas preview",
            FORM: {
                LOCATION: "Location",
                COMPLAIN_DESCRIPTION: "As per complaint",
                MODAL_HEADER: "Complaint location details",
            },
            SEARCH_FOR: "complaints",
        },
        MODALS: {
            ADD: "Add",
            CANCEL: "Cancel",
            SAVE: "Save",
        },
        NOTIFIERS: {
            DUPLICATE_OFFENDER_PNC: "An offender with the same CNP ({pnc}) has already been added.",
            DUPLICATE_WITNESS_PNC: "A witness with the same CNP ({pnc}) has already been added.",
            DUPLICATE_OFFENDER_PASSPORT: "An offender with the same passport number ({passport}) has already been added.",
            DUPLICATE_WITNESS_PASSPORT: "A witness with the same passport number ({passport}) has already been added.",
            CADASTRAL_NUMBER_NOT_FOUND: "Sorry, the cadastral number was not found. Please try again!",
            CADASTRAL_NUMBER_ERROR: "Sorry, the synchronisation was unsuccessful. Please try again!",
            DEFAULT_ERROR_MESSAGE: "An error occurred, please try again",
            GENERATE_DOCUMENTS_WARN: "PVCC generation",
            GENERATE_DOCUMENTS_WARN_TEXT: "Please save your changes before generating the document. Once the documents have been generated, the inspection can no longer be modified. Are you sure you want to continue?",
            GENERATION_COMPLETED: "Generated successfully!",
            GENERATION_COMPLETED_TEXT: "The generated documents can be viewed in the 'Documents' section.",
            GENERATION_ERROR: "An error occurred during generation!",
            GENERATION_ERROR_TEXT: "Please try generating the documents again.",
            CLOSE_CONTROL_SUCCESS: "The inspection was closed successfully!",
            CLOSE_CONTROL_SUCCESS_TEXT: "Once closed, it can no longer be modified.",
            CLOSE_CONTROL_WARN: "Close inspection",
            CLOSE_CONTROL_WARN_TEXT: "A closed inspection can no longer be modified. Are you sure you want to continue?",
            PREVIEW_DOCUMENTS_WARN: "PVCC preview",
            PREVIEW_DOCUMENTS_WARN_TEXT: "Please save your changes before previewing the document.",
        },
        UPLOAD_DOCUMENTS_MODAL: {
            TITLE: "Add documents",
        },
        TABS: {
            CONTROL_PREPARATION: "Inspection preparation",
            DATA_COLLECTION: "Data collection",
            DOCUMENTS: "Documents",
            ACTIVITIES: "Activities",
        },
    },
    DASHBOARD: {
        APPLICATIONS_STATUS: {
            HEADER: "Application status",
            PERIOD: "Last 30 days",
            REGISTERED: "Registered",
            PROCESSING: "Processing",
            CLARIFICATIONS: "Clarifications",
        },
        TOP_USERS: {
            HEADER: "Top users",
        },
        REGISTRED_APPLICATIONS: {
            HEADER: "Registered applications",
            DESCRIPTION: "Submitted vs resolved applications",
            PERIOD: "Last 12 months",
            SUBMITTED: "Submitted",
            APPLICATIONS_COUNT: "Number of applications",
        },
        SOLVED_APPLICATIONS: {
            HEADER: "Resolved applications",
            DESCRIPTION: "Percentage of resolved applications out of all submissions",
            APPLICATIONS_TYPE_HEADER_LEGAL: "Top application types",
            APPLICATIONS_TYPE_HEADER_STAFF: "Applications by UAT",
        },
        RECENT_APPLICATIONS: {
            HEADER: "Recent applications",
            BUTTON: {
                VIEW_ALL_APPLICATIONS: "View all applications",
            },
            MISSING: "There are currently no submitted applications. Submit an application online now.",
        },
        RECENT_ISSUED_DOC: {
            HEADER: "Recently issued documents",
            BUTTON: {
                VIEW_ALL_ISSUED_DOC: "View all issued documents",
            },
        },
        PERFORMANCE: {
            HEADER: "Performance",
            ABOVE_AVG: "Above average",
            NORMAL: "Normal",
            BELLOW_AVG: "Below average",
            RESOLUTION_AVG: "Average",
            OBJECTIVE_HEADER: "Resolution deadline target",
        },
        TOTALS: {
            NEW: "Total new",
            SOLVED: "Total resolved",
            IN_OPERATION: "Total in progress",
            PERCENT: "Total percentage",
            TOP_USERS: "Top assigned staff",
        },
        TYPES: {
            STATS: "Statistics",
            NEW: "New",
            SOLVED: "Resolved",
            IN_OPERATION: "In progress",
            TOTAL_LABEL: "Total",
            DAYS: "Days",
            SOLUTION_TERM: "Resolution deadline",
            APPLICATIONS_PER_UATS: "Applications by administrative-territorial unit (UAT)",
        },
        RECENT_NOTIFICATIONS: {
            MISSING: "You have no notifications.",
        },
        FIELDS: {
            START_DATE: "Start date",
            END_DATE: "End date",
        },
        REGISTERED_APPLICATIONS: {
            HEADER: "Registered applications",
            DESCRIPTION: "New vs resolved applications",
        },
        DOMAIN_TITLE: "How can we help you today?",
        DOMAIN_SUBTITLE: "We save you the trips to the counter.",
        DOMAIN_SUBTITLE_SECOND: "You can submit and track your applications 100% digitally, simply and securely. No paperwork!",
        DOMAIN_SEARCH_APPLICATION_TYPE_PLACEHOLDER: "Search application",
        DOMAIN_NO_SEARCH_RESULTS: "No application found.",
        DOMAIN_ACCESS_BUTTON: "Open",
        DOMAINS: [
            {
                key: "urbanism",
                title: "Urbanism",
                description: "Urbanism certificates, building permits, chief architect approvals, building attestation certificates, acceptance of works, etc.",
            },
            {
                key: "administration",
                title: "Administration",
                description: "Legal matters, documents of the deliberative authority, etc.",
            },
            {
                key: "city_hall",
                title: "Town halls",
                description: "Inter-institutional correspondence between town halls and the county council",
            },
            {
                key: "approvals",
                title: "Approving authorities",
                description: "Applications to the various institutions and entities that issue approvals and agreements (ISU, natural gas, water, etc.)",
            },
            {
                key: "roads",
                title: "Transport",
                description: "County road approvals, county road investments, county public transport, signage",
            },
            {
                key: "economic",
                title: "Economic",
                description: "Funding granted by Cluj County Council, payments, human resources, corporate governance, etc.",
            },
            {
                key: "subordination",
                title: "Subordinate institutions",
                description: "Libraries, cultural institutions, hospitals and companies belonging to Cluj County Council",
            },
            {
                key: "maps",
                title: "Maps",
                description: "GIS applications, various maps, the Territorial Atlas, etc.",
            },
            {
                key: "investments",
                title: "Investments",
                description: "Ongoing contracts, public procurement, European funds, projects, etc.",
            },
            {
                key: "tourism",
                title: "Tourism",
                description: "Visiting Bánffy Castle, tourist trails, the National Tourist Information Centre, Salvamont",
            },
            {
                key: "events",
                title: "Rentals",
                description: "Space rental applications, event organisation (Cluj Arena, Agro Transilvania, etc.)",
            },
            {
                key: "sesizari",
                title: "Complaints",
                description: "County roads, information of public interest, stray dogs, irregularities",
            },
        ],
        DOMAIN_APPLICATION_TYPES_COUNT: "applications | application | applications",
    },
    URBANISM_REGULATION_ZONES: {
        LIST: {
            TITLE: "Urbanism regulations",
        },
        ADD_BUTTON: "New regulation",
        FIELDS: {
            NAME: "Name",
            KEY: "Key",
            TYPE: "Regulation purpose",
            TENANT: "UAT",
            DISPLAY_NAME: "Atlas name",
        },
        FORM: {
            EDIT_TITLE: "Edit regulation",
            ADD_TITLE: "New regulation",
        },
        ENUMS: {
            TYPE: {
                PUG: "PUG",
                PUZ: "PUZ",
                PUD: "PUD",
            },
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
            KEY: "Search by key",
            TENANT: "UAT",
            TYPE: "Regulation purpose",
        },
    },
    URBANISM_REGULATIONS: {
        TITLE: "Edit RLU categories for {0}",
        FIELDS: {
            CONTENT: "Content",
            CONTENT_HTML: "Public content - This is the content available to citizens in the Atlas",
        },
        ITEM_DETAILS: "Details",
        EMPTY_ITEMS_LABEL: "No categories attached",
        EDIT_ITEM_FORM: "Edit {0} {1}",
    },
    URBANISM_REGULATIONS_PICKER: {
        SECTION_TITLE: "Manual pre-filling of urbanism regulations",
        TITLE: "Manual pre-filling",
        COMPLETE_BUTTON: "Select regulations",
        NO_DATA_FOUND: "There are no urbanism regulations to show",
        PREVIEW_HEADER: "Preview",
        SELECT_HEADER: "Select zone",
        SELECT_PLACEHOLDER: "Search by name",
        ENTRY_NOT_DEFINED: "Not defined",
        PREVIEW_HELP_TEXT: "Select a zone from the adjacent list to preview its content",
        COULD_NOT_SUBMIT_MESSAGE: "An error occurred, check that the urbanism regulations are configured correctly.",
        FORCE_UPDATE_LABEL: "Overwrite data",
        HELP_TEXT_COMPLETED: "The document has been pre-filled based on the Territorial Atlas configuration ",
        HELP_TEXT_NOT_COMPLETED: "The document could not be pre-filled automatically because no information was found in the Territorial Atlas",
        HELP_TEXT_FORCE_UPDATE: "All fields will be overwritten with new values",
        HELP_TEXT_NOT_FORCE_UPDATE: "Only empty fields will be filled in with new values",
    },
    INTERNAL_DOCUMENTS: {
        LIST: {
            TITLE: "Documents register",
            SUB_TITLE: "Documents list",
            NO_ASSIGNEE: "Unassigned",
            DOCUMENTS_HEADER: "Documents",
            SIGN_TITLE: "Register of documents to sign",
            SIGN_DOCUMENT_BULK: "Sign documents",
            SIGN_DOCUMENT_BULK_PERSONALIZED: "Sign documents with personalised signature",
            SIGN_DOCUMENT_BULK_STS: "Sign documents with STS",
        },
        ADD_BUTTON: "Create document",
        VIEW_APPLICATION_BUTTON: "View application {number}",
        INTERNAL_DOCUMENTS_REVIEW_WARNING: "This document is internal and will not reach the citizen!",
        FIELDS: {
            APPLICATION_TYPE_NAME_COLUMN: "Document type",
            IDENTIFICATION_NUMBER: "Entry code",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Application number",
            CREATED_DATE: "Created date",
            APPLICATION_DATE: "Completion date",
            RESPONSE_DUE_IN: "Time remaining",
            FILE_TYPE: "Document type",
            ASSIGNED_TO: "Assignee",
            ALLOCATED_DOCUMENT_SERIES: "Exit code",
            STATUS: "Status",
            CADASTRAL_NUMBER: "CF number",
            APPLICATION_TYPE_NAME: "Internal document type",
            REVIEW_COMMENT: "Remarks",
            APPLICATION_NUMBER: "Application number",
            PIN: "Confirmation code",
            CREATED_BY: "Created by",
            FILENAME: "Document name",
        },
        PLACEHOLDERS: {
            BENEFICIARY: "Beneficiary",
            IDENTIFICATION_NUMBER: "Entry code",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Application number",
            APPLICATION_TYPE_NAME: "Application type",
            CREATED_BY: "Created by",
            ASSIGNED_TO: "Assignee",
            STATUS: "Status",
            CADASTRAL_NUMBER: "Cadastral number",
            ALLOCATED_DOCUMENT_SERIES: "Exit code",
        },
        FORM: {
            NEW_DOCUMENT: "New internal document",
            EDIT_TITLE: "Document {0}",
            DOCUMENT_TYPE_HEADER: "",
            CONTINUE_BTN: "Continue",
            SAVE_BTN: "Save",
            SAVE_AS_DRAFT_BUTTON: "Save as draft",
            PREVIEW_DOC: "Preview",
            FIND_APPLICATION_TITLE: "Search application",
            SEARCH_FOR: "applications",
            ADD_DOCUMENT: "Add document",
            UPLOAD_DOCUMENT_TITLE: "Add document",
            SIGN_DOCUMENT_TITLE: "Sign document",
            REFRESH_DOCUMENT: "Reload",
            SIGNATURES_PANE_EXPAND: "Show signatures panel",
            SIGNATURES_PANE_COLLAPSE: "Hide signatures panel",
        },
        TABS: {
            APPLICATION_DETAILS: "Application details",
            DOCUMENT_DETAILS: "Document details",
            DOCUMENTS: "Documents",
            ACTIVITIES: "Activities",
        },
        VIEW: {
            SAVE_AS_DRAFT_BUTTON: "Save as draft",
            REASSIGN_STAFF: "Reassign staff",
            ASSIGN_STAFF: "Assign staff",
            SEND_RESPONSE: "Send response",
            NEXT_STEP: "Next step",
            SIGN_DOCUMENT: "Sign document",
            SIGN_DOCUMENT_PERSONALIZED: "Sign document with personalised signature",
            SIGN_DOCUMENT_STS: "Sign document with STS",
            ASSIGN_STAFF_MESSAGE: "Are you sure you want to take over this document?",
            APPROVE_DOCUMENT: "Approve",
            REJECT_DOCUMENT: "Reject",
            APPROVE_DOCUMENT_MESSAGE: "Are you sure you want to approve this document?",
            REJECT_DOCUMENT_MESSAGE: "Are you sure you want to reject this document?",
            GENERATE_DOCUMENT_MESSAGE: "The document has been generated",
            GENERATE_DOCUMENT_ERROR: "The document cannot be generated",
            SIGN_DOCUMENT_ERROR: "The document cannot be signed",
            SIGN_SUCCESS: "The document has been signed",
            SEND_REVIEW: "Clarification required",
            RETURN_DOCUMENT: "Regenerate document",
            RETURN_DOCUMENT_MESSAGE: "Are you sure you want to return this document? This action is irreversible and involves regenerating the document.",
            SAVE_FAILED: "Save failed",
            GENERATE_DOCUMENT_BTN: "Finalise document",
            SEND_TO_REVIEW: "Send for consultation",
            ASSIGN_REVIEWER: "Choose consultant",
            REASSIGN_REVIEWER: "Change consultant",
            SEND_TO_REVIEW_DOCUMENT_MESSAGE: "Are you sure you want to send this document for consultation?",
        },
        ENUMS: {
            STATUS: {
                NEW: "New",
                PENDING: "Under review",
                RESOLVED: "Resolved",
                REJECTED: "Rejected",
                REJECTED_IN_PROGRESS: "Being rejected",
                APPROVED: "In progress",
                DRAFT: "Draft",
                GENERATED: "Generated",
                SIGNED: "Signed",
                SEALED: "Sealed",
                SIGN_PENDING: "Pending signature",
                CLOSED: "Completed",
                REVIEW: "In clarification",
                ERROR: "Error",
                REGISTERED: "Registered",
            },
        },
        SIGN_CONFIRMATION: {
            INVALID_PIN: "The code is not valid, please try again",
            PIN_EXPIRED: "The code has expired, please try again",
            SESSION_EXPIRED: "The session has expired, please try again",
            ERROR: "An error occurred, please try again",
            BULK_FAILED: "The following applications cannot be signed: {0}",
        },
        SIGN_STATUS: {
            TITLE: "Signing status",
            IDENTIFICATION_NUMBER: "Entry code",
            PARENT_IDENTIFICATION_NUMBER: "Application number",
            SIGNING_BY: "Being signed by",
            LAST_SIGNING_DATE: "Last signing date",
        },
        NOTIFIERS: {
            ASSIGN_SUCCESS: "The document has been successfully assigned to <strong>{name}</strong>!",
            INVALID_PROFILE_FOR_SIGNING_TITLE: "The profile data is not valid",
            INVALID_PROFILE_FOR_SIGNING_TEXT: "Please check your personal numeric code (CNP) and identity card details in the <b>My profile</b> section, which are required for online signing!",
            INVALID_PROFILE_FOR_SIGNING_BUTTON_TEXT: "Go to My profile",
            INVALID_STAFF_ENROLLMENT_TITLE: "An error occurred during the signing process",
            INVALID_STAFF_ENROLLMENT_TEXT: "Please complete your enrolment to be able to sign",
            INVALID_STAFF_ENROLLMENT_BUTTON_TEXT: "Go to My profile",
            REVIEW_RESPONSE_SUCCESS: "The consultation response has been sent successfully!",
            REJECT_VIZA_RESPONSE_SUCCESS: "The rejection has been sent successfully!",
        },
        RESPONSE_MODAL: {
            REJECT_APPLICATION_TITLE: "Rejection reason",
        },
    },
    DOCUMENT_SERIES_ALLOCATION: {
        LIST: {
            TITLE: "Reservations register",
        },
        ADD_BUTTON: "Reserve series",
        DETAILS_BUTTON: "Document series details",
        EXPORT_ALLOCATIONS_BUTTON: "Export",
        FIELDS: {
            CREATED_BY: "Reserved by",
            CREATED_DATE: "Reservation date",
            ALLOCATED_SERIES: "Series",
            TYPE_NAME: "Series type",
            FILE: "Document (PDF)",
            ISSUED_DATE: "Issue date",
            LOCATION: "Location",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            IDENTIFICATION_NUMBER: "Identification number",
            TAX_VALUE: "Fee (RON)",
            AVAILABILITY_PERIOD_MONTHS: "Validity (months)",
            EXECUTION_DURATION: "⁠Execution duration",
            EXECUTION_START_DATE: "⁠Works start date",
            EXTENSION_DATE: "Extension date",
            INVESTITION_VALUE: "Investment value",
            USE_REAL_ESTATE: "Site vs. location pin",
        },
        FORM: {
            ADD_TITLE: "Reserve series",
            EDIT_TITLE: "Edit series",
            VIEW_TITLE: "View reserved series",
            ADD_LOCATION: "Add location",
            TITLE_TOOLTIP: "To draw an outline, use the area measurement option in the map menu. To select a location on the map, double-click it.",
            LOCATION_TYPES: {
                LABEL: "Site type",
                PINPOINT: "Location",
                REAL_ESTATE_LIST: "Land register",
            },
            DEFAULT_FILE_NAME: "Document",
        },
        PLACEHOLDERS: {
            CREATED_BY: "Reserved by",
            CREATED_DATE: "Reservation date",
            ALLOCATED_SERIES: "Search by series",
            TYPE_NAME: "Series type",
        },
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "Reserved successfully",
            CREATED_SUCCESS_TEXT: "Series number <strong>{number}</strong> has been reserved successfully.",
        },
    },
    APPLICATION_ATTACHMENTS: {
        TITLE: "ATTACHMENTS",
    },
    RELATED_APPLICATION: {
        TITLE: "Related documents",
        NOT_FOUND: "The document was not found in the system.",
        NOT_FOUND_AND_UPLOAD: "The document was not found in the system. Please upload the document.",
        SEARCH_DESCRIPTION: "Select the document issued through Ghișeul Unic or enter its number",
        ISSUED_BY_SYSTEM_DESCRIPTION: "Issued by {tenant} through Ghișeul Unic",
        ISSUED_BY_DESCRIPTION: "Issued by another authority/system",
        FIELDS: {
            ALLOCATED_DOCUMENT_SERIES: "Document number",
            ISSUED_DATE: "Year of issue",
            ISSUED_BY: "Issued by",
            RELATED_DOCUMENT: "Urbanism certificate",
        },
    },
    DOCUMENT_EXPIRY: {
        INLINE: {
            PREFIX: "This document is valid for",
            SUFFIX: "from the date of issue.",
        },
        FIELDS: {
            PERIOD_VALUE: "Validity",
            PERIOD_UNIT: "Unit",
        },
        ENUMS: {
            PERIOD_UNIT: {
                ZILE: "Days",
                LUNI: "Months",
                ANI: "Years",
            },
        },
    },
    DOCUMENT_EXTENSION: {
        FIELDS: {
            ISSUE_DATE: "Valid from",
            EXTENSION_MONTHS: "Extension period (months)",
            EXTENDED_UNTIL: "Valid until",
        },
    },
    OFFENDER: {
        DETAILS: {
            HEADER: "Offender details",
            ADD_BTN: "Add offender",
            REMOVE_BTN: "Delete offender",
            PERSON: {
                HEADER: "Person type",
                INDIVIDUAL: "Natural person",
                LEGAL: "Legal entity",
            },
            CITIZENSHIP: {
                HEADER: "Citizenship",
                ROMANIAN: "Romanian citizen",
                FOREIGNER: "Foreign citizen",
            },
            FORM: {
                AUTHORIZATION_CODE: "TNA",
                SUBSIDIARY: "Subsidiary",
            },
            ADDRESS: "Address",
            CONTACT: "Contact",
        },
        SINGLE: "Total {total} offender",
        MULTIPLE: "Total {total} offenders",
        LIST_HEADER: "List of offenders",
        MODAL: {
            ADD_HEADER: "Add offender",
            EDIT_HEADER: "Edit offender",
        },
        CARD: {
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Home address",
            CONTACT: "Contact",
            CITIZENSHIP: "Citizenship",
            ADDRESS_COUNTY: "County",
            ADDRESS_STREET: "Street",
            ADDRESS_NUMBER: "no.",
            ADDRESS_STAIRCASE: "staircase",
            ADDRESS_APARTMENT: "apt.",
            PASSPORT_NUMBER: "Passport",
        },
    },
    WITNESS: {
        DETAILS: {
            HEADER: "Witness details",
            ADD_BTN: "Add witness",
            REMOVE_BTN: "Delete witness",
            CITIZENSHIP: {
                HEADER: "Citizenship",
                ROMANIAN: "Romanian citizen",
                FOREIGNER: "Foreign citizen",
            },
            PERSON: {
                HEADER: "Person type",
                INDIVIDUAL: "Natural person",
                LEGAL: "Legal entity",
            },
            FORM: {
                AUTHORIZATION_CODE: "TNA",
                SUBSIDIARY: "Subsidiary",
            },
            ADDRESS: "Address",
            CONTACT: "Contact",
            SAVE_AS_PREDEFINED: "Save as predefined witness",
        },
        SINGLE: "Total {total} witness",
        MULTIPLE: "Total {total} witnesses",
        LIST_HEADER: "List of witnesses",
        MODAL: {
            ADD_HEADER: "Add witness",
            EDIT_HEADER: "Edit witness",
        },
        CARD: {
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Home address",
            CONTACT: "Contact",
            CITIZENSHIP: "Citizenship",
            ADDRESS_COUNTY: "County",
            ADDRESS_STREET: "Street",
            ADDRESS_NUMBER: "no.",
            ADDRESS_STAIRCASE: "staircase",
            ADDRESS_APARTMENT: "apt.",
            PASSPORT_NUMBER: "Passport",
        },
    },
    REALTY: {
        FORM: {
            HEADER: "Add building",
            ADD_BTN: "Add new building",
            DUPLICATE_CADASTRAL_NUMBER: "This cadastral number has already been added",
            DUPLICATE_CADASTRAL_NUMBER_PLURAL: "Some of the selected cadastral numbers have already been added",
            DIFFERENT_AREA: "The area entered differs from the one registered at ANCPI",
            WRONG_COUNTY: "Applications can only be submitted for {county} County",
        },
        VIEW: {
            ADDRESS: "Address",
            CONTACT: "Contact",
            CADASTRAL_PLAN: "Cadastral plan",
            NO_FILES: "No files",
            FILES_LABEL: "Identification files",
        },
        SINGLE: "Total {total} building",
        MULTIPLE: "Total {total} buildings",
        LIST_HEADER: "List of buildings",
        MODAL: {
            ADD_HEADER: "Add building",
            SUMMARY_HEADER: "Full list of buildings",
        },
        CARD: {
            CADASTRAL_NUMBER: "Cadastral number",
            UAT: "UAT",
            LAND_AREA: "Area",
            COUNTY: "{county} County",
            CATEGORY: "Category code",
            MISSING_COORDINATES_MESSAGE: "Missing ANCPI coordinates",
            ADDRESS: "{street} Street, no. {no}",
        },
    },
    STAFF: {
        SECTION_TITLE: "Staff member details",
        FIELDS: {
            FUNCTION: "Position",
            ORGANISATION: "Inspection body",
            FIRST_NAME: "First name",
            LAST_NAME: "Last name",
            IDENTIFICATION_NUMBER: "Inspector ID number",
            ID_EXPIRATION_DATE: "Expiry date",
            ID_RELEASED_BY: "Issued by",
            ADDRESS: "Registered office / inspected construction site address",
        },
    },
    CONTROL_TYPE: {
        HEADER: "Choose the inspection type",
        LIST: {
            TITLE: "Inspection types",
        },
        ADD_BUTTON: "New inspection",
        FIELDS: {
            NAME: "Name",
            STATUS: "Status",
            DESCRIPTION: "Description",
            FORM: "Form interface",
            DOCUMENT_TEMPLATE: "Document template",
            DOCUMENT_SERIES_TYPE: "Document series type",
            OUTPUT_DOCUMENT_SERIES_TYPE: "PVCC document series type",
            TENANT_ID: "Organisation",
        },
        FORM: {
            EDIT_TITLE: "Edit inspection type",
            ADD_TITLE: "New inspection type",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Active",
                INACTIVE: "Inactive",
            },
        },
        PLACEHOLDERS: {
            NAME: "Search by name",
            STATUS: "Status",
        },
    },
    AC_TAX_VALIDATOR: {
        FORM: {
            HEADER: "Add building",
            MIN_VALUE: "(minimum {value})",
        },
        FIELDS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            VILLAGE: "Locality",
            STREET: "Street",
            STREET_NUMBER_SHORT: "No.",
            CONSTRUCTION_SCOPE: "For the execution of the following works",
            CONSTRUCTION_TYPE: "Construction system",
            SURFACE: "Total gross floor area of the buildings",
            CONSTRUCTION_VALUE: "Value of residential buildings (RON)",
            CONSTRUCTION_PURPOSE: "For (facility)",
            COUNTY: "County",
        },
        PLACEHOLDERS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            VILLAGE: "Locality",
            STREET: "Street",
            STREET_NUMBER_SHORT: "No.",
            CONSTRUCTION_SCOPE: "Building type",
            CONSTRUCTION_TYPE: "Construction system",
            SURFACE: "Area",
            CONSTRUCTION_VALUE: "Value",
            CONSTRUCTION_PURPOSE: "",
            COUNTY: "",
        },
        ENUMS: {
            CONSTRUCTION_SCOPE: {
                LOCUINTE: "Residential buildings and their annexes (0.5%)",
                OTHER: "Other types of works (1%)",
            },
            CONSTRUCTION_TYPE: {
                BETON: "Building with reinforced concrete frames or with exterior walls made of fired brick or any other materials resulting from a thermal and/or chemical treatment",
                LEMN: "Building with exterior walls made of wood, natural stone, unfired brick, adobe or any other materials not subjected to a thermal and/or chemical treatment",
                ANEXE: "Annex building regardless of the construction system",
            },
        },
        ERRORS: {
            CONSTRUCTION_VALUE_TOO_SMALL: "The entered value is lower than the minimum value!",
            SURFACE_WRONG_FORMAT: "The entered value is not valid",
        },
    },
    LOCALITIES: {
        LIST_HEADER: "Site details",
        FORM: {
            HEADER: "Add a new site",
            ADD_BTN: "Add new site",
            WRONG_COUNTY: "Applications can only be submitted in {county} County",
        },
        VIEW: {
            ADDRESS: "Address",
            CONTACT: "Contact",
        },
        SINGLE: "Total {total} site",
        MULTIPLE: "Total {total} sites",
        MODAL: {
            ADD_HEADER: "Add a site",
            SUMMARY_HEADER: "Full list of sites",
        },
        CARD: {
            UAT: "Municipality / Town / Commune",
            COUNTY: "{county} County",
            VILLAGE: "Locality",
            ADDRESS: "Home address",
            ADDRESS_COUNTY: "County",
            ADDRESS_STREET: "St.",
            ADDRESS_NUMBER: "no.",
            ADDRESS_STAIRCASE: "staircase",
            ADDRESS_APARTMENT: "apt.",
        },
        FIELDS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "Municipality / Town / Commune",
            VILLAGE: "Locality",
            STREET: "Street",
            STREET_NUMBER_SHORT: "No.",
            COUNTY: "County",
            STAIRCASE: "Staircase",
            BLOCK: "Block",
            FLOOR: "Floor",
            APARTMENT: "Apartment",
        },
        PLACEHOLDERS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "Municipality / Town / Commune",
            VILLAGE: "Locality",
            STREET: "Street",
            STREET_NUMBER_SHORT: "No.",
            COUNTY: "",
        },
    },
    BUILDINGS: {
        LIST_HEADER: "Building bodies",
        FORM: {
            HEADER: "Add building bodies",
            ADD_BTN: "Add new building body",
            WRONG_COUNTY: "Applications can only be submitted in {county} County",
        },
        VIEW: {
            ADDRESS: "Address",
            CONTACT: "Contact",
        },
        SINGLE: "Total {total} building body",
        MULTIPLE: "Total {total} building bodies",
        MODAL: {
            ADD_HEADER: "Add a new building body",
            SUMMARY_HEADER: "Full list of building bodies",
        },
        CARD: {
            NAME: "Building body name",
            HEIGHT: "Height of the proposed buildings",
            HEIGHT_SHORT: "Height",
            NR_LEVELS: "Number of levels",
            CHARACTERISTICS: "Construction characteristics and exterior appearance",
            CHARACTERISTICS_SHORT: "Characteristics",
            CAPACITY: "Functional capacities of the designed buildings",
            CAPACITY_SHORT: "Capacities",
        },
        FIELDS: {
            NAME: "Building body name (e.g. C1 – dwelling)",
            HEIGHT: "Height at cornice/eaves (m)",
            MAX_HEIGHT: "Height at ridge/parapet (m)",
            EXISTING_LEVELS: "Number of existing levels",
            PROPOSED_LEVELS: "Number of proposed levels",
            CONSTRUCTION_TYPE: "Construction system (description)",
            FOUNDATIONS: "Foundations (type + description)",
            ROOF_TYPE: "Roof (type + description)",
            HEATING_TYPE: "Heating system",
            ISOLATION: "Roof covering",
            EXTERIOR_FINISH: "Exterior finishes",
            EXTERIOR_WOODWORK: "Exterior joinery",
            FUNCTION: "Building use",
            CATEGORY_OF_IMPORTANCE: "Importance category",
            BUILDING_FUNCTION: "Building body type",
            BUILDING_FUNC_EXISTING: "Existing",
            BUILT_AREA: "Built area (m²)",
            DEVELOPED_AREA: "Gross floor area (m²)",
            USEFUL_AREA: "Usable area (m²)",
            LIVING_AREA: "Living area (m²)",
            PROPOSED_APARTMENTS_NO: "Number of proposed dwelling units",
            ONE_ROOM_APARTMENT_NO: "1 room",
            TWO_ROOMS_APARTMENT_NO: "2 rooms",
            THREE_ROOMS_APARTMENT_NO: "3 rooms",
            FOUR_ROOMS_APARTMENT_NO: "4 rooms",
            FIVE_ROOMS_APARTMENT_NO: "5 rooms",
            OTHER_ROOMS_APARTMENT_NO: "Other",
            OTHER_CHARACTERISTICS: "Other characteristics of the functional capacities of the proposed buildings not included in the categories above",
            CL_HOUSING_TYPES: "Types",
        },
        PLACEHOLDERS: {
            EXTERIOR_FINISH: "type: decorative plaster \ncolour: RAL ... \nmaterial:",
            EXTERIOR_WOODWORK: "type: \ncolour: RAL ... \nmaterial: Wood/PVC",
            ISOLATION: "type: ceramic tile \ncolour: RAL ... \nmaterial:",
            PROPOSED_APARTMENTS_NO: "Sum = A+B+C+D+E+F",
            ONE_ROOM_APARTMENT_NO: "A",
            TWO_ROOMS_APARTMENT_NO: "B",
            THREE_ROOMS_APARTMENT_NO: "C",
            FOUR_ROOMS_APARTMENT_NO: "D",
            FIVE_ROOMS_APARTMENT_NO: "E",
            OTHER_ROOMS_APARTMENT_NO: "F",
        },
        ENUMS: {
            BUILDING_FUNCTION: {
                EXISTING: "Existing",
                PROPOSED: "Proposed",
            },
            BUILDING_FUNC_EXISTING: {
                DISSOLVED: "Demolished",
                MAINTAINED: "Retained",
            },
            FUNCTION: {
                CL: "Residential buildings CL",
                CAS: "Administrative and socio-cultural buildings CAS",
                CIE: "Industrial and public utility buildings CIE",
                CA: "Annex buildings CA",
            },
            CATEGORY_OF_IMPORTANCE: {
                A: "Buildings of exceptional importance (A)",
                B: "Buildings of special importance (B)",
                C: "Buildings of normal importance (C)",
                D: "Buildings of reduced importance (D)",
            },
            CL_HOUSING_TYPES: {
                PERMANENT: "Permanent",
                SEASONAL: "Seasonal",
                SOCIABLE: "Social",
                FOR_RENT: "for rent",
                OF_DUTY: "service ",
                OF_NECESSITY: "emergency ",
                OF_INTERVENTION: "intervention ",
                OF_PROTOCOL: "protocol",
            },
        },
        NO_BUILDINGS: "No buildings added",
    },
    URBANISM_REGULATIONS_EDIT: {
        SYNC_UTR: "Save UTR",
        SYNC_UTR_DESC: "Save the UTR among the regulations of the organisation associated with the application",
        CHECK_EXISTING_UTR: "Check UTR symbol",
        CHECK_EXISTING_UTR_DESC: "Check whether the UTR symbol already exists among the current regulations of the selected UAT",
        UTR_ALREADY_EXISTS: "The UTR symbol '{0}' already exists in the system.",
        UTR_KEY_IS_AVAILABLE: "The UTR symbol '{0}' is available.",
        OVERWRITE_EXISTING_UTR_WARN: "A regulation already exists in the system for the key '{0}'; the current regulation will be saved with the key '{1}'. Continue?",
        LIST_HEADER: "Regulations",
        FORM: {
            HEADER: "Add UTR",
            ADD_BTN: "Add a new UTR",
            ADD_BTN_LABEL: "Or",
        },
        SINGLE: "Total {total} UTR",
        MULTIPLE: "Total {total} UTRs",
        MODAL: {
            ADD_HEADER: "Add a regulation",
            EDIT_HEADER: "Edit regulation",
            VIEW_HEADER: "View regulation",
            SUMMARY_HEADER: "List of local urbanism regulations",
            OPTIONS: {
                LABEL: "Choose an existing regulation or add a new one",
                LOAD_EXISTING_UTR: "Choose from existing regulations",
                ADD_NEW_UTR: "Add a new UTR",
            },
        },
        CARD: {
            UAT: "Municipality / Town / Commune",
            NAME: "Name",
            SYMBOL: "Symbol",
        },
        SECTION_LABEL: "SECTION {0}",
        ARTICLE_LABEL: "Article {0}",
        SECTION_1: "CHARACTER OF THE ZONE",
        SECTION_2: "FUNCTIONAL USE",
        SECTION_3: "CONDITIONS FOR THE SITING, EQUIPPING AND CONFIGURATION OF BUILDINGS",
        SECTION_4: "MAXIMUM LAND USE POSSIBILITIES",
        SECTION_EXISTING_UTR: "UTR details",
        FIELDS: {
            COUNTY: "County",
            RU_SCOPE: "RU purpose",
            RU_SCOPES: "RU purposes",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            UTR_ID: "Regulations",
            UTR: "Regulation",
            NAME: "UTR name",
            SYMBOL: "UTR symbol (e.g. Lv)",
            IS_EXISTING_UTR: "Existing UTR",
            ARTICLE_1: "General conditions",
            ARTICLE_2: "Easements",
            ARTICLE_3: "Permitted uses",
            ARTICLE_4: "Conditionally permitted uses",
            ARTICLE_5: "Prohibited uses",
            ARTICLE_6: "Parcel characteristics",
            ARTICLE_7: "Siting of buildings in relation to the street alignment",
            ARTICLE_8: "Siting of buildings in relation to the side and rear boundaries of the parcels",
            ARTICLE_9: "Siting of buildings in relation to one another on the same parcel",
            ARTICLE_10: "Access and circulation conditions",
            ARTICLE_11: "Vehicle parking",
            ARTICLE_12: "Maximum height of buildings",
            ARTICLE_13: "External appearance of buildings",
            ARTICLE_14: "Utility servicing conditions",
            ARTICLE_15: "Green spaces",
            ARTICLE_16: "Fences",
            ARTICLE_17: "Maximum land occupation percentage (POT)",
            ARTICLE_18: "Maximum land use coefficient (CUT)",
            RLU_RT: "Technical regime",
            RLU_RJ: "Legal regime",
            RLU_RE: "Economic regime",
            RLU_POT: "POT",
            RLU_CUT: "CUT ",
            RLU_RDA: "Update regime",
        },
        PLACEHOLDERS: {},
        ENUMS: {},
    },
    APPLICATION_REGISTER: {
        TITLE: "Register a document",
        EMAIL: "Email",
        PHONE: "Phone",
        EXTERNAL_DOCUMENT_NUMBER: "External document number",
        EXTERNAL_DOCUMENT_DATE: "External document date",
        CONNECTED_APPLICATIONS: "Related documents",
        DETAILS: "Details",
        DOCUMENTS: "Documents",
        FILE_UPLOAD_INFO_MESSAGE: "Upload a file by drag and drop or by clicking",
        MAX_FILE_SIZE: "Maximum 50MB",
        FILE_SIZE_ERROR: "One of the files exceeds the 50 MB limit",
        FILE_EXTENSION_ERROR: "This file type is not accepted.",
        FILE_MISSING_ERROR: "The file is required",
        REGISTER_DOCUMENT: "Register document",
        REGISTER_APPLICATION: "Register application",
        GENERATE_DOCUMENT: "Generate document",
        REGISTER_DOCUMENT_INFO_OF: "Register a new document of type:",
        REGISTER_DOCUMENT_INFO_AS: "(fields marked with * are required)",
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "The document was registered successfully!",
            CREATED_SUCCESS_TEXT: "The assigned number is <strong>{number}</strong>",
            CONFIRM_BUTTON: "Print registration number",
            CANCEL_BUTTON: "Register another document",
            CREATE_ERROR_TITLE: "An error occurred while registering the document!",
            CREATE_ERROR_TEXT: "Please check the entered data and try again.",
            UNFINISHED_CONNECTED_DOCUMENTS_TEXT: "There are related documents in progress. Are you sure you want to finalise this document?",
        },
        BENEFICIARY_REGISTER_TEXT: "Register by email or phone",
        BENEFICIARY_INVITE_TEXT: "Invite beneficiary to Ghișeul Unic",
        BENEFICIARY_INVITED_SUCCESS: "The invitation was sent successfully",
        BENEFICIARY_INVITED_ERROR: "The invitation could not be sent",
        BENEFICIARY_INVITE_EMAIL_ERROR: "The invitation could not be sent. Check that the email address is valid",
        PRINT_RECEIPT: {
            REGISTERED_TEXT: "Your document has been successfully registered in Ghișeul Unic!",
            DOCUMENT_NUMBER: "Document number",
            REGISTRATION_DATE: "Registration date",
            SCAN_FOR_STATUS: "Scan for document status",
        },
    },
    APPLICATION_CIRCULAR_MAIL: {
        TITLE: "Send circular",
        SEARCH_FOR_DEPARTMENTS: "Department",
        SEARCH_FOR_USERS: "Staff member",
        RECIPIENT: "Recipient",
        ADDITIONAL_RECIPIENT: "Additional recipient",
        SUBJECT: "Subject",
        MESSAGE: "Message",
        SEND: "Send",
        CANCEL: "Cancel",
        DEPARTMENT: "Departments",
        USERS: "Staff",
        ORGANIZATION: "Organisation",
        SEARCH_PLACEHOLDER_DEPARTMENTS: "Search by department name",
        SEARCH_PLACEHOLDER_USERS: "Search by staff member name",
        SEARCH_PLACEHOLDER_ORGANIZATIONS: "Search by organisation name",
        ATTACHMENTS: "Attachments",
        MAX_FILE_SIZE: "Maximum 50MB",
        FILE_UPLOAD_INFO_MESSAGE: "Upload a file by drag and drop or by clicking (pdf, png, jpg, jpeg)",
        FILE_UPLOAD_ERROR: "One of the files exceeds the 50 MB limit",
        FILE_MISSING_ERROR: "The file is required",
        SEND_TO_ALL_ORGANIZATIONS: "Send to the whole organisation",
        ADDITIONAL_RECIPIENT_PLACEHOLDER: "Enter the email addresses separated by commas",
        SUCCESS_TITLE: "Sent successfully",
        SUCCESS_TEXT: "The circular was sent successfully!",
        ERROR_TITLE: "Please check the entered data and try again.",
        ERROR_TEXT: "At least one recipient is required.",
    },
    PUBLIC_APPLICATION: {
        STATUS: "Document status",
        APPLICATION_NAME: "Registered document type",
        IDENTIFICATION_NUMBER: "Registration number",
        DATE: "Registration date",
        FUNCTION: "Position",
        DEPARTMENT: "Department",
        ALLOCATED_DOCUMENT_SERIES: "Completion number",
        ISSUED_DATE: "Completion date",
        NOT_FOUND: "Application not found",
        TECHNICAL_ERROR: "Technical error",
        INFO: "Once the application is completed, you can view and download the documents related to it.",
        PHONE_LABEL: "Beneficiary/applicant phone number",
        PHONE_PLACEHOLDER: "Enter the phone number",
        SEND_SMS: "Send SMS",
        PHONE_ERROR_MANDATORY: "Phone number is required",
        PHONE_ERROR: "Please enter a valid phone number",
        PHONE_ERROR_PHONE_BLOCKED: "Because you entered the wrong code 5 times, your phone number is blocked for 5 minutes",
        PHONE_ERROR_PHONE_NUMBER_NOT_ALLOCATED: "The phone number entered must belong to the applicant or to one of the beneficiaries",
        SMS_LABEL: "Validate SMS code",
        SMS_PLACEHOLDER: "Enter the code received via SMS",
        VALIDATE_CODE: "Validate code",
        CODE_ERROR_MANDATORY: "The code received via SMS is required",
        CODE_ERROR: "Invalid code",
        CODE_ERROR_PHONE_BLOCKED: "Because you entered the wrong code 5 times, your phone number is blocked for 5 minutes",
        CODE_ERROR_INVALID_CODE: "The code entered is incorrect",
        CODE_ERROR_CODE_EXPIRED: "The code has expired. Please restart the process",
        CODE_ERROR_PHONE_NUMBER_NOT_ALLOCATED: "The phone number entered must belong to the applicant or to one of the beneficiaries",
        CODE_SENT_TO: "A code has been sent to the number ",
        IF_NUMBER_WRONG: ". If the number is wrong or the code has expired.",
        RETRY: "Retry",
        APPLICATIONS_DOCUMENTS: "Documents related to the application",
        PUBLIC_DOCUMENTS: "Public documents",
        DOWNLOAD_ALL: "Download all documents",
        TIME_REMAINING: "You have {time} left to view or download the documents",
    },
    EFACTURA: {
        AUTHORIZE: "Authorise",
        SYNC_NOW: "Synchronise now",
        PROCESS_AGAIN: "Process again",
        AUTH_SUCCESS: "ANAF authorisation successful",
        AUTH_FAILED: "Authorisation failed",
        AUTH_NO_CIF: "No CIF is set for the organisation. Enter a CIF and try again.",
        TOKEN_ACTIVE_EXPIRES: "Token active, expires {expires}",
        SYNC_STATUS: {
            NOT_SYNCED: "Data not synchronised",
            LAST_SYNC: "Last synchronisation: {date}",
        },
        EXPIRES: {
            UNKNOWN: "unknown",
            EXPIRED: "expired",
            IN: "in {duration}",
            AND: "and",
            SECONDS: "{n} seconds | {n} second | {n} seconds",
            MINUTES: "{n} minutes | {n} minute | {n} minutes",
            HOURS: "{n} hours | {n} hour | {n} hours",
            DAYS: "{n} days | {n} day | {n} days",
            MONTHS: "{n} months | {n} month | {n} months",
        },
    },
    INVOICES: {
        FIELDS: {
            DETAILS: "Invoice details",
            CREATIONDATE: "Issue date",
            INVOICE_ID: "Invoice code",
            REQUEST_ID: "Request code",
            STATUS: "Status",
            NUMAR_FACTURA: "Invoice no.",
            FURNIZOR: "Supplier",
            VALOARE: "Value",
            IDENTIFICATION_NUMBER: "Reg. no.",
            APPLICATION_DATE: "Reg. date",
            REFERINTA_CONTRACT: "Contract no.",
            CIF_EMITENT: "Issuer CIF",
            ID_INCARCARE: "Upload ID",
        },
        PLACEHOLDERS: {
            NUMAR_FACTURA: "Invoice no.",
            STATUS: "Status",
            FURNIZOR: "Supplier",
            IDENTIFICATION_NUMBER: "Reg. no.",
            APPLICATION_DATE: "Reg. date",
            REFERINTA_CONTRACT: "Contract no.",
            CIF_EMITENT: "Issuer CIF",
            ID_INCARCARE: "Upload ID",
        },
        ENUMS: {
            STATUS: {
                NEW: "New",
                PROCESSED: "Processed",
                REPROCESSING: "Awaiting reprocessing",
                PROCESSING: "Processing",
                FAILED: "Error",
            },
        },
    },
    PCUEL: {
        INFO_MODAL_TEXT: "Your account will be synchronised with the PCUEL platform. This way, the documents issued in Ghișeul Unic will automatically be available on the PCUEL platform.",
        ALREADY_SYNCED_TEXT: "Your account is already synchronised with the PCUEL platform.",
        DIFFERENT_ACCOUNT_TEXT: "Your profile is already synchronised with a different PCUEL account. To change the linked account, please contact technical support.",
        CONFLICT_TEXT: "The specified PCUEL account is already linked to another profile. Please contact technical support.",
        UNLINK_ERROR: "An error occurred while unlinking the account from PCUEL",
        UNLINK_SUCCESS: "Synchronisation removed successfully",
        UNLINK_CONFIRMATION_MESSAGE: "Are you sure you want to disable synchronisation with PCUEL?",
    },
};

module.exports = { locale };
